export const PortugalLAUs = [
  [
    "PT16D",
    "010103",
    "Aguada de Cima",
    "",
    "no",
    "4013",
    "28393100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010109",
    "Fermentelos",
    "",
    "no",
    "3258",
    "8582000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010112",
    "Macinhata do Vouga",
    "",
    "no",
    "3406",
    "31954400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010119",
    "Valongo do Vouga",
    "",
    "no",
    "4877",
    "43201100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010121",
    "União das freguesias de Águeda e Borralha",
    "",
    "no",
    "13576",
    "36029300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010122",
    "União das freguesias de Barrô e Aguada de Baixo",
    "",
    "no",
    "3209",
    "10190100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010123",
    "União das freguesias de Belazaima do Chão, Castanheira do Vouga e Agadão",
    "",
    "no",
    "1611",
    "88090300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010124",
    "União das freguesias de Recardães e Espinhel",
    "",
    "no",
    "6036",
    "19917800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010125",
    "União das freguesias de Travassô e Óis da Ribeira",
    "",
    "no",
    "2305",
    "11121900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010126",
    "União das freguesias de Trofa, Segadães e Lamas do Vouga",
    "",
    "no",
    "4630",
    "16068100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010127",
    "União das freguesias do Préstimo e Macieira de Alcoba",
    "",
    "no",
    "808",
    "41726400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010202",
    "Alquerubim",
    "",
    "no",
    "2381",
    "15358600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010203",
    "Angeja",
    "",
    "no",
    "2073",
    "21251700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010204",
    "Branca",
    "",
    "no",
    "5621",
    "30288600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010206",
    "Ribeira de Fráguas",
    "",
    "no",
    "1713",
    "26745400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010209",
    "Albergaria-a-Velha e Valmaior",
    "",
    "no",
    "10568",
    "46996400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010210",
    "São João de Loure e Frossos",
    "",
    "no",
    "2896",
    "18184200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010304",
    "Avelãs de Caminho",
    "",
    "no",
    "1252",
    "6448700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010305",
    "Avelãs de Cima",
    "",
    "no",
    "2185",
    "40578000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010307",
    "Moita",
    "",
    "no",
    "2484",
    "34176100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010309",
    "Sangalhos",
    "",
    "no",
    "4068",
    "16904200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010310",
    "São Lourenço do Bairro",
    "",
    "no",
    "2414",
    "15383100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010312",
    "Vila Nova de Monsarros",
    "",
    "no",
    "1713",
    "23720400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010313",
    "Vilarinho do Bairro",
    "",
    "no",
    "2764",
    "25563300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010316",
    "União das freguesias de Amoreira da Gândara, Paredes do Bairro e Ancas",
    "",
    "no",
    "2675",
    "22064200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010317",
    "União das freguesias de Arcos e Mogofores",
    "",
    "no",
    "6331",
    "14393000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010318",
    "União das freguesias de Tamengos, Aguim e Óis do Bairro",
    "",
    "no",
    "3264",
    "17403900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010402",
    "Alvarenga",
    "",
    "no",
    "1223",
    "38766000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010407",
    "Chave",
    "",
    "no",
    "1253",
    "10905300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010409",
    "Escariz",
    "",
    "no",
    "2222",
    "17984600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010411",
    "Fermedo",
    "",
    "no",
    "1340",
    "11105300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010413",
    "Mansores",
    "",
    "no",
    "1081",
    "14075400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010414",
    "Moldes",
    "",
    "no",
    "1257",
    "28005100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010415",
    "Rossas",
    "",
    "no",
    "1599",
    "11111800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010416",
    "Santa Eulália",
    "",
    "no",
    "2253",
    "23047600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010417",
    "São Miguel do Mato",
    "",
    "no",
    "598",
    "17104700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010418",
    "Tropeço",
    "",
    "no",
    "1150",
    "17838700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010419",
    "Urrô",
    "",
    "no",
    "1029",
    "10787500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010420",
    "Várzea",
    "",
    "no",
    "540",
    "1791000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010421",
    "União das freguesias de Arouca e Burgo",
    "",
    "no",
    "5178",
    "15244100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010422",
    "União das freguesias de Cabreiros e Albergaria da Serra",
    "",
    "no",
    "231",
    "31231600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010423",
    "União das freguesias de Canelas e Espiunca",
    "",
    "no",
    "1183",
    "35729400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010424",
    "União das freguesias de Covelo de Paivó e Janarde",
    "",
    "no",
    "222",
    "44377000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010501",
    "Aradas",
    "",
    "no",
    "9157",
    "8927700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "010502",
    "Cacia",
    "",
    "no",
    "7354",
    "35754900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "010505",
    "Esgueira",
    "",
    "no",
    "13431",
    "17148500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010508",
    "Oliveirinha",
    "",
    "no",
    "4817",
    "12070700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010510",
    "São Bernardo",
    "",
    "no",
    "4960",
    "3935600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010511",
    "São Jacinto",
    "",
    "no",
    "993",
    "13837100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "010513",
    "Santa Joana",
    "",
    "no",
    "8094",
    "5845500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010515",
    "Eixo e Eirol",
    "",
    "no",
    "6324",
    "22415600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010516",
    "Requeixo, Nossa Senhora de Fátima e Nariz",
    "",
    "no",
    "4564",
    "32319500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010517",
    "União das freguesias de Glória e Vera Cruz",
    "",
    "no",
    "18756",
    "45320700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11C",
    "010602",
    "Fornos",
    "",
    "no",
    "1439",
    "4110100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "010606",
    "Real",
    "",
    "no",
    "1300",
    "33106500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "010607",
    "Santa Maria de Sardoura",
    "",
    "no",
    "2538",
    "10063300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "010608",
    "São Martinho de Sardoura",
    "",
    "no",
    "1931",
    "4312200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "010610",
    "União das freguesias de Raiva, Pedorido e Paraíso",
    "",
    "no",
    "4694",
    "49372800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "010611",
    "União das freguesias de Sobrado e Bairros",
    "",
    "no",
    "4831",
    "14040400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010702",
    "Espinho",
    "",
    "no",
    "9832",
    "1766200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010704",
    "Paramos",
    "",
    "no",
    "3515",
    "5871700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010705",
    "Silvalde",
    "",
    "no",
    "6673",
    "5454800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010706",
    "União das freguesias de Anta e Guetim",
    "",
    "no",
    "11766",
    "7964000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "010801",
    "Avanca",
    "",
    "no",
    "6189",
    "21067300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010805",
    "Pardilhó",
    "",
    "no",
    "4176",
    "15702500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "010806",
    "Salreu",
    "",
    "no",
    "3815",
    "16539100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010808",
    "União das freguesias de Beduído e Veiros",
    "",
    "no",
    "10047",
    "31842500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "010809",
    "União das freguesias de Canelas e Fermelã",
    "",
    "no",
    "2770",
    "23021900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010901",
    "Argoncilhe",
    "",
    "no",
    "8420",
    "8213400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010902",
    "Arrifana",
    "",
    "no",
    "6551",
    "5294700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010904",
    "Escapães",
    "",
    "no",
    "3309",
    "4304000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010907",
    "Fiães",
    "",
    "no",
    "7991",
    "6378200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010908",
    "Fornos",
    "",
    "no",
    "3397",
    "3136400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010913",
    "Lourosa",
    "",
    "no",
    "8636",
    "5774000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010914",
    "Milheirós de Poiares",
    "",
    "no",
    "3791",
    "7865100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010916",
    "Mozelos",
    "",
    "no",
    "7142",
    "5809400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010917",
    "Nogueira da Regedoura",
    "",
    "no",
    "5790",
    "5099100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010918",
    "São Paio de Oleiros",
    "",
    "no",
    "4069",
    "3905300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010919",
    "Paços de Brandão",
    "",
    "no",
    "4867",
    "3556200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010921",
    "Rio Meão",
    "",
    "no",
    "4931",
    "6683300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010922",
    "Romariz",
    "",
    "no",
    "3023",
    "11079900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010924",
    "Sanguedo",
    "",
    "no",
    "3600",
    "4565600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010925",
    "Santa Maria de Lamas",
    "",
    "no",
    "5073",
    "3754500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010926",
    "São João de Ver",
    "",
    "no",
    "10579",
    "15374500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010932",
    "União das freguesias de Caldas de São Jorge e Pigeiros",
    "",
    "no",
    "3897",
    "10640000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010933",
    "União das freguesias de Canedo, Vale e Vila Maior",
    "",
    "no",
    "9455",
    "43696000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010934",
    "União das freguesias de Lobão, Gião, Louredo e Guisande",
    "",
    "no",
    "9860",
    "23582200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "010935",
    "União das freguesias de Santa Maria da Feira, Travanca, Sanfins e Espargo",
    "",
    "no",
    "18194",
    "23362100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "010936",
    "União das freguesias de São Miguel do Souto e Mosteirô",
    "",
    "no",
    "6734",
    "13802600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011005",
    "Gafanha da Encarnação",
    "",
    "no",
    "5362",
    "10982800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011006",
    "Gafanha da Nazaré",
    "",
    "no",
    "15240",
    "16435900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011007",
    "Gafanha do Carmo",
    "",
    "no",
    "1526",
    "7054900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011008",
    "Ílhavo (São Salvador)",
    "",
    "no",
    "16470",
    "39002000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "011102",
    "Barcouço",
    "",
    "no",
    "2152",
    "21308900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "011103",
    "Casal Comba",
    "",
    "no",
    "3183",
    "18804200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "011104",
    "Luso",
    "",
    "no",
    "2593",
    "16869400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "011106",
    "Pampilhosa",
    "",
    "no",
    "4098",
    "13603400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "011107",
    "Vacariça",
    "",
    "no",
    "1945",
    "18666700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "011109",
    "União das freguesias da Mealhada, Ventosa do Bairro e Antes",
    "",
    "no",
    "6457",
    "21404000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011201",
    "Bunheiro",
    "",
    "no",
    "2682",
    "24792400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011202",
    "Monte",
    "",
    "no",
    "1459",
    "2285700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011203",
    "Murtosa",
    "",
    "no",
    "3699",
    "14549300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011204",
    "Torreira",
    "",
    "no",
    "2745",
    "31460400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "011301",
    "Carregosa",
    "",
    "no",
    "3419",
    "11817300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011302",
    "Cesar",
    "",
    "no",
    "3166",
    "5427700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011303",
    "Fajões",
    "",
    "no",
    "3087",
    "8122200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011304",
    "Loureiro",
    "",
    "no",
    "3531",
    "17133500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011305",
    "Macieira de Sarnes",
    "",
    "no",
    "1925",
    "3868900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011310",
    "Ossela",
    "",
    "no",
    "2208",
    "17886000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011315",
    "São Martinho da Gândara",
    "",
    "no",
    "1985",
    "8131300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011318",
    "São Roque",
    "",
    "no",
    "5228",
    "7052900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011319",
    "Vila de Cucujães",
    "",
    "no",
    "10705",
    "10421100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011320",
    "União das freguesias de Nogueira do Cravo e Pindelo",
    "",
    "no",
    "5390",
    "12542200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011321",
    "União das freguesias de Oliveira de Azeméis, Santiago de Riba-Ul, Ul, Macinhata da Seixa e Madail",
    "",
    "no",
    "20760",
    "25944500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011322",
    "União das freguesias de Pinheiro da Bemposta, Travanca e Palmaz",
    "",
    "no",
    "7207",
    "32756400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011403",
    "Oiã",
    "",
    "no",
    "7722",
    "26322400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011404",
    "Oliveira do Bairro",
    "",
    "no",
    "6250",
    "22553300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011405",
    "Palhaça",
    "",
    "no",
    "2627",
    "10025600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011407",
    "União das freguesias de Bustos, Troviscal e Mamarrosa",
    "",
    "no",
    "6429",
    "28418600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011502",
    "Cortegaça",
    "",
    "no",
    "3837",
    "9228600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011503",
    "Esmoriz",
    "",
    "no",
    "11448",
    "9167300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011504",
    "Maceda",
    "",
    "no",
    "3521",
    "16079600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011507",
    "Válega",
    "",
    "no",
    "6827",
    "26830300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011509",
    "União das freguesias de Ovar, São João, Arada e São Vicente de Pereira Jusã",
    "",
    "no",
    "29765",
    "86396700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "011601",
    "São João da Madeira",
    "",
    "no",
    "21713",
    "7943000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011702",
    "Couto de Esteves",
    "",
    "no",
    "890",
    "16423900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011704",
    "Pessegueiro do Vouga",
    "",
    "no",
    "1852",
    "15854800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011705",
    "Rocas do Vouga",
    "",
    "no",
    "1778",
    "14818200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011706",
    "Sever do Vouga",
    "",
    "no",
    "2777",
    "11580900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011708",
    "Talhadas",
    "",
    "no",
    "1187",
    "28641300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011710",
    "União das freguesias de Cedrim e Paradela",
    "",
    "no",
    "1554",
    "18370000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011711",
    "União das freguesias de Silva Escura e Dornelas",
    "",
    "no",
    "2318",
    "24186500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011801",
    "Calvão",
    "",
    "no",
    "2014",
    "14844100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011804",
    "Gafanha da Boa Hora",
    "",
    "no",
    "2625",
    "37215500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011805",
    "Ouca",
    "",
    "no",
    "1805",
    "16271900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011807",
    "Sosa",
    "",
    "no",
    "3069",
    "21693300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011810",
    "Santo André de Vagos",
    "",
    "no",
    "2033",
    "12694600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16D",
    "011812",
    "União das freguesias de Fonte de Angeão e Covão do Lobo",
    "",
    "no",
    "2165",
    "17552500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011813",
    "União das freguesias de Ponte de Vagos e Santa Catarina",
    "",
    "no",
    "2781",
    "13321300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16D",
    "011814",
    "União das freguesias de Vagos e Santo António",
    "",
    "no",
    "6359",
    "31321900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "011901",
    "Arões",
    "",
    "no",
    "1459",
    "40334700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011902",
    "São Pedro de Castelões",
    "",
    "no",
    "7181",
    "21099100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011903",
    "Cepelos",
    "",
    "no",
    "1313",
    "18928300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011905",
    "Junqueira",
    "",
    "no",
    "1067",
    "18038300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011906",
    "Macieira de Cambra",
    "",
    "no",
    "4747",
    "18053000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011907",
    "Roge",
    "",
    "no",
    "1752",
    "17595800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "011910",
    "União das freguesias de Vila Chã, Codal e Vila Cova de Perrinho",
    "",
    "no",
    "5345",
    "13285500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020102",
    "Ervidel",
    "",
    "no",
    "1005",
    "38850800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020103",
    "Messejana",
    "",
    "no",
    "892",
    "113765600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020104",
    "São João de Negrilhos",
    "",
    "no",
    "1482",
    "77018400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020106",
    "União das freguesias de Aljustrel e Rio de Moinhos",
    "",
    "no",
    "5878",
    "228839300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020203",
    "Rosário",
    "",
    "no",
    "608",
    "60688800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020205",
    "Santa Cruz",
    "",
    "no",
    "651",
    "123380500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020206",
    "São Barnabé",
    "",
    "no",
    "531",
    "141673500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020208",
    "Aldeia dos Fernandes",
    "",
    "no",
    "536",
    "21258000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020209",
    "União das freguesias de Almodôvar e Graça dos Padrões",
    "",
    "no",
    "4168",
    "257065700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020210",
    "União das freguesias de Santa Clara-a-Nova e Gomes Aires",
    "",
    "no",
    "955",
    "173813700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020301",
    "Alvito",
    "",
    "no",
    "1259",
    "136523400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020302",
    "Vila Nova da Baronia",
    "",
    "no",
    "1245",
    "128329800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020401",
    "Barrancos",
    "",
    "no",
    "1834",
    "168417300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020502",
    "Baleizão",
    "",
    "no",
    "902",
    "139742900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020503",
    "Beringel",
    "",
    "no",
    "1362",
    "16049600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020504",
    "Cabeça Gorda",
    "",
    "no",
    "1386",
    "78156800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020506",
    "Nossa Senhora das Neves",
    "",
    "no",
    "1747",
    "53143800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020510",
    "Santa Clara de Louredo",
    "",
    "no",
    "864",
    "71884800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020516",
    "São Matias",
    "",
    "no",
    "569",
    "70227700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020519",
    "União das freguesias de Albernoa e Trindade",
    "",
    "no",
    "1032",
    "209385000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020520",
    "União das freguesias de Beja (Salvador e Santa Maria da Feira)",
    "",
    "no",
    "11133",
    "22509100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020521",
    "União das freguesias de Beja (Santiago Maior e São João Baptista)",
    "",
    "no",
    "14015",
    "51265500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020522",
    "União das freguesias de Salvada e Quintos",
    "",
    "no",
    "1352",
    "199719400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020523",
    "União das freguesias de Santa Vitória e Mombeja",
    "",
    "no",
    "920",
    "166131500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020524",
    "União das freguesias de Trigaches e São Brissos",
    "",
    "no",
    "572",
    "68259300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020603",
    "Entradas",
    "",
    "no",
    "649",
    "76229000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020604",
    "Santa Bárbara de Padrões",
    "",
    "no",
    "943",
    "66314700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020605",
    "São Marcos da Ataboeira",
    "",
    "no",
    "338",
    "104130700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020606",
    "União das freguesias de Castro Verde e Casével",
    "",
    "no",
    "5346",
    "322767800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020701",
    "Cuba",
    "",
    "no",
    "3306",
    "70092100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020702",
    "Faro do Alentejo",
    "",
    "no",
    "591",
    "44675100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020703",
    "Vila Alva",
    "",
    "no",
    "514",
    "37197700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020704",
    "Vila Ruiva",
    "",
    "no",
    "467",
    "20122300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020803",
    "Figueira dos Cavaleiros",
    "",
    "no",
    "1346",
    "154201900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020804",
    "Odivelas",
    "",
    "no",
    "542",
    "110051300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020807",
    "União das freguesias de Alfundão e Peroguarda",
    "",
    "no",
    "1227",
    "88332000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020808",
    "União das freguesias de Ferreira do Alentejo e Canhestros",
    "",
    "no",
    "5140",
    "295621600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020901",
    "Alcaria Ruiva",
    "",
    "no",
    "849",
    "216668700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020902",
    "Corte do Pinto",
    "",
    "no",
    "857",
    "71459500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020903",
    "Espírito Santo",
    "",
    "no",
    "335",
    "135921500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020904",
    "Mértola",
    "",
    "no",
    "2824",
    "322770300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020905",
    "Santana de Cambas",
    "",
    "no",
    "797",
    "166721100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020906",
    "São João dos Caldeireiros",
    "",
    "no",
    "567",
    "103954500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "020910",
    "União das freguesias de São Miguel do Pinheiro, São Pedro de Solis e São Sebastião dos Carros",
    "",
    "no",
    "1045",
    "275377700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021001",
    "Amareleja",
    "",
    "no",
    "2564",
    "108557200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021002",
    "Póvoa de São Miguel",
    "",
    "no",
    "888",
    "187079300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021008",
    "Sobral da Adiça",
    "",
    "no",
    "1013",
    "138195800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021009",
    "União das freguesias de Moura (Santo Agostinho e São João Baptista) e Santo Amador",
    "",
    "no",
    "8831",
    "287418300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021010",
    "União das freguesias de Safara e Santo Aleixo da Restauração",
    "",
    "no",
    "1871",
    "237204900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021102",
    "Relíquias",
    "",
    "no",
    "931",
    "120082700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021103",
    "Sabóia",
    "",
    "no",
    "1152",
    "155424100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021106",
    "São Luís",
    "",
    "no",
    "1989",
    "146646900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021107",
    "São Martinho das Amoreiras",
    "",
    "no",
    "1006",
    "144171600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021111",
    "Vila Nova de Milfontes",
    "",
    "no",
    "5031",
    "76481000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "021115",
    "Luzianes-Gare",
    "",
    "no",
    "429",
    "94356000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021116",
    "Boavista dos Pinheiros",
    "",
    "no",
    "1633",
    "37845300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021117",
    "Longueira/Almograve",
    "",
    "no",
    "1356",
    "91690600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "021118",
    "Colos",
    "",
    "no",
    "1061",
    "109769200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021119",
    "Santa Clara-a-Velha",
    "",
    "no",
    "873",
    "163673500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021120",
    "São Salvador e Santa Maria",
    "",
    "no",
    "3119",
    "120997400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "021121",
    "São Teotónio",
    "",
    "no",
    "6439",
    "347254600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "021122",
    "Vale de Santiago",
    "",
    "no",
    "1047",
    "112208700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021203",
    "Ourique",
    "",
    "no",
    "2874",
    "249695400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021206",
    "Santana da Serra",
    "",
    "no",
    "850",
    "190942300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021207",
    "União das freguesias de Garvão e Santa Luzia",
    "",
    "no",
    "1083",
    "79146100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021208",
    "União das freguesias de Panoias e Conceição",
    "",
    "no",
    "582",
    "143529800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021302",
    "Brinches",
    "",
    "no",
    "1039",
    "92401800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021303",
    "Pias",
    "",
    "no",
    "2852",
    "163861600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021307",
    "Vila Verde de Ficalho",
    "",
    "no",
    "1459",
    "105394400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021308",
    "União das freguesias de Serpa (Salvador e Santa Maria)",
    "",
    "no",
    "6233",
    "443727800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021309",
    "União das freguesias de Vila Nova de São Bento e Vale de Vargo",
    "",
    "no",
    "4040",
    "300247800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021401",
    "Pedrógão",
    "",
    "no",
    "1151",
    "125690500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021402",
    "Selmes",
    "",
    "no",
    "894",
    "137469000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021403",
    "Vidigueira",
    "",
    "no",
    "2959",
    "27829900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT184",
    "021404",
    "Vila de Frades",
    "",
    "no",
    "928",
    "25621400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030102",
    "Barreiros",
    "",
    "no",
    "760",
    "2986500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030104",
    "Bico",
    "",
    "no",
    "777",
    "2293600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030105",
    "Caires",
    "",
    "no",
    "868",
    "4715500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030107",
    "Carrazedo",
    "",
    "no",
    "732",
    "2707700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030108",
    "Dornelas",
    "",
    "no",
    "508",
    "3386200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030111",
    "Fiscal",
    "",
    "no",
    "718",
    "3896900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030112",
    "Goães",
    "",
    "no",
    "557",
    "3027800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030113",
    "Lago",
    "",
    "no",
    "1910",
    "3990100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030118",
    "Rendufe",
    "",
    "no",
    "1124",
    "3062600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030119",
    "Bouro (Santa Maria)",
    "",
    "no",
    "760",
    "6919700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030120",
    "Bouro (Santa Marta)",
    "",
    "no",
    "490",
    "9499300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030125",
    "União das freguesias de Amares e Figueiredo",
    "",
    "no",
    "2654",
    "4560700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030126",
    "União das freguesias de Caldelas, Sequeiros e Paranhos",
    "",
    "no",
    "1187",
    "11372700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030127",
    "União das freguesias de Ferreiros, Prozelo e Besteiros",
    "",
    "no",
    "4573",
    "7337600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030128",
    "União das freguesias de Torre e Portela",
    "",
    "no",
    "626",
    "3594700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030129",
    "União das freguesias de Vilela, Seramil e Paredes Secas",
    "",
    "no",
    "645",
    "8602400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030201",
    "Abade de Neiva",
    "",
    "no",
    "2024",
    "7503600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030202",
    "Aborim",
    "",
    "no",
    "891",
    "6181200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030203",
    "Adães",
    "",
    "no",
    "790",
    "2690300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030205",
    "Airó",
    "",
    "no",
    "913",
    "3023400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030206",
    "Aldreu",
    "",
    "no",
    "904",
    "4796700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030208",
    "Alvelos",
    "",
    "no",
    "2145",
    "3381700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030209",
    "Arcozelo",
    "",
    "no",
    "12840",
    "3436800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030210",
    "Areias",
    "",
    "no",
    "1014",
    "2511400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030212",
    "Balugães",
    "",
    "no",
    "841",
    "2726100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030213",
    "Barcelinhos",
    "",
    "no",
    "1781",
    "2757000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030215",
    "Barqueiros",
    "",
    "no",
    "1957",
    "8066400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030216",
    "Cambeses",
    "",
    "no",
    "1300",
    "3311800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030218",
    "Carapeços",
    "",
    "no",
    "2277",
    "8116000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030220",
    "Carvalhal",
    "",
    "no",
    "1391",
    "2579800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030221",
    "Carvalhas",
    "",
    "no",
    "691",
    "3494500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030224",
    "Cossourado",
    "",
    "no",
    "825",
    "6441200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030228",
    "Cristelo",
    "",
    "no",
    "1875",
    "7714800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030234",
    "Fornelos",
    "",
    "no",
    "803",
    "4291800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030235",
    "Fragoso",
    "",
    "no",
    "2193",
    "12588300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030237",
    "Gilmonde",
    "",
    "no",
    "1516",
    "5577700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030242",
    "Lama",
    "",
    "no",
    "1271",
    "3267200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030243",
    "Lijó",
    "",
    "no",
    "2306",
    "4419200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030244",
    "Macieira de Rates",
    "",
    "no",
    "2083",
    "7849500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030245",
    "Manhente",
    "",
    "no",
    "1703",
    "3910800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030247",
    "Martim",
    "",
    "no",
    "2375",
    "5317000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030252",
    "Moure",
    "",
    "no",
    "925",
    "2543100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030254",
    "Oliveira",
    "",
    "no",
    "1004",
    "5457700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030255",
    "Palme",
    "",
    "no",
    "1073",
    "8314500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030256",
    "Panque",
    "",
    "no",
    "680",
    "6289500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030257",
    "Paradela",
    "",
    "no",
    "850",
    "8358500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030259",
    "Pereira",
    "",
    "no",
    "1318",
    "3848100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030260",
    "Perelhal",
    "",
    "no",
    "1749",
    "6803100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030261",
    "Pousa",
    "",
    "no",
    "2272",
    "6631600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030263",
    "Remelhe",
    "",
    "no",
    "1309",
    "6124100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030264",
    "Roriz",
    "",
    "no",
    "2152",
    "6533900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030265",
    "Rio Covo (Santa Eugénia)",
    "",
    "no",
    "1483",
    "3134100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030268",
    "Galegos (Santa Maria)",
    "",
    "no",
    "2987",
    "4588200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030272",
    "Galegos (São Martinho)",
    "",
    "no",
    "1930",
    "3122400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030277",
    "Tamel (São Veríssimo)",
    "",
    "no",
    "3025",
    "3325600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030279",
    "Silva",
    "",
    "no",
    "913",
    "2179600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030282",
    "Ucha",
    "",
    "no",
    "1420",
    "4269400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030283",
    "Várzea",
    "",
    "no",
    "1904",
    "2952100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030287",
    "Vila Seca",
    "",
    "no",
    "1197",
    "4342500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030290",
    "União das freguesias de Alheira e Igreja Nova",
    "",
    "no",
    "1456",
    "10171200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030291",
    "União das freguesias de Alvito (São Pedro e São Martinho) e Couto",
    "",
    "no",
    "1438",
    "8543800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030292",
    "União das freguesias de Areias de Vilar e Encourados",
    "",
    "no",
    "1879",
    "10167700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030293",
    "União das freguesias de Barcelos, Vila Boa e Vila Frescainha (São Martinho e São Pedro)",
    "",
    "no",
    "11108",
    "9299100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030294",
    "União das freguesias de Campo e Tamel (São Pedro Fins)",
    "",
    "no",
    "1521",
    "4806000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030295",
    "União das freguesias de Carreira e Fonte Coberta",
    "",
    "no",
    "2033",
    "5288400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030296",
    "União das freguesias de Chorente, Góios, Courel, Pedra Furada e Gueral",
    "",
    "no",
    "2568",
    "16091700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030297",
    "União das freguesias de Creixomil e Mariz",
    "",
    "no",
    "1208",
    "6976700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030298",
    "União das freguesias de Durrães e Tregosa",
    "",
    "no",
    "1409",
    "6728500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030299",
    "União das freguesias de Gamil e Midões",
    "",
    "no",
    "1386",
    "5835500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FA",
    "União das freguesias de Milhazes, Vilar de Figos e Faria",
    "",
    "no",
    "2066",
    "12137600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "0302FB",
    "União das freguesias de Negreiros e Chavão",
    "",
    "no",
    "2364",
    "6964300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FC",
    "União das freguesias de Quintiães e Aguiar",
    "",
    "no",
    "1190",
    "7364500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FD",
    "União das freguesias de Sequeade e Bastuço (São João e Santo Estevão)",
    "",
    "no",
    "1916",
    "6339800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FE",
    "União das freguesias de Silveiros e Rio Covo (Santa Eulália)",
    "",
    "no",
    "2151",
    "8234600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FF",
    "União das freguesias de Tamel (Santa Leocádia) e Vilar do Monte",
    "",
    "no",
    "1420",
    "11056700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FG",
    "União das freguesias de Viatodos, Grimancelos, Minhotães e Monte de Fralães",
    "",
    "no",
    "3814",
    "12395300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "0302FH",
    "União das freguesias de Vila Cova e Feitos",
    "",
    "no",
    "2564",
    "15727800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030301",
    "Adaúfe",
    "",
    "no",
    "3711",
    "10805100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030312",
    "Espinho",
    "",
    "no",
    "1181",
    "4475800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030313",
    "Esporões",
    "",
    "no",
    "1709",
    "4740700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030315",
    "Figueiredo",
    "",
    "no",
    "1198",
    "2026700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030319",
    "Gualtar",
    "",
    "no",
    "5286",
    "2735800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030322",
    "Lamas",
    "",
    "no",
    "842",
    "1253500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030325",
    "Mire de Tibães",
    "",
    "no",
    "2437",
    "4357100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030330",
    "Padim da Graça",
    "",
    "no",
    "1521",
    "3393700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030331",
    "Palmeira",
    "",
    "no",
    "5468",
    "8879600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030334",
    "Pedralva",
    "",
    "no",
    "1110",
    "8068200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030336",
    "Priscos",
    "",
    "no",
    "1341",
    "3649100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030338",
    "Ruilhe",
    "",
    "no",
    "1142",
    "2203500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030349",
    "Braga (São Vicente)",
    "",
    "no",
    "13236",
    "2550400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030351",
    "Braga (São Vítor)",
    "",
    "no",
    "29642",
    "4083800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030354",
    "Sequeira",
    "",
    "no",
    "1811",
    "4350500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030355",
    "Sobreposta",
    "",
    "no",
    "1301",
    "5980300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030356",
    "Tadim",
    "",
    "no",
    "1143",
    "2680400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030357",
    "Tebosa",
    "",
    "no",
    "1129",
    "2586200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030363",
    "União das freguesias de Arentim e Cunha",
    "",
    "no",
    "1530",
    "5720500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030364",
    "União das freguesias de Braga (Maximinos, Sé e Cividade)",
    "",
    "no",
    "14572",
    "2566900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030365",
    "União das freguesias de Braga (São José de São Lázaro e São João do Souto)",
    "",
    "no",
    "14301",
    "2431700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030366",
    "União das freguesias de Cabreiros e Passos (São Julião)",
    "",
    "no",
    "2165",
    "4790500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030367",
    "União das freguesias de Celeirós, Aveleda e Vimieiro",
    "",
    "no",
    "6671",
    "7569000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030368",
    "União das freguesias de Crespos e Pousada",
    "",
    "no",
    "1347",
    "7338200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030369",
    "União das freguesias de Escudeiros e Penso (Santo Estêvão e São Vicente)",
    "",
    "no",
    "1864",
    "8036600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030370",
    "União das freguesias de Este (São Pedro e São Mamede)",
    "",
    "no",
    "3837",
    "9794900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030371",
    "União das freguesias de Ferreiros e Gondizalves",
    "",
    "no",
    "9148",
    "4256200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030372",
    "União das freguesias de Guisande e Oliveira (São Pedro)",
    "",
    "no",
    "1053",
    "4709400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030373",
    "União das freguesias de Lomar e Arcos",
    "",
    "no",
    "6805",
    "4012700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030374",
    "União das freguesias de Merelim (São Paio), Panoias e Parada de Tibães",
    "",
    "no",
    "5363",
    "5359800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030375",
    "União das freguesias de Merelim (São Pedro) e Frossos",
    "",
    "no",
    "3726",
    "3148500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030376",
    "União das freguesias de Morreira e Trandeiras",
    "",
    "no",
    "1447",
    "4542900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030377",
    "União das freguesias de Nogueira, Fraião e Lamaçães",
    "",
    "no",
    "13054",
    "8395100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030378",
    "União das freguesias de Nogueiró e Tenões",
    "",
    "no",
    "5129",
    "4427300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030379",
    "União das freguesias de Real, Dume e Semelhe",
    "",
    "no",
    "11700",
    "8465000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030380",
    "União das freguesias de Santa Lucrécia de Algeriz e Navarra",
    "",
    "no",
    "994",
    "6217500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030381",
    "União das freguesias de Vilaça e Fradelos",
    "",
    "no",
    "1580",
    "2796200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030401",
    "Abadim",
    "",
    "no",
    "571",
    "15136400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030404",
    "Basto",
    "",
    "no",
    "938",
    "5576100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030405",
    "Bucos",
    "",
    "no",
    "554",
    "17798500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030406",
    "Cabeceiras de Basto",
    "",
    "no",
    "711",
    "24522400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030407",
    "Cavez",
    "",
    "no",
    "1268",
    "26791200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030408",
    "Faia",
    "",
    "no",
    "558",
    "5149600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030413",
    "Pedraça",
    "",
    "no",
    "760",
    "12168200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030415",
    "Rio Douro",
    "",
    "no",
    "942",
    "43114200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030418",
    "União das freguesias de Alvite e Passos",
    "",
    "no",
    "1184",
    "12189200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030419",
    "União das freguesias de Arco de Baúlhe e Vila Nune",
    "",
    "no",
    "2048",
    "9038600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030420",
    "União das freguesias de Gondiães e Vilar de Cunhas",
    "",
    "no",
    "421",
    "41384700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030421",
    "União das freguesias de Refojos de Basto, Outeiro e Painzela",
    "",
    "no",
    "6755",
    "28952600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030501",
    "Agilde",
    "",
    "no",
    "1227",
    "9012100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030502",
    "Arnóia",
    "",
    "no",
    "1702",
    "18728900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030503",
    "Borba de Montanha",
    "",
    "no",
    "1294",
    "10890300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030508",
    "Codeçoso",
    "",
    "no",
    "444",
    "10698400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030510",
    "Fervença",
    "",
    "no",
    "1445",
    "12047800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030515",
    "Moreira do Castelo",
    "",
    "no",
    "627",
    "6135100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030517",
    "Rego",
    "",
    "no",
    "1241",
    "17175200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030518",
    "Ribas",
    "",
    "no",
    "1068",
    "8277900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030520",
    "Basto (São Clemente)",
    "",
    "no",
    "1524",
    "15410600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030521",
    "Vale de Bouro",
    "",
    "no",
    "813",
    "7891100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030523",
    "União das freguesias de Britelo, Gémeos e Ourilhe",
    "",
    "no",
    "3670",
    "17167000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030524",
    "União das freguesias de Caçarilhe e Infesta",
    "",
    "no",
    "758",
    "11389700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030525",
    "União das freguesias de Canedo de Basto e Corgo",
    "",
    "no",
    "1321",
    "13231400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030526",
    "União das freguesias de Carvalho e Basto (Santa Tecla)",
    "",
    "no",
    "1001",
    "10025000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "030527",
    "União das freguesias de Veade, Gagos e Molares",
    "",
    "no",
    "1963",
    "12989900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "030601",
    "Antas",
    "",
    "no",
    "2221",
    "9067300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030608",
    "Forjães",
    "",
    "no",
    "2767",
    "8304700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030610",
    "Gemeses",
    "",
    "no",
    "1078",
    "5568600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030615",
    "Vila Chã",
    "",
    "no",
    "1419",
    "8502000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030616",
    "União das freguesias de Apúlia e Fão",
    "",
    "no",
    "7301",
    "16285700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030617",
    "União das freguesias de Belinho e Mar",
    "",
    "no",
    "3199",
    "8946400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030618",
    "União das freguesias de Esposende, Marinhas e Gandra",
    "",
    "no",
    "11111",
    "17314200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030619",
    "União das freguesias de Fonte Boa e Rio Tinto",
    "",
    "no",
    "1944",
    "10378800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT112",
    "030620",
    "União das freguesias de Palmeira de Faro e Curvos",
    "",
    "no",
    "3214",
    "11042200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT119",
    "030705",
    "Armil",
    "",
    "no",
    "735",
    "4648200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030708",
    "Estorãos",
    "",
    "no",
    "1508",
    "5904400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030709",
    "Fafe",
    "",
    "no",
    "15703",
    "7969900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030712",
    "Fornelos",
    "",
    "no",
    "1374",
    "2446600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030714",
    "Golães",
    "",
    "no",
    "2135",
    "4699200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030716",
    "Medelo",
    "",
    "no",
    "1602",
    "2517100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030719",
    "Passos",
    "",
    "no",
    "1076",
    "4096400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030722",
    "Quinchães",
    "",
    "no",
    "2278",
    "10608500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030723",
    "Regadas",
    "",
    "no",
    "1661",
    "5902400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030724",
    "Revelhe",
    "",
    "no",
    "849",
    "4910700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030725",
    "Ribeiros",
    "",
    "no",
    "640",
    "4958000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030726",
    "Arões (Santa Cristina)",
    "",
    "no",
    "1538",
    "3950500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030728",
    "São Gens",
    "",
    "no",
    "1703",
    "14797200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030729",
    "Silvares (São Martinho)",
    "",
    "no",
    "1325",
    "6292900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030730",
    "Arões (São Romão)",
    "",
    "no",
    "3295",
    "5721300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030733",
    "Travassós",
    "",
    "no",
    "1539",
    "8142200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030736",
    "Vinhós",
    "",
    "no",
    "642",
    "2877900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030737",
    "União de freguesias de Aboim, Felgueiras, Gontim e Pedraído",
    "",
    "no",
    "918",
    "26710500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030738",
    "União de freguesias de Agrela e Serafão",
    "",
    "no",
    "1180",
    "9193300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030739",
    "União de freguesias de Antime e Silvares (São Clemente)",
    "",
    "no",
    "2046",
    "5574700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030740",
    "União de freguesias de Ardegão, Arnozela e Seidões",
    "",
    "no",
    "1083",
    "9783000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030741",
    "União de freguesias de Cepães e Fareja",
    "",
    "no",
    "2265",
    "7389600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030742",
    "União de freguesias de Freitas e Vila Cova",
    "",
    "no",
    "804",
    "11477800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030743",
    "União de freguesias de Monte e Queimadela",
    "",
    "no",
    "801",
    "20372400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030744",
    "União de freguesias de Moreira do Rei e Várzea Cova",
    "",
    "no",
    "1933",
    "28136300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030801",
    "Aldão",
    "",
    "no",
    "1293",
    "1551500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030804",
    "Azurém",
    "",
    "no",
    "8348",
    "2900100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030806",
    "Barco",
    "",
    "no",
    "1510",
    "3016100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030807",
    "Brito",
    "",
    "no",
    "4939",
    "5903000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030808",
    "Caldelas",
    "",
    "no",
    "5723",
    "2693600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030812",
    "Costa",
    "",
    "no",
    "5155",
    "4710500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030813",
    "Creixomil",
    "",
    "no",
    "9641",
    "3006900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030815",
    "Fermentões",
    "",
    "no",
    "5707",
    "3755600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030820",
    "Gonça",
    "",
    "no",
    "1051",
    "7026000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030821",
    "Gondar",
    "",
    "no",
    "2837",
    "2508500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030823",
    "Guardizela",
    "",
    "no",
    "2474",
    "3975700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030824",
    "Infantas",
    "",
    "no",
    "1764",
    "6494400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030827",
    "Longos",
    "",
    "no",
    "1372",
    "7236100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030828",
    "Lordelo",
    "",
    "yes",
    "4290",
    "5017700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030830",
    "Mesão Frio",
    "",
    "no",
    "4173",
    "4130300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030831",
    "Moreira de Cónegos",
    "",
    "no",
    "4853",
    "4724700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030832",
    "Nespereira",
    "",
    "no",
    "2578",
    "3688300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030835",
    "Pencelo",
    "",
    "no",
    "1258",
    "2398400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030836",
    "Pinheiro",
    "",
    "no",
    "1234",
    "1932700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030837",
    "Polvoreira",
    "",
    "no",
    "3495",
    "3294800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030838",
    "Ponte",
    "",
    "no",
    "6610",
    "6011000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030840",
    "Ronfe",
    "",
    "no",
    "4462",
    "5020500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030842",
    "Prazins (Santa Eufémia)",
    "",
    "no",
    "1221",
    "2234800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030850",
    "Selho (São Cristóvão)",
    "",
    "no",
    "2357",
    "2664300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030854",
    "Selho (São Jorge)",
    "",
    "no",
    "5729",
    "5201600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030857",
    "Candoso (São Martinho)",
    "",
    "no",
    "1340",
    "2208400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030858",
    "Sande (São Martinho)",
    "",
    "no",
    "2533",
    "3304300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030865",
    "São Torcato",
    "",
    "no",
    "3373",
    "10385100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030866",
    "Serzedelo",
    "",
    "no",
    "3630",
    "5138600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030868",
    "Silvares",
    "",
    "no",
    "2282",
    "4488500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030871",
    "Urgezes",
    "",
    "no",
    "5259",
    "3314800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030875",
    "União das freguesias de Abação e Gémeos",
    "",
    "no",
    "2694",
    "6733700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030876",
    "União das freguesias de Airão Santa Maria, Airão São João e Vermil",
    "",
    "no",
    "3657",
    "7483400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030877",
    "União das freguesias de Arosa e Castelões",
    "",
    "no",
    "809",
    "5523100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030878",
    "União das freguesias de Atães e Rendufe",
    "",
    "no",
    "2630",
    "12089200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030879",
    "União das freguesias de Briteiros Santo Estêvão e Donim",
    "",
    "no",
    "2089",
    "5938300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030880",
    "União das freguesias de Briteiros São Salvador e Briteiros Santa Leocádia",
    "",
    "no",
    "1799",
    "9388800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030881",
    "União das freguesias de Candoso São Tiago e Mascotelos",
    "",
    "no",
    "3794",
    "3859500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030882",
    "União das freguesias de Conde e Gandarela",
    "",
    "no",
    "2452",
    "3641600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030883",
    "União das freguesias de Leitões, Oleiros e Figueiredo",
    "",
    "no",
    "1466",
    "8977100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030884",
    "União das freguesias de Oliveira, São Paio e São Sebastião",
    "",
    "no",
    "8137",
    "1554900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030885",
    "União das freguesias de Prazins Santo Tirso e Corvite",
    "",
    "no",
    "1876",
    "4587600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030886",
    "União das freguesias de Sande São Lourenço e Balazar",
    "",
    "no",
    "1537",
    "6457800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030887",
    "União das freguesias de Sande Vila Nova e Sande São Clemente",
    "",
    "no",
    "3434",
    "7253100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030888",
    "União das freguesias de Selho São Lourenço e Gominhães",
    "",
    "no",
    "2293",
    "4152600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030889",
    "União das freguesias de Serzedo e Calvos",
    "",
    "no",
    "2284",
    "4504400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030890",
    "União das freguesias de Souto Santa Maria, Souto São Salvador e Gondomar",
    "",
    "no",
    "2096",
    "13869300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030891",
    "União das freguesias de Tabuadelo e São Faustino",
    "",
    "no",
    "2553",
    "5048500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030906",
    "Covelas",
    "",
    "no",
    "416",
    "2909300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030908",
    "Ferreiros",
    "",
    "no",
    "416",
    "4400200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030912",
    "Galegos",
    "",
    "no",
    "543",
    "2942100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030913",
    "Garfe",
    "",
    "no",
    "1000",
    "5435800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030914",
    "Geraz do Minho",
    "",
    "no",
    "546",
    "4843300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030915",
    "Lanhoso",
    "",
    "no",
    "720",
    "6057900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030917",
    "Monsul",
    "",
    "no",
    "770",
    "3278700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030919",
    "Póvoa de Lanhoso (Nossa Senhora do Amparo)",
    "",
    "no",
    "5048",
    "5703200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030921",
    "Rendufinho",
    "",
    "no",
    "736",
    "8365300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030922",
    "Santo Emilião",
    "",
    "no",
    "926",
    "2137900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030923",
    "São João de Rei",
    "",
    "no",
    "401",
    "5462100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030924",
    "Serzedelo",
    "",
    "no",
    "719",
    "10063500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030925",
    "Sobradelo da Goma",
    "",
    "no",
    "794",
    "10119200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030926",
    "Taíde",
    "",
    "no",
    "1613",
    "6665300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030927",
    "Travassos",
    "",
    "no",
    "698",
    "4638200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030929",
    "Vilela",
    "",
    "no",
    "615",
    "4578500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030930",
    "União das freguesias de Águas Santas e Moure",
    "",
    "no",
    "659",
    "3911000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030931",
    "União das freguesias de Calvos e Frades",
    "",
    "no",
    "753",
    "8716100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030932",
    "União das freguesias de Campos e Louredo",
    "",
    "no",
    "1485",
    "5064300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030933",
    "União das freguesias de Esperança e Brunhais",
    "",
    "no",
    "652",
    "8209700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030934",
    "União das freguesias de Fonte Arcada e Oliveira",
    "",
    "no",
    "1672",
    "11058900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "030935",
    "União das freguesias de Verim, Friande e Ajude",
    "",
    "no",
    "736",
    "10092400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031001",
    "Balança",
    "",
    "no",
    "341",
    "3764900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031003",
    "Campo do Gerês",
    "",
    "no",
    "162",
    "68764800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031004",
    "Carvalheira",
    "",
    "no",
    "386",
    "9053400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031008",
    "Covide",
    "",
    "no",
    "343",
    "18094800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031009",
    "Gondoriz",
    "",
    "no",
    "295",
    "7400800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031010",
    "Moimenta",
    "",
    "no",
    "741",
    "3353800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031012",
    "Ribeira",
    "",
    "no",
    "242",
    "2245200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031013",
    "Rio Caldo",
    "",
    "no",
    "892",
    "13953700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031014",
    "Souto",
    "",
    "no",
    "494",
    "4026100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031015",
    "Valdosende",
    "",
    "no",
    "630",
    "12115200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031017",
    "Vilar da Veiga",
    "",
    "no",
    "1286",
    "77825700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031018",
    "União das freguesias de Chamoim e Vilar",
    "",
    "no",
    "440",
    "12568200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031019",
    "União das freguesias de Chorense e Monte",
    "",
    "no",
    "580",
    "20263400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031020",
    "União das freguesias de Cibões e Brufe",
    "",
    "no",
    "421",
    "24030700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031105",
    "Cantelães",
    "",
    "no",
    "828",
    "11542600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031107",
    "Eira Vedra",
    "",
    "no",
    "702",
    "5585900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031108",
    "Guilhofrei",
    "",
    "no",
    "961",
    "11232500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031109",
    "Louredo",
    "",
    "no",
    "436",
    "7613700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031110",
    "Mosteiro",
    "",
    "no",
    "774",
    "10819200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031111",
    "Parada do Bouro",
    "",
    "no",
    "469",
    "7710600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031112",
    "Pinheiro",
    "",
    "no",
    "447",
    "10266300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031113",
    "Rossas",
    "",
    "no",
    "1673",
    "31566000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031115",
    "Salamonde",
    "",
    "no",
    "387",
    "8370000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031118",
    "Tabuaças",
    "",
    "no",
    "919",
    "9682400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031120",
    "Vieira do Minho",
    "",
    "no",
    "2239",
    "7186400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031122",
    "União das freguesias de Anissó e Soutelo",
    "",
    "no",
    "392",
    "8151900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031123",
    "União das freguesias de Anjos e Vilar do Chão",
    "",
    "no",
    "589",
    "24987600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031124",
    "União das freguesias de Caniçada e Soengas",
    "",
    "no",
    "603",
    "8989500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031125",
    "União das freguesias de Ruivães e Campos",
    "",
    "no",
    "923",
    "44034600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031126",
    "União das freguesias de Ventosa e Cova",
    "",
    "no",
    "659",
    "8704400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031204",
    "Bairro",
    "",
    "no",
    "3588",
    "3349700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031206",
    "Brufe",
    "",
    "no",
    "2231",
    "2489200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031210",
    "Castelões",
    "",
    "no",
    "2021",
    "3528500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031212",
    "Cruz",
    "",
    "no",
    "1738",
    "4131700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031213",
    "Delães",
    "",
    "no",
    "4080",
    "2618500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031215",
    "Fradelos",
    "",
    "no",
    "3914",
    "16803400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031216",
    "Gavião",
    "",
    "no",
    "3747",
    "4040900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031219",
    "Joane",
    "",
    "no",
    "8089",
    "7315800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031221",
    "Landim",
    "",
    "no",
    "2834",
    "4510000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031223",
    "Louro",
    "",
    "no",
    "2250",
    "4980300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031224",
    "Lousado",
    "",
    "no",
    "4046",
    "5795000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031225",
    "Mogege",
    "",
    "no",
    "1943",
    "2868100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031227",
    "Nine",
    "",
    "no",
    "2974",
    "4336100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031230",
    "Pedome",
    "",
    "no",
    "2120",
    "2630800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031232",
    "Pousada de Saramagos",
    "",
    "no",
    "2234",
    "2120300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031233",
    "Requião",
    "",
    "no",
    "3376",
    "7416400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031234",
    "Riba de Ave",
    "",
    "no",
    "3425",
    "2757200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031235",
    "Ribeirão",
    "",
    "no",
    "8839",
    "10313500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031239",
    "Oliveira (Santa Maria)",
    "",
    "no",
    "3420",
    "4520800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031241",
    "Vale (São Martinho)",
    "",
    "no",
    "2081",
    "3601200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031242",
    "Oliveira (São Mateus)",
    "",
    "no",
    "2561",
    "2018300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031247",
    "Vermoim",
    "",
    "no",
    "2930",
    "4714400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031249",
    "Vilarinho das Cambas",
    "",
    "no",
    "1366",
    "8410600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031250",
    "União das freguesias de Antas e Abade de Vermoim",
    "",
    "no",
    "7362",
    "5441900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031251",
    "União das freguesias de Arnoso (Santa Maria e Santa Eulália) e Sezures",
    "",
    "no",
    "3543",
    "8809000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031252",
    "União das freguesias de Avidos e Lagoa",
    "",
    "no",
    "2653",
    "4673300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031253",
    "União das freguesias de Carreira e Bente",
    "",
    "no",
    "2576",
    "3579700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031254",
    "União das freguesias de Esmeriz e Cabeçudos",
    "",
    "no",
    "3684",
    "7254100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031255",
    "União das freguesias de Gondifelos, Cavalões e Outiz",
    "",
    "no",
    "4890",
    "16705600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031256",
    "União das freguesias de Lemenhe, Mouquim e Jesufrei",
    "",
    "no",
    "3217",
    "9831700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031257",
    "União das freguesias de Ruivães e Novais",
    "",
    "no",
    "3012",
    "4547900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031258",
    "União das freguesias de Seide",
    "",
    "no",
    "1542",
    "2854700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031259",
    "União das freguesias de Vale (São Cosme), Telhado e Portela",
    "",
    "no",
    "5401",
    "13688300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031260",
    "União das freguesias de Vila Nova de Famalicão e Calendário",
    "",
    "no",
    "20145",
    "8935800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031304",
    "Atiães",
    "",
    "no",
    "520",
    "4036500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031308",
    "Cabanelas",
    "",
    "no",
    "2102",
    "6740300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031309",
    "Cervães",
    "",
    "no",
    "1981",
    "10890500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031311",
    "Coucieiro",
    "",
    "no",
    "531",
    "4216700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031313",
    "Dossãos",
    "",
    "no",
    "500",
    "3346700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031316",
    "Freiriz",
    "",
    "no",
    "1099",
    "5842500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031317",
    "Gême",
    "",
    "no",
    "551",
    "1596700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031323",
    "Lage",
    "",
    "no",
    "2895",
    "4668000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031324",
    "Lanhas",
    "",
    "no",
    "581",
    "1829600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031325",
    "Loureira",
    "",
    "no",
    "1152",
    "1759500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031328",
    "Moure",
    "",
    "no",
    "1421",
    "4501700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031330",
    "Oleiros",
    "",
    "no",
    "1169",
    "3779000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031331",
    "Parada de Gatim",
    "",
    "no",
    "793",
    "3215200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031335",
    "Pico",
    "",
    "no",
    "610",
    "2801800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031337",
    "Ponte",
    "",
    "no",
    "483",
    "3412100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031340",
    "Sabariz",
    "",
    "no",
    "443",
    "2070100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031342",
    "Vila de Prado",
    "",
    "no",
    "4472",
    "5515100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031350",
    "Prado (São Miguel)",
    "",
    "no",
    "717",
    "5506000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031352",
    "Soutelo",
    "",
    "no",
    "2102",
    "4171200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031354",
    "Turiz",
    "",
    "no",
    "1746",
    "3620300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031355",
    "Valdreu",
    "",
    "no",
    "516",
    "17956600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031359",
    "Aboim da Nóbrega e Gondomar",
    "",
    "no",
    "1058",
    "14411700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031360",
    "União das freguesias da Ribeira do Neiva",
    "",
    "no",
    "3807",
    "33762500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031361",
    "União das freguesias de Carreiras (São Miguel) e Carreiras (Santiago)",
    "",
    "no",
    "930",
    "4404400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031362",
    "União das freguesias de Escariz (São Mamede) e Escariz (São Martinho)",
    "",
    "no",
    "749",
    "5779300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031363",
    "União das freguesias de Esqueiros, Nevogilde e Travassós",
    "",
    "no",
    "1035",
    "5024900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031364",
    "União das freguesias de Marrancos e Arcozelo",
    "",
    "no",
    "909",
    "6488500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031365",
    "União das freguesias de Oriz (Santa Marinha) e Oriz (São Miguel)",
    "",
    "no",
    "571",
    "6056400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031366",
    "União das freguesias de Pico de Regalados, Gondiães e Mós",
    "",
    "no",
    "1515",
    "9530200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031367",
    "União das freguesias de Sande, Vilarinho, Barros e Gomide",
    "",
    "no",
    "1564",
    "12383300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031368",
    "União das freguesias de Valbom (São Pedro), Passô e Valbom (São Martinho)",
    "",
    "no",
    "642",
    "6185200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031369",
    "União das freguesias do Vade",
    "",
    "no",
    "1677",
    "15639100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT112",
    "031370",
    "Vila Verde e Barbudo",
    "",
    "no",
    "7047",
    "7523600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031401",
    "Santa Eulália",
    "",
    "no",
    "5619",
    "5640500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031404",
    "Infias",
    "",
    "no",
    "1840",
    "3113400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031406",
    "Vizela (Santo Adrião)",
    "",
    "no",
    "2280",
    "3011500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031408",
    "União das freguesias de Caldas de Vizela (São Miguel e São João)",
    "",
    "no",
    "10633",
    "7683800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "031409",
    "União das freguesias de Tagilde e Vizela (São Paio)",
    "",
    "no",
    "3364",
    "5249000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040102",
    "Alfândega da Fé",
    "",
    "no",
    "2055",
    "40621200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040103",
    "Cerejais",
    "",
    "no",
    "202",
    "16999600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040111",
    "Sambade",
    "",
    "no",
    "475",
    "31487900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040118",
    "Vilar Chão",
    "",
    "no",
    "259",
    "24549100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040119",
    "Vilarelhos",
    "",
    "no",
    "275",
    "12053500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040120",
    "Vilares de Vilariça",
    "",
    "no",
    "216",
    "14919600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040121",
    "União das freguesias de Agrobom, Saldonha e Vale Pereiro",
    "",
    "no",
    "265",
    "32603500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040122",
    "União das freguesias de Eucisia, Gouveia e Valverde",
    "",
    "no",
    "357",
    "50820100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040123",
    "União das freguesias de Ferradosa e Sendim da Serra",
    "",
    "no",
    "251",
    "27057900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040124",
    "União das freguesias de Gebelim e Soeima",
    "",
    "no",
    "332",
    "30597700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040125",
    "União das freguesias de Parada e Sendim da Ribeira",
    "",
    "no",
    "216",
    "25043600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040126",
    "União das freguesias de Pombal e Vales",
    "",
    "no",
    "201",
    "15192700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040201",
    "Alfaião",
    "",
    "no",
    "173",
    "17582500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040203",
    "Babe",
    "",
    "no",
    "238",
    "25616600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040204",
    "Baçal",
    "",
    "no",
    "484",
    "28365600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040206",
    "Carragosa",
    "",
    "no",
    "190",
    "27771900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040209",
    "Castro de Avelãs",
    "",
    "no",
    "460",
    "13478700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040210",
    "Coelhoso",
    "",
    "no",
    "319",
    "19781300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040212",
    "Donai",
    "",
    "no",
    "446",
    "15068600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040213",
    "Espinhosela",
    "",
    "no",
    "244",
    "37028000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040215",
    "França",
    "",
    "no",
    "238",
    "53713000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040216",
    "Gimonde",
    "",
    "no",
    "341",
    "16495900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040217",
    "Gondesende",
    "",
    "no",
    "194",
    "12941800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040218",
    "Gostei",
    "",
    "no",
    "425",
    "19492100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040219",
    "Grijó de Parada",
    "",
    "no",
    "296",
    "31186600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040221",
    "Macedo do Mato",
    "",
    "no",
    "208",
    "15541700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040224",
    "Mós",
    "",
    "no",
    "178",
    "11623000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040225",
    "Nogueira",
    "",
    "no",
    "495",
    "12071300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040226",
    "Outeiro",
    "",
    "no",
    "301",
    "40932100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040229",
    "Parâmio",
    "",
    "no",
    "214",
    "22565400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040230",
    "Pinela",
    "",
    "no",
    "219",
    "22649200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040232",
    "Quintanilha",
    "",
    "no",
    "216",
    "20302000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040233",
    "Quintela de Lampaças",
    "",
    "no",
    "215",
    "19984800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040234",
    "Rabal",
    "",
    "no",
    "171",
    "23371300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040236",
    "Rebordãos",
    "",
    "no",
    "546",
    "26292000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040239",
    "Salsas",
    "",
    "no",
    "389",
    "26118000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040240",
    "Samil",
    "",
    "no",
    "1246",
    "10247500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040241",
    "Santa Comba de Rossas",
    "",
    "no",
    "304",
    "8747700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040244",
    "São Pedro de Sarracenos",
    "",
    "no",
    "366",
    "15908000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040246",
    "Sendas",
    "",
    "no",
    "183",
    "19174300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040247",
    "Serapicos",
    "",
    "no",
    "208",
    "28249500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040248",
    "Sortes",
    "",
    "no",
    "296",
    "21303800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040249",
    "Zoio",
    "",
    "no",
    "189",
    "24391100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040250",
    "União das freguesias de Aveleda e Rio de Onor",
    "",
    "no",
    "272",
    "106352100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040251",
    "União das freguesias de Castrelos e Carrazedo",
    "",
    "no",
    "241",
    "50530700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040252",
    "União das freguesias de Izeda, Calvelhe e Paradinha Nova",
    "",
    "no",
    "1212",
    "72670100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040253",
    "União das freguesias de Parada e Faílde",
    "",
    "no",
    "657",
    "52133000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040254",
    "União das freguesias de Rebordainhos e Pombares",
    "",
    "no",
    "187",
    "24071600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040255",
    "União das freguesias de Rio Frio e Milhão",
    "",
    "no",
    "364",
    "63506300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040256",
    "União das freguesias de São Julião de Palácios e Deilão",
    "",
    "no",
    "400",
    "80621300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040257",
    "União das freguesias de Sé, Santa Maria e Meixedo",
    "",
    "no",
    "22016",
    "35692200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040304",
    "Carrazeda de Ansiães",
    "",
    "no",
    "1701",
    "8960400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040306",
    "Fonte Longa",
    "",
    "no",
    "301",
    "13330100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040308",
    "Linhares",
    "",
    "no",
    "421",
    "28641500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040309",
    "Marzagão",
    "",
    "no",
    "315",
    "16220200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040311",
    "Parambos",
    "",
    "no",
    "247",
    "11175200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040312",
    "Pereiros",
    "",
    "no",
    "235",
    "14700800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040313",
    "Pinhal do Norte",
    "",
    "no",
    "263",
    "16814600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040314",
    "Pombal",
    "",
    "no",
    "324",
    "16819700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040316",
    "Seixo de Ansiães",
    "",
    "no",
    "290",
    "23992200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040318",
    "Vilarinho da Castanheira",
    "",
    "no",
    "415",
    "28256200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040320",
    "União das freguesias de Amedo e Zedes",
    "",
    "no",
    "462",
    "23428100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040321",
    "União das freguesias de Belver e Mogo de Malta",
    "",
    "no",
    "433",
    "19804900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040322",
    "União das freguesias de Castanheiro do Norte e Ribalonga",
    "",
    "no",
    "519",
    "20704300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040323",
    "União das freguesias de Lavandeira, Beira Grande e Selores",
    "",
    "no",
    "447",
    "36392700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040404",
    "Ligares",
    "",
    "no",
    "397",
    "45692200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040406",
    "Poiares",
    "",
    "no",
    "411",
    "40735400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040407",
    "União das freguesias de Freixo de Espada à Cinta e Mazouco",
    "",
    "no",
    "2355",
    "93447000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040408",
    "União das freguesias de Lagoaça e Fornos",
    "",
    "no",
    "617",
    "64268300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040502",
    "Amendoeira",
    "",
    "no",
    "427",
    "15721900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040503",
    "Arcas",
    "",
    "no",
    "262",
    "23015300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040507",
    "Carrapatas",
    "",
    "no",
    "197",
    "6507800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040509",
    "Chacim",
    "",
    "no",
    "265",
    "19429300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040510",
    "Cortiços",
    "",
    "no",
    "296",
    "24251600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040511",
    "Corujas",
    "",
    "no",
    "168",
    "9907100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040514",
    "Ferreira",
    "",
    "no",
    "194",
    "19644600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040515",
    "Grijó",
    "",
    "no",
    "371",
    "8905900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040516",
    "Lagoa",
    "",
    "no",
    "312",
    "35114000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040517",
    "Lamalonga",
    "",
    "no",
    "402",
    "16972900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040518",
    "Lamas",
    "",
    "no",
    "278",
    "7789600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040519",
    "Lombo",
    "",
    "no",
    "346",
    "14403300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040520",
    "Macedo de Cavaleiros",
    "",
    "no",
    "6257",
    "14911300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040521",
    "Morais",
    "",
    "no",
    "644",
    "52162700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040523",
    "Olmos",
    "",
    "no",
    "208",
    "18703100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040524",
    "Peredo",
    "",
    "no",
    "258",
    "22077600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040526",
    "Salselas",
    "",
    "no",
    "386",
    "36310400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040528",
    "Sezulfe",
    "",
    "no",
    "263",
    "15218500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040530",
    "Talhas",
    "",
    "no",
    "316",
    "43800300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040532",
    "Vale Benfeito",
    "",
    "no",
    "181",
    "15135600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040533",
    "Vale da Porca",
    "",
    "no",
    "286",
    "17427300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040534",
    "Vale de Prados",
    "",
    "no",
    "431",
    "10367500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040536",
    "Vilarinho de Agrochão",
    "",
    "no",
    "235",
    "13852600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040538",
    "Vinhas",
    "",
    "no",
    "236",
    "33019400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040539",
    "União das freguesias de Ala e Vilarinho do Monte",
    "",
    "no",
    "484",
    "40770200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040540",
    "União das freguesias de Bornes e Burga",
    "",
    "no",
    "443",
    "26045200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040541",
    "União das freguesias de Castelãos e Vilar do Monte",
    "",
    "no",
    "547",
    "18838400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040542",
    "União das freguesias de Espadanedo, Edroso, Murçós e Soutelo Mourisco",
    "",
    "no",
    "448",
    "64130000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040543",
    "União das freguesias de Podence e Santa Combinha",
    "",
    "no",
    "306",
    "19455000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040544",
    "União das freguesias de Talhinhas e Bagueixe",
    "",
    "no",
    "329",
    "35252400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040604",
    "Duas Igrejas",
    "",
    "no",
    "599",
    "49895700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040605",
    "Genísio",
    "",
    "no",
    "186",
    "29467900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040607",
    "Malhadas",
    "",
    "no",
    "344",
    "27673900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040608",
    "Miranda do Douro",
    "",
    "no",
    "2254",
    "35524600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040609",
    "Palaçoulo",
    "",
    "no",
    "554",
    "42371300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040611",
    "Picote",
    "",
    "no",
    "301",
    "19433700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040612",
    "Póvoa",
    "",
    "no",
    "208",
    "22537800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040613",
    "São Martinho de Angueira",
    "",
    "no",
    "307",
    "36771200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040616",
    "Vila Chã de Braciosa",
    "",
    "no",
    "327",
    "42937200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040618",
    "União das freguesias de Constantim e Cicouro",
    "",
    "no",
    "204",
    "36330100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040619",
    "União das freguesias de Ifanes e Paradela",
    "",
    "no",
    "311",
    "44698800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040620",
    "União das freguesias de Sendim e Atenor",
    "",
    "no",
    "1487",
    "58929300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040621",
    "União das freguesias de Silva e Águas Vivas",
    "",
    "no",
    "400",
    "40611600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040701",
    "Abambres",
    "",
    "no",
    "347",
    "18816000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040702",
    "Abreiro",
    "",
    "no",
    "257",
    "24028000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040703",
    "Aguieiras",
    "",
    "no",
    "289",
    "14722500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040704",
    "Alvites",
    "",
    "no",
    "237",
    "17808900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040708",
    "Bouça",
    "",
    "no",
    "261",
    "12989900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040709",
    "Cabanelas",
    "",
    "no",
    "386",
    "18656500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040710",
    "Caravelas",
    "",
    "no",
    "214",
    "12565700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040711",
    "Carvalhais",
    "",
    "no",
    "1299",
    "22038600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040712",
    "Cedães",
    "",
    "no",
    "338",
    "25439600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040713",
    "Cobro",
    "",
    "no",
    "205",
    "12312900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040714",
    "Fradizela",
    "",
    "no",
    "234",
    "12772600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040716",
    "Frechas",
    "",
    "no",
    "929",
    "18541700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040718",
    "Lamas de Orelhão",
    "",
    "no",
    "394",
    "19221800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040720",
    "Mascarenhas",
    "",
    "no",
    "550",
    "28138500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040721",
    "Mirandela",
    "",
    "no",
    "11852",
    "32449400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040722",
    "Múrias",
    "",
    "no",
    "281",
    "22551300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040724",
    "Passos",
    "",
    "no",
    "423",
    "18387000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040727",
    "São Pedro Velho",
    "",
    "no",
    "329",
    "23626100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040728",
    "São Salvador",
    "",
    "no",
    "223",
    "14213000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040729",
    "Suçães",
    "",
    "no",
    "574",
    "36205000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040730",
    "Torre de Dona Chama",
    "",
    "no",
    "1105",
    "27684000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040731",
    "Vale de Asnes",
    "",
    "no",
    "271",
    "21417200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040732",
    "Vale de Gouvinhas",
    "",
    "no",
    "319",
    "17140200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040733",
    "Vale de Salgueiro",
    "",
    "no",
    "424",
    "15167600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040734",
    "Vale de Telhas",
    "",
    "no",
    "283",
    "15168000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040738",
    "União das freguesias de Avantos e Romeu",
    "",
    "no",
    "376",
    "27413900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040739",
    "União das Freguesias de Avidagos, Navalho e Pereira",
    "",
    "no",
    "531",
    "33164900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040740",
    "União das freguesias de Barcel, Marmelos e Valverde da Gestosa",
    "",
    "no",
    "415",
    "48744900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040741",
    "União das freguesias de Franco e Vila Boa",
    "",
    "no",
    "334",
    "26339100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040742",
    "União das freguesias de Freixeda e Vila Verde",
    "",
    "no",
    "170",
    "21232000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040801",
    "Azinhoso",
    "",
    "no",
    "307",
    "30802100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040802",
    "Bemposta",
    "",
    "no",
    "602",
    "37919100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040803",
    "Bruçó",
    "",
    "no",
    "211",
    "32380700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040804",
    "Brunhoso",
    "",
    "no",
    "216",
    "20811700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040807",
    "Castelo Branco",
    "",
    "no",
    "449",
    "54311000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040808",
    "Castro Vicente",
    "",
    "no",
    "337",
    "34786500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040809",
    "Meirinhos",
    "",
    "no",
    "287",
    "53401600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040811",
    "Paradela",
    "",
    "no",
    "156",
    "20532900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040812",
    "Penas Roias",
    "",
    "no",
    "382",
    "33279600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040813",
    "Peredo da Bemposta",
    "",
    "no",
    "188",
    "18158900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040815",
    "Saldanha",
    "",
    "no",
    "165",
    "25901800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040817",
    "São Martinho do Peso",
    "",
    "no",
    "355",
    "52191500",
    "3",
    "no",
    "no",
    "no"
  ],
  ["PT11E", "040819", "Tó", "", "no", "154", "23684700", "3", "no", "no", "no"],
  [
    "PT11E",
    "040820",
    "Travanca",
    "",
    "no",
    "172",
    "21056700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040821",
    "Urrós",
    "",
    "no",
    "318",
    "31939900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040822",
    "Vale da Madre",
    "",
    "no",
    "156",
    "11565400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040826",
    "Vila de Ala",
    "",
    "no",
    "234",
    "26725500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040829",
    "União das freguesias de Brunhozinho, Castanheira e Sanhoane",
    "",
    "no",
    "289",
    "42763000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040830",
    "União das freguesias de Mogadouro, Valverde, Vale de Porco e Vilar de Rei",
    "",
    "no",
    "3887",
    "103215800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040831",
    "União das freguesias de Remondes e Soutelo",
    "",
    "no",
    "341",
    "36484600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "040832",
    "União das freguesias de Vilarinho dos Galegos e Ventozelo",
    "",
    "no",
    "336",
    "48736100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040901",
    "Açoreira",
    "",
    "no",
    "524",
    "23980300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040903",
    "Cabeça Boa",
    "",
    "no",
    "428",
    "26371900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040905",
    "Carviçais",
    "",
    "no",
    "757",
    "62999500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040906",
    "Castedo",
    "",
    "no",
    "236",
    "17936200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040909",
    "Horta da Vilariça",
    "",
    "no",
    "310",
    "16421500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040910",
    "Larinho",
    "",
    "no",
    "365",
    "29486100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040911",
    "Lousa",
    "",
    "no",
    "358",
    "33937400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040913",
    "Mós",
    "",
    "no",
    "246",
    "59125900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040916",
    "Torre de Moncorvo",
    "",
    "no",
    "2891",
    "36083600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040918",
    "União das freguesias de Adeganha e Cardanha",
    "",
    "no",
    "574",
    "64457900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040919",
    "União das freguesias de Felgar e Souto da Velha",
    "",
    "no",
    "1047",
    "46931900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040920",
    "União das freguesias de Felgueiras e Maçores",
    "",
    "no",
    "460",
    "38929900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "040921",
    "União das freguesias de Urros e Peredo dos Castelhanos",
    "",
    "no",
    "376",
    "74894700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041002",
    "Benlhevai",
    "",
    "no",
    "234",
    "11351100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041005",
    "Freixiel",
    "",
    "no",
    "640",
    "34737800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041009",
    "Roios",
    "",
    "no",
    "150",
    "15302700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041010",
    "Samões",
    "",
    "no",
    "338",
    "13477400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041011",
    "Sampaio",
    "",
    "no",
    "159",
    "8621800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041012",
    "Santa Comba de Vilariça",
    "",
    "no",
    "407",
    "12186100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041013",
    "Seixo de Manhoses",
    "",
    "no",
    "469",
    "9749000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041014",
    "Trindade",
    "",
    "no",
    "162",
    "14981900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041015",
    "Vale Frechoso",
    "",
    "no",
    "189",
    "19301200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041020",
    "União das freguesias de Assares e Lodões",
    "",
    "no",
    "241",
    "14264800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041021",
    "União das freguesias de Candoso e Carvalho de Egas",
    "",
    "no",
    "272",
    "10035400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041022",
    "União das freguesias de Valtorno e Mourão",
    "",
    "no",
    "364",
    "18581300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041023",
    "União das freguesias de Vila Flor e Nabo",
    "",
    "no",
    "2413",
    "40257200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041024",
    "União das freguesias de Vilas Boas e Vilarinho das Azenhas",
    "",
    "no",
    "659",
    "42963800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041103",
    "Argozelo",
    "",
    "no",
    "701",
    "29526700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041107",
    "Carção",
    "",
    "no",
    "419",
    "27338700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041108",
    "Matela",
    "",
    "no",
    "228",
    "44523100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041109",
    "Pinelo",
    "",
    "no",
    "222",
    "32994400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041110",
    "Santulhão",
    "",
    "no",
    "423",
    "49377400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041113",
    "Vilar Seco",
    "",
    "no",
    "181",
    "23415800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041114",
    "Vimioso",
    "",
    "no",
    "1285",
    "55343100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041115",
    "União das freguesias de Algoso, Campo de Víboras e Uva",
    "",
    "no",
    "567",
    "96531700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041116",
    "União das freguesias de Caçarelhos e Angueira",
    "",
    "no",
    "335",
    "53155800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041117",
    "União das freguesias de Vale de Frades e Avelanoso",
    "",
    "no",
    "308",
    "69378500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041201",
    "Agrochão",
    "",
    "no",
    "280",
    "17485200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041203",
    "Candedo",
    "",
    "no",
    "331",
    "21439000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041204",
    "Celas",
    "",
    "no",
    "269",
    "37883800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041206",
    "Edral",
    "",
    "no",
    "198",
    "26162400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041207",
    "Edrosa",
    "",
    "no",
    "151",
    "21811300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041208",
    "Ervedosa",
    "",
    "no",
    "376",
    "30153800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041215",
    "Paçó",
    "",
    "no",
    "191",
    "16668100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041216",
    "Penhas Juntas",
    "",
    "no",
    "255",
    "26353300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041219",
    "Rebordelo",
    "",
    "no",
    "618",
    "21065500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041221",
    "Santalha",
    "",
    "no",
    "254",
    "29035400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041226",
    "Tuizelo",
    "",
    "no",
    "387",
    "31353000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041227",
    "Vale das Fontes",
    "",
    "no",
    "347",
    "17761200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041229",
    "Vila Boa de Ousilhão",
    "",
    "no",
    "184",
    "8278500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041230",
    "Vila Verde",
    "",
    "no",
    "186",
    "14884500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041232",
    "Vilar de Ossos",
    "",
    "no",
    "269",
    "17701900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041233",
    "Vilar de Peregrinos",
    "",
    "no",
    "155",
    "15993000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041234",
    "Vilar Seco de Lomba",
    "",
    "no",
    "235",
    "22322700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041235",
    "Vinhais",
    "",
    "no",
    "2245",
    "32013300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041236",
    "União das freguesias de Curopos e Vale de Janeiro",
    "",
    "no",
    "313",
    "36204400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041237",
    "União das freguesias de Moimenta e Montouto",
    "",
    "no",
    "278",
    "43352200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041238",
    "União das freguesias de Nunes e Ousilhão",
    "",
    "no",
    "257",
    "21494800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041239",
    "União das freguesias de Quirás e Pinheiro Novo",
    "",
    "no",
    "286",
    "59190000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041240",
    "União das freguesias de Sobreiro de Baixo e Alvaredos",
    "",
    "no",
    "369",
    "26787600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041241",
    "União das freguesias de Soeira, Fresulfe e Mofreita",
    "",
    "no",
    "224",
    "46672100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041242",
    "União das freguesias de Travanca e Santa Cruz",
    "",
    "no",
    "171",
    "23201700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11E",
    "041243",
    "União das freguesias de Vilar de Lomba e São Jomil",
    "",
    "no",
    "237",
    "29482100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050102",
    "Caria",
    "",
    "no",
    "1921",
    "39028100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050104",
    "Inguias",
    "",
    "no",
    "670",
    "23204900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050105",
    "Maçainhas",
    "",
    "no",
    "356",
    "18206500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050106",
    "União das freguesias de Belmonte e Colmeal da Torre",
    "",
    "no",
    "3912",
    "38319600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050201",
    "Alcains",
    "",
    "no",
    "5022",
    "36944700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050202",
    "Almaceda",
    "",
    "no",
    "677",
    "72192700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050203",
    "Benquerenças",
    "",
    "no",
    "720",
    "61031400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050205",
    "Castelo Branco",
    "",
    "no",
    "35242",
    "170262400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050211",
    "Lardosa",
    "",
    "no",
    "961",
    "44471400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050212",
    "Louriçal do Campo",
    "",
    "no",
    "636",
    "22305600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050214",
    "Malpica do Tejo",
    "",
    "no",
    "517",
    "246022200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050216",
    "Monforte da Beira",
    "",
    "no",
    "378",
    "120354600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050220",
    "Salgueiro do Campo",
    "",
    "no",
    "891",
    "30338600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050221",
    "Santo André das Tojeiras",
    "",
    "no",
    "747",
    "74874100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050222",
    "São Vicente da Beira",
    "",
    "no",
    "1259",
    "100002600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050223",
    "Sarzedas",
    "",
    "no",
    "1335",
    "172049000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050225",
    "Tinalhas",
    "",
    "no",
    "585",
    "16194900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050226",
    "União das freguesias de Cebolais de Cima e Retaxo",
    "",
    "no",
    "1869",
    "25126100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050227",
    "União das freguesias de Escalos de Baixo e Mata",
    "",
    "no",
    "1216",
    "70076500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050228",
    "União das freguesias de Escalos de Cima e Lousa",
    "",
    "no",
    "1559",
    "51235500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050229",
    "União das freguesias de Freixial e Juncal do Campo",
    "",
    "no",
    "823",
    "40667600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050230",
    "União das freguesias de Ninho do Açor e Sobral do Campo",
    "",
    "no",
    "746",
    "42969200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050231",
    "União das freguesias de Póvoa de Rio de Moinhos e Cafede",
    "",
    "no",
    "926",
    "41072500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050302",
    "Aldeia de São Francisco de Assis",
    "",
    "no",
    "632",
    "16078400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050305",
    "Boidobra",
    "",
    "no",
    "3246",
    "16260000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050308",
    "Cortes do Meio",
    "",
    "no",
    "884",
    "47402300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050309",
    "Dominguizo",
    "",
    "no",
    "1119",
    "4949000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050310",
    "Erada",
    "",
    "no",
    "709",
    "43395200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050311",
    "Ferro",
    "",
    "no",
    "1700",
    "30759100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050312",
    "Orjais",
    "",
    "no",
    "806",
    "18897800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050314",
    "Paul",
    "",
    "no",
    "1624",
    "23992100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050315",
    "Peraboa",
    "",
    "no",
    "953",
    "27201200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050318",
    "São Jorge da Beira",
    "",
    "no",
    "633",
    "23050800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050322",
    "Sobral de São Miguel",
    "",
    "no",
    "418",
    "23935200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050324",
    "Tortosendo",
    "",
    "no",
    "5624",
    "17750600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050325",
    "Unhais da Serra",
    "",
    "no",
    "1398",
    "29930800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050327",
    "Verdelhos",
    "",
    "no",
    "664",
    "36492600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050332",
    "União das freguesias de Barco e Coutada",
    "",
    "no",
    "879",
    "24025500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050333",
    "União das freguesias de Cantar-Galo e Vila do Carvalho",
    "",
    "no",
    "3974",
    "15800600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050334",
    "União das freguesias de Casegas e Ourondo",
    "",
    "no",
    "797",
    "48246600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050335",
    "União das freguesias de Covilhã e Canhoso",
    "",
    "no",
    "19022",
    "25949500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050336",
    "União das freguesias de Peso e Vales do Rio",
    "",
    "no",
    "1411",
    "15889700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050337",
    "União das freguesias de Teixoso e Sarzedo",
    "",
    "no",
    "4490",
    "46693300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050338",
    "União das freguesias de Vale Formoso e Aldeia do Souto",
    "",
    "no",
    "814",
    "18900200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050401",
    "Alcaide",
    "",
    "no",
    "616",
    "16715100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050402",
    "Alcaria",
    "",
    "no",
    "1180",
    "21481400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050403",
    "Alcongosta",
    "",
    "no",
    "497",
    "7310500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050406",
    "Alpedrinha",
    "",
    "no",
    "1087",
    "16186900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050408",
    "Barroca",
    "",
    "no",
    "496",
    "23098700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050410",
    "Bogas de Cima",
    "",
    "no",
    "347",
    "31242900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050411",
    "Capinha",
    "",
    "no",
    "494",
    "39635800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050412",
    "Castelejo",
    "",
    "no",
    "656",
    "29518200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050413",
    "Castelo Novo",
    "",
    "no",
    "406",
    "40510900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050416",
    "Fatela",
    "",
    "no",
    "564",
    "11265700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050419",
    "Lavacolhos",
    "",
    "no",
    "236",
    "19865300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050420",
    "Orca",
    "",
    "no",
    "650",
    "54983200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050421",
    "Pêro Viseu",
    "",
    "no",
    "728",
    "19200800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050424",
    "Silvares",
    "",
    "no",
    "968",
    "20245300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050425",
    "Soalheira",
    "",
    "no",
    "891",
    "12422900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050426",
    "Souto da Casa",
    "",
    "no",
    "807",
    "29369400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050427",
    "Telhado",
    "",
    "no",
    "618",
    "17641500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050431",
    "Enxames",
    "",
    "no",
    "520",
    "22483900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050432",
    "Três Povos",
    "",
    "no",
    "914",
    "65956800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050433",
    "União das freguesias de Janeiro de Cima e Bogas de Baixo",
    "",
    "no",
    "500",
    "46360900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050434",
    "União das freguesias de Fundão, Valverde, Donas, Aldeia de Joanes e Aldeia Nova do Cabo",
    "",
    "no",
    "13434",
    "57831400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050435",
    "União das freguesias de Póvoa de Atalaia e Atalaia do Campo",
    "",
    "no",
    "1188",
    "24181600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "050436",
    "União das freguesias de Vale de Prazeres e Mata da Rainha",
    "",
    "no",
    "1416",
    "72689000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050502",
    "Aldeia de Santa Margarida",
    "",
    "no",
    "292",
    "13621800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050505",
    "Ladoeiro",
    "",
    "no",
    "1290",
    "63284600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050506",
    "Medelim",
    "",
    "no",
    "272",
    "30474200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050509",
    "Oledo",
    "",
    "no",
    "355",
    "27665200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050510",
    "Penha Garcia",
    "",
    "no",
    "748",
    "128417900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050511",
    "Proença-a-Velha",
    "",
    "no",
    "224",
    "58001700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050512",
    "Rosmaninhal",
    "",
    "no",
    "537",
    "266587800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050514",
    "São Miguel de Acha",
    "",
    "no",
    "560",
    "41260800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050516",
    "Toulões",
    "",
    "no",
    "237",
    "36727900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050518",
    "União das freguesias de Idanha-a-Nova e Alcafozes",
    "",
    "no",
    "2554",
    "284781900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050519",
    "União das freguesias de Monfortinho e Salvaterra do Extremo",
    "",
    "no",
    "706",
    "135387000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050520",
    "União das freguesias de Monsanto e Idanha-a-Velha",
    "",
    "no",
    "892",
    "152730500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050521",
    "União das freguesias de Zebreira e Segura",
    "",
    "no",
    "1049",
    "177393800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050601",
    "Álvaro",
    "",
    "no",
    "237",
    "29408400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050603",
    "Cambas",
    "",
    "no",
    "309",
    "48538400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050605",
    "Isna",
    "",
    "no",
    "209",
    "27941000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050606",
    "Madeirã",
    "",
    "no",
    "171",
    "26874300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050607",
    "Mosteiro",
    "",
    "no",
    "307",
    "17695400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050609",
    "Orvalho",
    "",
    "no",
    "678",
    "33311300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050610",
    "Sarnadas de São Simão",
    "",
    "no",
    "217",
    "31003300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050611",
    "Sobral",
    "",
    "no",
    "160",
    "19163900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050613",
    "Estreito-Vilar Barroco",
    "",
    "no",
    "1011",
    "93512900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050614",
    "Oleiros-Amieira",
    "",
    "no",
    "2422",
    "143644200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050704",
    "Aranhas",
    "",
    "no",
    "353",
    "5476700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050706",
    "Benquerença",
    "",
    "no",
    "575",
    "28601500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050707",
    "Meimão",
    "",
    "no",
    "280",
    "33116800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050708",
    "Meimoa",
    "",
    "no",
    "373",
    "28795400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050710",
    "Penamacor",
    "",
    "no",
    "1577",
    "373498600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050711",
    "Salvador",
    "",
    "no",
    "476",
    "10486800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050712",
    "Vale da Senhora da Póvoa",
    "",
    "no",
    "257",
    "19312300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050713",
    "União das freguesias de Aldeia do Bispo, Águas e Aldeia de João Pires",
    "",
    "no",
    "1171",
    "32709800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050714",
    "União das freguesias de Pedrógão de São Pedro e Bemposta",
    "",
    "no",
    "620",
    "31709100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050802",
    "Montes da Senhora",
    "",
    "no",
    "748",
    "36730400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050805",
    "São Pedro do Esteval",
    "",
    "no",
    "527",
    "68499000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050807",
    "União das freguesias de Proença-a-Nova e Peral",
    "",
    "no",
    "4969",
    "171513700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "050808",
    "União das freguesias de Sobreira Formosa e Alvito da Beira",
    "",
    "no",
    "2070",
    "118656500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050901",
    "Cabeçudo",
    "",
    "no",
    "957",
    "10393800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050902",
    "Carvalhal",
    "",
    "no",
    "465",
    "10020200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050903",
    "Castelo",
    "",
    "no",
    "1046",
    "24574300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050911",
    "Pedrógão Pequeno",
    "",
    "no",
    "753",
    "36856900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050912",
    "Sertã",
    "",
    "no",
    "6196",
    "80947500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050913",
    "Troviscal",
    "",
    "no",
    "864",
    "53370700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050914",
    "Várzea dos Cavaleiros",
    "",
    "no",
    "820",
    "34506400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050915",
    "União das freguesias de Cernache do Bonjardim, Nesperal e Palhais",
    "",
    "no",
    "3625",
    "101586800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050916",
    "União das freguesias de Cumeada e Marmeleiro",
    "",
    "no",
    "731",
    "51732800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "050917",
    "União das freguesias de Ermida e Figueiredo",
    "",
    "no",
    "423",
    "42742200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "051001",
    "Fundada",
    "",
    "no",
    "638",
    "36544300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "051002",
    "São João do Peso",
    "",
    "no",
    "204",
    "13050700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "051003",
    "Vila de Rei",
    "",
    "no",
    "2610",
    "141950900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "051101",
    "Fratel",
    "",
    "no",
    "608",
    "97843800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "051102",
    "Perais",
    "",
    "no",
    "510",
    "81951500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "051103",
    "Sarnadas de Ródão",
    "",
    "no",
    "637",
    "59675400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16H",
    "051104",
    "Vila Velha de Ródão",
    "",
    "no",
    "1766",
    "90440900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060102",
    "Arganil",
    "",
    "no",
    "4002",
    "34110100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060104",
    "Benfeita",
    "",
    "no",
    "394",
    "21769500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060105",
    "Celavisa",
    "",
    "no",
    "182",
    "15271900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060109",
    "Folques",
    "",
    "no",
    "356",
    "18356300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060111",
    "Piódão",
    "",
    "no",
    "178",
    "36570200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060112",
    "Pomares",
    "",
    "no",
    "513",
    "31517100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060113",
    "Pombeiro da Beira",
    "",
    "no",
    "1010",
    "32649000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060114",
    "São Martinho da Cortiça",
    "",
    "no",
    "1319",
    "31542200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060115",
    "Sarzedo",
    "",
    "no",
    "685",
    "11555500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060116",
    "Secarias",
    "",
    "no",
    "430",
    "6940700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060119",
    "União das freguesias de Cepos e Teixeira",
    "",
    "no",
    "270",
    "32711000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060120",
    "União das freguesias de Cerdeira e Moura da Serra",
    "",
    "no",
    "439",
    "18423800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060121",
    "União das freguesias de Côja e Barril de Alva",
    "",
    "no",
    "1708",
    "24296300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060122",
    "União das freguesias de Vila Cova de Alva e Anseriz",
    "",
    "no",
    "659",
    "17125800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060201",
    "Ançã",
    "",
    "no",
    "2625",
    "18095800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060203",
    "Cadima",
    "",
    "no",
    "2963",
    "26991300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060205",
    "Cordinhã",
    "",
    "no",
    "1034",
    "9916900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060207",
    "Febres",
    "",
    "no",
    "3352",
    "22941800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060208",
    "Murtede",
    "",
    "no",
    "1431",
    "20161000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060209",
    "Ourentã",
    "",
    "no",
    "1208",
    "18360800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060214",
    "Tocha",
    "",
    "no",
    "3992",
    "78439500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060215",
    "São Caetano",
    "",
    "no",
    "801",
    "19038100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060218",
    "Sanguinheira",
    "",
    "no",
    "1901",
    "26604700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060220",
    "União das freguesias de Cantanhede e Pocariça",
    "",
    "no",
    "8839",
    "54090000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060221",
    "União das freguesias de Covões e Camarneira",
    "",
    "no",
    "2979",
    "36859400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060222",
    "União das freguesias de Portunhos e Outil",
    "",
    "no",
    "2045",
    "30721500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060223",
    "União das freguesias de Sepins e Bolho",
    "",
    "no",
    "1924",
    "17613600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060224",
    "União das freguesias de Vilamar e Corticeiro de Cima",
    "",
    "no",
    "1501",
    "11045800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060301",
    "Almalaguês",
    "",
    "no",
    "3111",
    "23163900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060309",
    "Brasfemes",
    "",
    "no",
    "1969",
    "9177900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060311",
    "Ceira",
    "",
    "no",
    "3701",
    "12424900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060312",
    "Cernache",
    "",
    "no",
    "4048",
    "19165200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060318",
    "Santo António dos Olivais",
    "",
    "no",
    "38936",
    "19273300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060320",
    "São João do Campo",
    "",
    "no",
    "2073",
    "7919500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060324",
    "São Silvestre",
    "",
    "no",
    "3122",
    "10273400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060329",
    "Torres do Mondego",
    "",
    "no",
    "2402",
    "16662900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060332",
    "União das freguesias de Antuzede e Vil de Matos",
    "",
    "no",
    "3146",
    "17623900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060333",
    "União das freguesias de Assafarge e Antanhol",
    "",
    "no",
    "5302",
    "19511300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060334",
    "União das freguesias de Coimbra (Sé Nova, Santa Cruz, Almedina e São Bartolomeu)",
    "",
    "no",
    "13971",
    "8334800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060335",
    "União das freguesias de Eiras e São Paulo de Frades",
    "",
    "no",
    "17921",
    "24777100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060336",
    "União das freguesias de Santa Clara e Castelo Viegas",
    "",
    "no",
    "11624",
    "17627700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060337",
    "União das freguesias de São Martinho de Árvore e Lamarosa",
    "",
    "no",
    "3102",
    "20881700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060338",
    "União das freguesias de São Martinho do Bispo e Ribeira de Frades",
    "",
    "no",
    "16049",
    "24677400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060339",
    "União das freguesias de Souselas e Botão",
    "",
    "no",
    "4680",
    "33007000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060340",
    "União das freguesias de Taveiro, Ameal e Arzila",
    "",
    "no",
    "4285",
    "24339600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060341",
    "União das freguesias de Trouxemil e Torre de Vilela",
    "",
    "no",
    "3954",
    "10557800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060401",
    "Anobra",
    "",
    "no",
    "1316",
    "16382900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060406",
    "Ega",
    "",
    "no",
    "2835",
    "32550600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060407",
    "Furadouro",
    "",
    "no",
    "206",
    "14412200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060410",
    "Zambujal",
    "",
    "no",
    "402",
    "18418000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060411",
    "União das freguesias de Condeixa-a-Velha e Condeixa-a-Nova",
    "",
    "no",
    "8608",
    "27653600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060412",
    "União das freguesias de Sebal e Belide",
    "",
    "no",
    "2723",
    "12986100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060413",
    "União das freguesias de Vila Seca e Bem da Fé",
    "",
    "no",
    "988",
    "16271400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060502",
    "Alqueidão",
    "",
    "no",
    "1752",
    "19664800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060507",
    "Maiorca",
    "",
    "no",
    "2703",
    "25135500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060508",
    "Marinha das Ondas",
    "",
    "no",
    "3179",
    "27412200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060512",
    "Tavarede",
    "",
    "no",
    "9441",
    "10713600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060513",
    "Vila Verde",
    "",
    "no",
    "2898",
    "17292400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060514",
    "São Pedro",
    "",
    "no",
    "2910",
    "7005200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060515",
    "Bom Sucesso",
    "",
    "no",
    "2133",
    "60361700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060518",
    "Moinhos da Gândara",
    "",
    "no",
    "1265",
    "10744300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060519",
    "Alhadas",
    "",
    "no",
    "4757",
    "31844400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060520",
    "Buarcos",
    "",
    "no",
    "18454",
    "15530400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060521",
    "Ferreira-a-Nova",
    "",
    "no",
    "2477",
    "27830900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060522",
    "Lavos",
    "",
    "no",
    "3999",
    "42023600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060523",
    "Paião",
    "",
    "no",
    "3115",
    "31187100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060524",
    "Quiaios",
    "",
    "no",
    "3042",
    "52306500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060601",
    "Alvares",
    "",
    "no",
    "812",
    "100573300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060604",
    "Góis",
    "",
    "no",
    "2171",
    "72871000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060605",
    "Vila Nova do Ceira",
    "",
    "no",
    "929",
    "19701200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060606",
    "União das freguesias de Cadafaz e Colmeal",
    "",
    "no",
    "348",
    "70156300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060704",
    "Serpins",
    "",
    "no",
    "1802",
    "36122000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060706",
    "Gândaras",
    "",
    "no",
    "1308",
    "10040500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060707",
    "União das freguesias de Foz de Arouce e Casal de Ermio",
    "",
    "no",
    "1438",
    "19835300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060708",
    "União das freguesias de Lousã e Vilarinho",
    "",
    "no",
    "13056",
    "72402300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060801",
    "Mira",
    "",
    "no",
    "7367",
    "63143200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060802",
    "Seixo",
    "",
    "no",
    "1234",
    "16231000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060803",
    "Carapelhos",
    "",
    "no",
    "717",
    "4381200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060804",
    "Praia de Mira",
    "",
    "no",
    "3147",
    "40278500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16E",
    "060901",
    "Lamas",
    "",
    "no",
    "838",
    "15660400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060902",
    "Miranda do Corvo",
    "",
    "no",
    "7614",
    "46519600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060905",
    "Vila Nova",
    "",
    "no",
    "970",
    "26895400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "060906",
    "União das freguesias de Semide e Rio Vide",
    "",
    "no",
    "3676",
    "37302500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061002",
    "Arazede",
    "",
    "no",
    "5508",
    "53447000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061003",
    "Carapinheira",
    "",
    "no",
    "2898",
    "15900300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061005",
    "Liceia",
    "",
    "no",
    "1254",
    "12690400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061006",
    "Meãs do Campo",
    "",
    "no",
    "1853",
    "9743800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061008",
    "Pereira",
    "",
    "no",
    "3265",
    "12339800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061009",
    "Santo Varão",
    "",
    "no",
    "1969",
    "11846700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061010",
    "Seixo de Gatões",
    "",
    "no",
    "1449",
    "10898900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061011",
    "Tentúgal",
    "",
    "no",
    "2141",
    "34291800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061014",
    "Ereira",
    "",
    "no",
    "649",
    "7246300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061015",
    "União das freguesias de Abrunheira, Verride e Vila Nova da Barca",
    "",
    "no",
    "1515",
    "29500200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061016",
    "União das freguesias de Montemor-o-Velho e Gatões",
    "",
    "no",
    "3670",
    "31056900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061101",
    "Aldeia das Dez",
    "",
    "no",
    "531",
    "18694900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061102",
    "Alvoco das Várzeas",
    "",
    "no",
    "320",
    "11623000",
    "3",
    "no",
    "no",
    "no"
  ],
  ["PT16E", "061103", "Avô", "", "no", "595", "7172000", "3", "no", "no", "no"],
  [
    "PT16E",
    "061104",
    "Bobadela",
    "",
    "no",
    "759",
    "5679600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061106",
    "Lagares",
    "",
    "no",
    "1398",
    "13189600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061109",
    "Lourosa",
    "",
    "no",
    "555",
    "13935300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061110",
    "Meruge",
    "",
    "no",
    "555",
    "7247000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061111",
    "Nogueira do Cravo",
    "",
    "no",
    "2309",
    "14983600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061115",
    "São Gião",
    "",
    "no",
    "425",
    "14549200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061118",
    "Seixo da Beira",
    "",
    "no",
    "1600",
    "33729200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061119",
    "Travanca de Lagos",
    "",
    "no",
    "1296",
    "15826700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061122",
    "União das freguesias de Ervedal e Vila Franca da Beira",
    "",
    "no",
    "1394",
    "28779500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061123",
    "União das freguesias de Lagos da Beira e Lajeosa",
    "",
    "no",
    "1335",
    "13511900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061124",
    "União das freguesias de Oliveira do Hospital e São Paio de Gramaços",
    "",
    "no",
    "5708",
    "13668700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061125",
    "União das freguesias de Penalva de Alva e São Sebastião da Feira",
    "",
    "no",
    "1123",
    "14495900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061126",
    "União das freguesias de Santa Ovaia e Vila Pouca da Beira",
    "",
    "no",
    "952",
    "7430500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061201",
    "Cabril",
    "",
    "no",
    "231",
    "35198600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061202",
    "Dornelas do Zêzere",
    "",
    "no",
    "682",
    "16436400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061204",
    "Janeiro de Baixo",
    "",
    "no",
    "669",
    "40695100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061206",
    "Pampilhosa da Serra",
    "",
    "no",
    "1389",
    "100175100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061207",
    "Pessegueiro",
    "",
    "no",
    "228",
    "31996800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061209",
    "Unhais-o-Velho",
    "",
    "no",
    "458",
    "39574400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061211",
    "Fajão-Vidual",
    "",
    "no",
    "317",
    "79591000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061212",
    "Portela do Fojo-Machio",
    "",
    "no",
    "507",
    "52795000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061301",
    "Carvalho",
    "",
    "no",
    "846",
    "30135700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061302",
    "Figueira de Lorvão",
    "",
    "no",
    "2737",
    "26678000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061304",
    "Lorvão",
    "",
    "no",
    "3898",
    "26951400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061307",
    "Penacova",
    "",
    "no",
    "3254",
    "32416800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061310",
    "Sazes do Lorvão",
    "",
    "no",
    "749",
    "17856200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061312",
    "União das freguesias de Friúmes e Paradela",
    "",
    "no",
    "870",
    "22175300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061313",
    "União das freguesias de Oliveira do Mondego e Travanca do Mondego",
    "",
    "no",
    "1079",
    "22580200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061314",
    "União das freguesias de São Pedro de Alva e São Paio de Mondego",
    "",
    "no",
    "1818",
    "37938700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061401",
    "Cumeeira",
    "",
    "no",
    "1072",
    "21294400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061402",
    "Espinhal",
    "",
    "no",
    "775",
    "29384200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061403",
    "Podentes",
    "",
    "no",
    "485",
    "17278300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061407",
    "União das freguesias de São Miguel, Santa Eufémia e Rabaçal",
    "",
    "no",
    "3651",
    "66843100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061501",
    "Alfarelos",
    "",
    "no",
    "1439",
    "13984400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061504",
    "Figueiró do Campo",
    "",
    "no",
    "1507",
    "11270000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061506",
    "Granja do Ulmeiro",
    "",
    "no",
    "1866",
    "5051900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061508",
    "Samuel",
    "",
    "no",
    "1254",
    "31372900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061509",
    "Soure",
    "",
    "no",
    "7917",
    "92324600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061510",
    "Tapéus",
    "",
    "no",
    "338",
    "13868700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061511",
    "Vila Nova de Anços",
    "",
    "no",
    "1113",
    "20576300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061512",
    "Vinha da Rainha",
    "",
    "no",
    "1397",
    "20382900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061513",
    "União das freguesias de Degracias e Pombalinho",
    "",
    "no",
    "1260",
    "39473900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061514",
    "União das freguesias de Gesteira e Brunhós",
    "",
    "no",
    "1154",
    "16755100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061602",
    "Candosa",
    "",
    "no",
    "689",
    "11391200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061603",
    "Carapinha",
    "",
    "no",
    "402",
    "9417500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061608",
    "Midões",
    "",
    "no",
    "1725",
    "20067100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061609",
    "Mouronho",
    "",
    "no",
    "840",
    "24023800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061611",
    "Póvoa de Midões",
    "",
    "no",
    "582",
    "9520000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061612",
    "São João da Boa Vista",
    "",
    "no",
    "453",
    "9853400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061614",
    "Tábua",
    "",
    "no",
    "3542",
    "24811400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061616",
    "União das freguesias de Ázere e Covelo",
    "",
    "no",
    "933",
    "25474900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061617",
    "União das freguesias de Covas e Vila Nova de Oliveirinha",
    "",
    "no",
    "1378",
    "21867100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061618",
    "União das freguesias de Espariz e Sinde",
    "",
    "no",
    "1006",
    "23524500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061619",
    "União das freguesias de Pinheiro de Coja e Meda de Mouros",
    "",
    "no",
    "521",
    "19835000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061701",
    "Arrifana",
    "",
    "no",
    "1440",
    "23842700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061702",
    "Lavegadas",
    "",
    "no",
    "204",
    "11264200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061703",
    "Poiares (Santo André)",
    "",
    "no",
    "4306",
    "28806900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "061704",
    "São Miguel de Poiares",
    "",
    "no",
    "1331",
    "20539200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070103",
    "Santiago Maior",
    "",
    "no",
    "2205",
    "112993900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070104",
    "Capelins (Santo António)",
    "",
    "no",
    "527",
    "87135500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070105",
    "Terena (São Pedro)",
    "",
    "no",
    "767",
    "82969500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070107",
    "União das freguesias de Alandroal (Nossa Senhora da Conceição), São Brás dos Matos (Mina do Bugalho) e Juromenha (Nossa Senhora do Loreto)",
    "",
    "no",
    "2344",
    "259579200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070201",
    "Arraiolos",
    "",
    "no",
    "3386",
    "146077000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070202",
    "Igrejinha",
    "",
    "no",
    "932",
    "84521200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070206",
    "Vimieiro",
    "",
    "no",
    "1589",
    "252557700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070208",
    "União das freguesias de Gafanhoeira (São Pedro) e Sabugueiro",
    "",
    "no",
    "890",
    "83402700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070209",
    "União das freguesias de São Gregório e Santa Justa",
    "",
    "no",
    "566",
    "117186900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070301",
    "Borba (Matriz)",
    "",
    "no",
    "3779",
    "41320100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070302",
    "Orada",
    "",
    "no",
    "740",
    "50808200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070303",
    "Rio de Moinhos",
    "",
    "no",
    "2056",
    "52854500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070304",
    "Borba (São Bartolomeu)",
    "",
    "no",
    "758",
    "203800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070401",
    "Arcos",
    "",
    "no",
    "1152",
    "23894100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070402",
    "Glória",
    "",
    "no",
    "532",
    "72746100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070404",
    "Évora Monte (Santa Maria)",
    "",
    "no",
    "569",
    "99384100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070411",
    "São Domingos de Ana Loura",
    "",
    "no",
    "341",
    "16297700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070413",
    "Veiros",
    "",
    "no",
    "1036",
    "39719200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070414",
    "União das freguesias de Estremoz (Santa Maria e Santo André)",
    "",
    "no",
    "8662",
    "63903800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070415",
    "União das freguesias de São Bento do Cortiço e Santo Estêvão",
    "",
    "no",
    "773",
    "56966900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070416",
    "União das freguesias de São Lourenço de Mamporcão e São Bento de Ana Loura",
    "",
    "no",
    "556",
    "43401300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070417",
    "União das freguesias do Ameixial (Santa Vitória e São Bento)",
    "",
    "no",
    "697",
    "97486300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070502",
    "Nossa Senhora da Graça do Divor",
    "",
    "no",
    "486",
    "84135700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070503",
    "Nossa Senhora de Machede",
    "",
    "no",
    "1123",
    "185189300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070506",
    "São Bento do Mato",
    "",
    "no",
    "1151",
    "66554400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070509",
    "São Miguel de Machede",
    "",
    "no",
    "794",
    "81524700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070513",
    "Torre de Coelheiros",
    "",
    "no",
    "715",
    "226239400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070515",
    "Canaviais",
    "",
    "no",
    "3442",
    "19412300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070522",
    "União das freguesias de Bacelo e Senhora da Saúde",
    "",
    "no",
    "18233",
    "46504800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070523",
    "União das freguesias de Évora (São Mamede, Sé, São Pedro e Santo Antão)",
    "",
    "no",
    "4738",
    "1131500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070524",
    "União das freguesias de Malagueira e Horta das Figueiras",
    "",
    "no",
    "22379",
    "64427200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070525",
    "União das freguesias de Nossa Senhora da Tourega e Nossa Senhora de Guadalupe",
    "",
    "no",
    "1151",
    "263342200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070526",
    "União das freguesias de São Manços e São Vicente do Pigeiro",
    "",
    "no",
    "1302",
    "193231700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070527",
    "União das freguesias de São Sebastião da Giesteira e Nossa Senhora da Boa Fé",
    "",
    "no",
    "1082",
    "75382600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070601",
    "Cabrela",
    "",
    "no",
    "649",
    "192259100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070605",
    "Santiago do Escoural",
    "",
    "no",
    "1335",
    "138704500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070606",
    "São Cristóvão",
    "",
    "no",
    "540",
    "145920500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070607",
    "Ciborro",
    "",
    "no",
    "714",
    "55493700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070610",
    "Foros de Vale de Figueira",
    "",
    "no",
    "1070",
    "67399200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070611",
    "União das freguesias de Cortiçadas de Lavre e Lavre",
    "",
    "no",
    "1561",
    "213698400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070612",
    "União das freguesias de Nossa Senhora da Vila, Nossa Senhora do Bispo e Silveiras",
    "",
    "no",
    "11568",
    "419491200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070701",
    "Brotas",
    "",
    "no",
    "451",
    "83205100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070702",
    "Cabeção",
    "",
    "no",
    "1073",
    "47427300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070703",
    "Mora",
    "",
    "no",
    "2522",
    "127702000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070704",
    "Pavia",
    "",
    "no",
    "932",
    "185615900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070801",
    "Granja",
    "",
    "no",
    "605",
    "92557100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070802",
    "Luz",
    "",
    "no",
    "290",
    "50855000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070803",
    "Mourão",
    "",
    "no",
    "1768",
    "135217700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070903",
    "Monte do Trigo",
    "",
    "no",
    "1240",
    "107111900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070905",
    "Portel",
    "",
    "no",
    "2661",
    "156438700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070906",
    "Santana",
    "",
    "no",
    "542",
    "41951600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070908",
    "Vera Cruz",
    "",
    "no",
    "458",
    "44615500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070909",
    "União das freguesias de Amieira e Alqueva",
    "",
    "no",
    "691",
    "177144600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "070910",
    "União das freguesias de São Bartolomeu do Outeiro e Oriola",
    "",
    "no",
    "836",
    "73743400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071001",
    "Montoito",
    "",
    "no",
    "1298",
    "61710700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071002",
    "Redondo",
    "",
    "no",
    "5733",
    "307798000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071102",
    "Corval",
    "",
    "no",
    "1389",
    "96411600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071103",
    "Monsaraz",
    "",
    "no",
    "782",
    "88294200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071104",
    "Reguengos de Monsaraz",
    "",
    "no",
    "7261",
    "101720200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071106",
    "União das freguesias de Campo e Campinho",
    "",
    "no",
    "1396",
    "177571200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071201",
    "Vendas Novas",
    "",
    "no",
    "11123",
    "157718100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071202",
    "Landeira",
    "",
    "no",
    "723",
    "64670700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071301",
    "Alcáçovas",
    "",
    "no",
    "2111",
    "268004700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071302",
    "Viana do Alentejo",
    "",
    "no",
    "2742",
    "94698700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071303",
    "Aguiar",
    "",
    "no",
    "890",
    "30969400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071401",
    "Bencatel",
    "",
    "no",
    "1679",
    "36208900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071402",
    "Ciladas",
    "",
    "no",
    "1071",
    "107513700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071404",
    "Pardais",
    "",
    "no",
    "546",
    "17949300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT187",
    "071406",
    "Nossa Senhora da Conceição e São Bartolomeu",
    "",
    "no",
    "5023",
    "33187000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080102",
    "Guia",
    "",
    "no",
    "4376",
    "26800200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080103",
    "Paderne",
    "",
    "no",
    "3304",
    "52561700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080104",
    "Ferreiras",
    "",
    "no",
    "6406",
    "20125400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080106",
    "Albufeira e Olhos de Água",
    "",
    "no",
    "26742",
    "41176900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080202",
    "Giões",
    "",
    "no",
    "256",
    "71798000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080203",
    "Martim Longo",
    "",
    "no",
    "1030",
    "128446600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080205",
    "Vaqueiros",
    "",
    "no",
    "497",
    "143944300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080206",
    "União das freguesias de Alcoutim e Pereiro",
    "",
    "no",
    "1134",
    "231174400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080301",
    "Aljezur",
    "",
    "no",
    "3365",
    "166759900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080302",
    "Bordeira",
    "",
    "no",
    "432",
    "79872900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080303",
    "Odeceixe",
    "",
    "no",
    "961",
    "41905700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080304",
    "Rogil",
    "",
    "no",
    "1126",
    "34961100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080401",
    "Azinhal",
    "",
    "no",
    "522",
    "68155900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080402",
    "Castro Marim",
    "",
    "no",
    "3267",
    "79348100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080403",
    "Odeleite",
    "",
    "no",
    "763",
    "142241000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080404",
    "Altura",
    "",
    "no",
    "2195",
    "11098700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080503",
    "Santa Bárbara de Nexe",
    "",
    "no",
    "4116",
    "38216400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080506",
    "Montenegro",
    "",
    "no",
    "8149",
    "21196800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080507",
    "União das freguesias de Conceição e Estoi",
    "",
    "no",
    "8176",
    "68401500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080508",
    "União das freguesias de Faro (Sé e São Pedro)",
    "",
    "no",
    "44578",
    "74753100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080602",
    "Ferragudo",
    "",
    "no",
    "1973",
    "5409500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080604",
    "Porches",
    "",
    "no",
    "2011",
    "15640600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080607",
    "União das freguesias de Estômbar e Parchal",
    "",
    "no",
    "9004",
    "28072400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080608",
    "União das freguesias de Lagoa e Carvoeiro",
    "",
    "no",
    "9987",
    "39132000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080703",
    "Luz",
    "",
    "no",
    "3545",
    "21783100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080704",
    "Odiáxere",
    "",
    "no",
    "2984",
    "31851300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080707",
    "União das freguesias de Bensafrim e Barão de São João",
    "",
    "no",
    "2425",
    "130204000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080708",
    "União das freguesias de Lagos (São Sebastião e Santa Maria)",
    "",
    "no",
    "22095",
    "29154400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080801",
    "Almancil",
    "",
    "no",
    "10677",
    "62299500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080802",
    "Alte",
    "",
    "no",
    "1997",
    "94333400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080803",
    "Ameixial",
    "",
    "no",
    "439",
    "123849500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080804",
    "Boliqueime",
    "",
    "no",
    "4973",
    "46212800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080805",
    "Quarteira",
    "",
    "no",
    "21798",
    "38156900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080807",
    "Salir",
    "",
    "no",
    "2775",
    "187750600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080808",
    "Loulé (São Clemente)",
    "",
    "no",
    "17358",
    "46195100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080809",
    "Loulé (São Sebastião)",
    "",
    "no",
    "7433",
    "62696300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "080812",
    "União de freguesias de Querença, Tôr e Benafim",
    "",
    "no",
    "2713",
    "102175100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080901",
    "Alferce",
    "",
    "no",
    "441",
    "96118300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080902",
    "Marmelete",
    "",
    "no",
    "787",
    "139905800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "080903",
    "Monchique",
    "",
    "no",
    "4817",
    "159280200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081003",
    "Olhão",
    "",
    "no",
    "14914",
    "12246500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081004",
    "Pechão",
    "",
    "no",
    "3601",
    "19787800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081005",
    "Quelfes",
    "",
    "no",
    "17246",
    "28197500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081006",
    "União das freguesias de Moncarapacho e Fuseta",
    "",
    "no",
    "9635",
    "70631900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081101",
    "Alvor",
    "",
    "no",
    "6154",
    "15253900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081102",
    "Mexilhoeira Grande",
    "",
    "no",
    "4029",
    "91152600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081103",
    "Portimão",
    "",
    "no",
    "45431",
    "75656400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081201",
    "São Brás de Alportel",
    "",
    "no",
    "10662",
    "153369200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081303",
    "Armação de Pêra",
    "",
    "no",
    "4867",
    "7990100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081305",
    "São Bartolomeu de Messines",
    "",
    "no",
    "8430",
    "239872100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081306",
    "São Marcos da Serra",
    "",
    "no",
    "1352",
    "166066100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081307",
    "Silves",
    "",
    "no",
    "11014",
    "174993000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081309",
    "União das freguesias de Alcantarilha e Pêra",
    "",
    "no",
    "4972",
    "46256100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081310",
    "União das freguesias de Algoz e Tunes",
    "",
    "no",
    "6491",
    "44885000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081401",
    "Cachopo",
    "",
    "no",
    "716",
    "203526500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081404",
    "Santa Catarina da Fonte do Bispo",
    "",
    "no",
    "1809",
    "117588200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT150",
    "081408",
    "Santa Luzia",
    "",
    "no",
    "1455",
    "8501100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081410",
    "União das freguesias de Conceição e Cabanas de Tavira",
    "",
    "no",
    "2519",
    "69444400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081411",
    "União das freguesias de Luz de Tavira e Santo Estêvão",
    "",
    "no",
    "4535",
    "59912300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081412",
    "União das freguesias de Tavira (Santa Maria e Santiago)",
    "",
    "no",
    "15133",
    "147994500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081501",
    "Barão de São Miguel",
    "",
    "no",
    "451",
    "14869200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081502",
    "Budens",
    "",
    "no",
    "1520",
    "45603400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081504",
    "Sagres",
    "",
    "no",
    "1909",
    "34369100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081506",
    "Vila do Bispo e Raposeira",
    "",
    "no",
    "1378",
    "84219000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081601",
    "Vila Nova de Cacela",
    "",
    "no",
    "3902",
    "46034300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081602",
    "Vila Real de Santo António",
    "",
    "no",
    "11946",
    "10990900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT150",
    "081603",
    "Monte Gordo",
    "",
    "no",
    "3308",
    "4224800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16G",
    "090102",
    "Carapito",
    "",
    "no",
    "442",
    "17259800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090103",
    "Cortiçada",
    "",
    "no",
    "341",
    "12653800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090105",
    "Dornelas",
    "",
    "no",
    "690",
    "23748700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090106",
    "Eirado",
    "",
    "no",
    "230",
    "9241700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090107",
    "Forninhos",
    "",
    "no",
    "222",
    "9617300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090109",
    "Pena Verde",
    "",
    "no",
    "813",
    "29400600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090110",
    "Pinheiro",
    "",
    "no",
    "232",
    "15883200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090114",
    "União das freguesias de Aguiar da Beira e Coruche",
    "",
    "no",
    "1631",
    "43357200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090115",
    "União das freguesias de Sequeiros e Gradiz",
    "",
    "no",
    "421",
    "23924800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "090116",
    "União das freguesias de Souto de Aguiar da Beira e Valverde",
    "",
    "no",
    "451",
    "21678600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090203",
    "Almeida",
    "",
    "no",
    "1314",
    "52423800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090207",
    "Castelo Bom",
    "",
    "no",
    "216",
    "25041400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090209",
    "Freineda",
    "",
    "no",
    "238",
    "29239500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090210",
    "Freixo",
    "",
    "no",
    "182",
    "17175300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090213",
    "Malhada Sorda",
    "",
    "no",
    "334",
    "45774200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090219",
    "Nave de Haver",
    "",
    "no",
    "358",
    "41133300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090224",
    "São Pedro de Rio Seco",
    "",
    "no",
    "181",
    "22585600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090227",
    "Vale da Mula",
    "",
    "no",
    "182",
    "16456400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090229",
    "Vilar Formoso",
    "",
    "no",
    "2219",
    "15136900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090230",
    "União das freguesias de Amoreira, Parada e Cabreira",
    "",
    "no",
    "383",
    "31395400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090231",
    "União das freguesias de Azinhal, Peva e Valverde",
    "",
    "no",
    "326",
    "47046900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090232",
    "União das freguesias de Castelo Mendo, Ade, Monteperobolso e Mesquitela",
    "",
    "no",
    "266",
    "41882900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090233",
    "União das freguesias de Junça e Naves",
    "",
    "no",
    "192",
    "32395600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090234",
    "União das freguesias de Leomil, Mido, Senouras e Aldeia Nova",
    "",
    "no",
    "221",
    "42422800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090235",
    "União das freguesias de Malpartida e Vale de Coelha",
    "",
    "no",
    "215",
    "29006700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090236",
    "União das freguesias de Miuzela e Porto de Ovelha",
    "",
    "no",
    "415",
    "28867900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090302",
    "Baraçal",
    "",
    "no",
    "227",
    "12223700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090304",
    "Carrapichana",
    "",
    "no",
    "216",
    "5597900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090306",
    "Forno Telheiro",
    "",
    "no",
    "735",
    "20763200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090307",
    "Lajeosa do Mondego",
    "",
    "no",
    "698",
    "12460800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090308",
    "Linhares",
    "",
    "no",
    "259",
    "15713300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090309",
    "Maçal do Chão",
    "",
    "no",
    "160",
    "15116600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090310",
    "Mesquitela",
    "",
    "no",
    "238",
    "17012000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090311",
    "Minhocal",
    "",
    "no",
    "175",
    "10750600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090312",
    "Prados",
    "",
    "no",
    "180",
    "14234300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090314",
    "Ratoeira",
    "",
    "no",
    "303",
    "7743000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090318",
    "Vale de Azares",
    "",
    "no",
    "400",
    "9054500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090322",
    "Casas do Soeiro",
    "",
    "no",
    "499",
    "5997400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090323",
    "União das freguesias de Açores e Velosa",
    "",
    "no",
    "466",
    "20943600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090324",
    "União das freguesias de Celorico (São Pedro e Santa Maria) e Vila Boa do Mondego",
    "",
    "no",
    "2385",
    "41098500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090325",
    "União das freguesias de Cortiçô da Serra, Vide entre Vinhas e Salgueirais",
    "",
    "no",
    "450",
    "22336100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090326",
    "União das freguesias de Rapa e Cadafaz",
    "",
    "no",
    "302",
    "16171000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090403",
    "Castelo Rodrigo",
    "",
    "no",
    "517",
    "32943400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090406",
    "Escalhão",
    "",
    "no",
    "770",
    "78807400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090408",
    "Figueira de Castelo Rodrigo",
    "",
    "no",
    "2211",
    "27880800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090410",
    "Mata de Lobos",
    "",
    "no",
    "383",
    "36972900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090415",
    "Vermiosa",
    "",
    "no",
    "394",
    "40055500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090418",
    "União das freguesias de Algodres, Vale de Afonsinho e Vilar de Amargo",
    "",
    "no",
    "535",
    "72361700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090419",
    "União das freguesias de Almofala e Escarigo",
    "",
    "no",
    "280",
    "47336700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090420",
    "União das freguesias de Cinco Vilas e Reigada",
    "",
    "no",
    "397",
    "41590600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090421",
    "União das freguesias de Freixeda do Torrão, Quintã de Pêro Martins e Penha de Águia",
    "",
    "no",
    "518",
    "57725500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090422",
    "União das freguesias do Colmeal e Vilar Torpim",
    "",
    "no",
    "255",
    "72900100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090501",
    "Algodres",
    "",
    "no",
    "349",
    "10150900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090502",
    "Casal Vasco",
    "",
    "no",
    "227",
    "6734100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090504",
    "Figueiró da Granja",
    "",
    "no",
    "414",
    "11680800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090505",
    "Fornos de Algodres",
    "",
    "no",
    "1627",
    "15445100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090507",
    "Infias",
    "",
    "no",
    "242",
    "2781600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090509",
    "Maceira",
    "",
    "no",
    "229",
    "8060500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090510",
    "Matança",
    "",
    "no",
    "243",
    "13815700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090511",
    "Muxagata",
    "",
    "no",
    "241",
    "9960500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090512",
    "Queiriz",
    "",
    "no",
    "260",
    "9736500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090517",
    "União das freguesias de Cortiçô e Vila Chã",
    "",
    "no",
    "226",
    "8044500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090518",
    "União das freguesias de Juncais, Vila Ruiva e Vila Soeiro do Chão",
    "",
    "no",
    "631",
    "19871300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090519",
    "União das freguesias de Sobral Pichorro e Fuinhas",
    "",
    "no",
    "300",
    "15168800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090602",
    "Arcozelo",
    "",
    "no",
    "717",
    "24023900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090603",
    "Cativelos",
    "",
    "no",
    "724",
    "14106800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090605",
    "Folgosinho",
    "",
    "no",
    "499",
    "51693500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090612",
    "Nespereira",
    "",
    "no",
    "758",
    "5384600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090613",
    "Paços da Serra",
    "",
    "no",
    "601",
    "10395500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090614",
    "Ribamondego",
    "",
    "no",
    "317",
    "7553900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090617",
    "São Paio",
    "",
    "no",
    "828",
    "15573600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090619",
    "Vila Cortês da Serra",
    "",
    "no",
    "267",
    "11062900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090620",
    "Vila Franca da Serra",
    "",
    "no",
    "262",
    "11012300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090621",
    "Vila Nova de Tazem",
    "",
    "no",
    "1708",
    "15953600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090623",
    "União das freguesias de Aldeias e Mangualde da Serra",
    "",
    "no",
    "492",
    "37546300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090624",
    "União das freguesias de Figueiró da Serra e Freixo da Serra",
    "",
    "no",
    "362",
    "12730400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090625",
    "Gouveia",
    "",
    "no",
    "3472",
    "35455800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090626",
    "União das freguesias de Melo e Nabais",
    "",
    "no",
    "903",
    "14446700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090627",
    "União das freguesias de Moimenta da Serra e Vinhó",
    "",
    "no",
    "1230",
    "14324000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090628",
    "União das freguesias de Rio Torto e Lagarinhos",
    "",
    "no",
    "906",
    "19347800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090703",
    "Aldeia do Bispo",
    "",
    "no",
    "220",
    "13169300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090704",
    "Aldeia Viçosa",
    "",
    "no",
    "341",
    "7439300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090705",
    "Alvendre",
    "",
    "no",
    "210",
    "12937300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090706",
    "Arrifana",
    "",
    "no",
    "661",
    "15820700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090708",
    "Avelãs da Ribeira",
    "",
    "no",
    "196",
    "11300600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090709",
    "Benespera",
    "",
    "no",
    "297",
    "18064000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090711",
    "Casal de Cinza",
    "",
    "no",
    "561",
    "17968300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090712",
    "Castanheira",
    "",
    "no",
    "345",
    "24641200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090713",
    "Cavadoude",
    "",
    "no",
    "324",
    "6647900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090714",
    "Codesseiro",
    "",
    "no",
    "205",
    "9622000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090716",
    "Faia",
    "",
    "no",
    "227",
    "10001200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090717",
    "Famalicão",
    "",
    "no",
    "615",
    "16016400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090718",
    "Fernão Joanes",
    "",
    "no",
    "269",
    "25064600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090721",
    "Gonçalo Bocas",
    "",
    "no",
    "227",
    "6443800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090722",
    "João Antão",
    "",
    "no",
    "160",
    "8782400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090723",
    "Maçainhas",
    "",
    "no",
    "1081",
    "12200300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090724",
    "Marmeleiro",
    "",
    "no",
    "361",
    "29627600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090725",
    "Meios",
    "",
    "no",
    "197",
    "4834000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090728",
    "Panoias de Cima",
    "",
    "no",
    "608",
    "11389600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090729",
    "Pega",
    "",
    "no",
    "161",
    "10634800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090730",
    "Pêra do Moço",
    "",
    "no",
    "831",
    "20597600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090732",
    "Porto da Carne",
    "",
    "no",
    "385",
    "1983600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090734",
    "Ramela",
    "",
    "no",
    "218",
    "10158600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090738",
    "Santana da Azinha",
    "",
    "no",
    "459",
    "15943800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090744",
    "Sobral da Serra",
    "",
    "no",
    "242",
    "11202500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090746",
    "Vale de Estrela",
    "",
    "no",
    "394",
    "13938000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090747",
    "Valhelhas",
    "",
    "no",
    "396",
    "20177100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090748",
    "Vela",
    "",
    "no",
    "490",
    "21000400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090749",
    "Videmonte",
    "",
    "no",
    "478",
    "53920800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090750",
    "Vila Cortês do Mondego",
    "",
    "no",
    "298",
    "4383900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090751",
    "Vila Fernando",
    "",
    "no",
    "491",
    "16269500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090752",
    "Vila Franca do Deão",
    "",
    "no",
    "153",
    "12991100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090753",
    "Vila Garcia",
    "",
    "no",
    "320",
    "15327300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090757",
    "Gonçalo",
    "",
    "no",
    "1167",
    "27104400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090758",
    "Guarda",
    "",
    "no",
    "26565",
    "37656300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090759",
    "Jarmelo São Miguel",
    "",
    "no",
    "295",
    "17062700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090760",
    "Jarmelo São Pedro",
    "",
    "no",
    "311",
    "31079700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090761",
    "União de freguesias de Avelãs de Ambom e Rocamondo",
    "",
    "no",
    "158",
    "13336700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090762",
    "União de freguesias de Corujeira e Trinta",
    "",
    "no",
    "524",
    "12469900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090763",
    "União de freguesias de Mizarela, Pêro Soares e Vila Soeiro",
    "",
    "no",
    "246",
    "14017900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090764",
    "União de freguesias de Pousade e Albardo",
    "",
    "no",
    "270",
    "16887700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090765",
    "União de freguesias de Rochoso e Monte Margarida",
    "",
    "no",
    "300",
    "23659200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090766",
    "Adão",
    "",
    "no",
    "284",
    "28321700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090801",
    "Sameiro",
    "",
    "no",
    "343",
    "22028900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090802",
    "Manteigas (Santa Maria)",
    "",
    "no",
    "1418",
    "22300900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090803",
    "Manteigas (São Pedro)",
    "",
    "no",
    "1446",
    "60881100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090804",
    "Vale de Amoreira",
    "",
    "no",
    "223",
    "16764600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090901",
    "Aveloso",
    "",
    "no",
    "207",
    "7457900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090902",
    "Barreira",
    "",
    "no",
    "177",
    "25726700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090905",
    "Coriscada",
    "",
    "no",
    "208",
    "25187600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090907",
    "Longroiva",
    "",
    "no",
    "286",
    "41278100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090908",
    "Marialva",
    "",
    "no",
    "255",
    "19206300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090912",
    "Poço do Canto",
    "",
    "no",
    "443",
    "16218500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090914",
    "Rabaçal",
    "",
    "no",
    "278",
    "14040900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090915",
    "Ranhados",
    "",
    "no",
    "252",
    "25320200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090917",
    "União das freguesias de Mêda, Outeiro de Gatos e Fonte Longa",
    "",
    "no",
    "2464",
    "50945300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090918",
    "União das freguesias de Prova e Casteição",
    "",
    "no",
    "306",
    "26026100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "090919",
    "União das freguesias de Vale Flor, Carvalhal e Pai Penela",
    "",
    "no",
    "326",
    "34641600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091009",
    "Ervedosa",
    "",
    "no",
    "190",
    "12842300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091010",
    "Freixedas",
    "",
    "no",
    "905",
    "33108700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091012",
    "Lamegal",
    "",
    "no",
    "253",
    "21962400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091013",
    "Lameiras",
    "",
    "no",
    "290",
    "17763400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091014",
    "Manigoto",
    "",
    "no",
    "186",
    "15886800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091015",
    "Pala",
    "",
    "no",
    "543",
    "14241200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091017",
    "Pinhel",
    "",
    "no",
    "3518",
    "44652100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091018",
    "Pínzio",
    "",
    "no",
    "453",
    "27130000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091024",
    "Souro Pires",
    "",
    "no",
    "588",
    "15672600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091027",
    "Vascoveiro",
    "",
    "no",
    "186",
    "18088500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091028",
    "Agregação das freguesias Sul de Pinhel",
    "",
    "no",
    "434",
    "40818300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091029",
    "Alverca da Beira/Bouça Cova",
    "",
    "no",
    "567",
    "19733600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091030",
    "Terras de Massueime",
    "",
    "no",
    "274",
    "12393800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091031",
    "Valbom/Bogalhal",
    "",
    "no",
    "251",
    "32330000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091032",
    "Alto do Palurdo",
    "",
    "no",
    "242",
    "47307300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091033",
    "Vale do Côa",
    "",
    "no",
    "235",
    "52195300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091034",
    "Vale do Massueime",
    "",
    "no",
    "305",
    "24073400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091035",
    "União das freguesias de Atalaia e Safurdão",
    "",
    "no",
    "207",
    "34321600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091101",
    "Águas Belas",
    "",
    "no",
    "175",
    "20568500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091102",
    "Aldeia do Bispo",
    "",
    "no",
    "286",
    "13137000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091103",
    "Aldeia da Ponte",
    "",
    "no",
    "317",
    "36690700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091106",
    "Aldeia Velha",
    "",
    "no",
    "431",
    "20878800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091107",
    "Alfaiates",
    "",
    "no",
    "331",
    "31434300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091109",
    "Baraçal",
    "",
    "no",
    "190",
    "16034500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091110",
    "Bendada",
    "",
    "no",
    "580",
    "34598900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091111",
    "Bismula",
    "",
    "no",
    "193",
    "19129600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091112",
    "Casteleiro",
    "",
    "no",
    "365",
    "44502200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091113",
    "Cerdeira",
    "",
    "no",
    "229",
    "23428700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091114",
    "Fóios",
    "",
    "no",
    "362",
    "28309700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091118",
    "Malcata",
    "",
    "no",
    "332",
    "21250000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091120",
    "Nave",
    "",
    "no",
    "230",
    "27126400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091123",
    "Quadrazais",
    "",
    "no",
    "457",
    "40611600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091124",
    "Quintas de São Bartolomeu",
    "",
    "no",
    "180",
    "10637200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091125",
    "Rapoula do Côa",
    "",
    "no",
    "195",
    "7939100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091126",
    "Rebolosa",
    "",
    "no",
    "222",
    "8976300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091127",
    "Rendo",
    "",
    "no",
    "278",
    "21511900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091133",
    "Sortelha",
    "",
    "no",
    "444",
    "39637600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091134",
    "Souto",
    "",
    "no",
    "1224",
    "28088600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091136",
    "Vale de Espinho",
    "",
    "no",
    "393",
    "31608200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091138",
    "Vila Boa",
    "",
    "no",
    "243",
    "8615500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091139",
    "Vila do Touro",
    "",
    "no",
    "183",
    "23313000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091141",
    "União das freguesias de Aldeia da Ribeira, Vilar Maior e Badamalos",
    "",
    "no",
    "347",
    "68785100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091142",
    "União das freguesias de Lajeosa e Forcalhos",
    "",
    "no",
    "289",
    "28930100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091143",
    "União das freguesias de Pousafoles do Bispo, Pena Lobo e Lomba",
    "",
    "no",
    "475",
    "38163700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091144",
    "União das freguesias de Ruvina, Ruivós e Vale das Éguas",
    "",
    "no",
    "221",
    "18424300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091145",
    "União das freguesias do Sabugal e Aldeia de Santo António",
    "",
    "no",
    "2741",
    "56337700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091146",
    "União das freguesias de Santo Estêvão e Moita",
    "",
    "no",
    "413",
    "29001700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091147",
    "União das freguesias de Seixo do Côa e Vale Longo",
    "",
    "no",
    "218",
    "25027400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091201",
    "Alvoco da Serra",
    "",
    "no",
    "466",
    "37568200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091205",
    "Girabolhos",
    "",
    "no",
    "317",
    "17736500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091207",
    "Loriga",
    "",
    "no",
    "1053",
    "36250300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091208",
    "Paranhos",
    "",
    "no",
    "1503",
    "21229100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091209",
    "Pinhanços",
    "",
    "no",
    "716",
    "8325500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091210",
    "Sabugueiro",
    "",
    "no",
    "478",
    "40069300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091212",
    "Sandomil",
    "",
    "no",
    "917",
    "13223100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091213",
    "Santa Comba",
    "",
    "no",
    "834",
    "11825200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091216",
    "Santiago",
    "",
    "no",
    "1205",
    "7434900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091219",
    "Sazes da Beira",
    "",
    "no",
    "283",
    "7792100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091221",
    "Teixeira",
    "",
    "no",
    "187",
    "15921100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091224",
    "Travancinha",
    "",
    "no",
    "472",
    "12470500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091225",
    "Valezim",
    "",
    "no",
    "310",
    "12085200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091228",
    "Vila Cova à Coelheira",
    "",
    "no",
    "404",
    "7676300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091230",
    "União das freguesias de Carragozela e Várzea de Meruge",
    "",
    "no",
    "629",
    "10078700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091231",
    "União das freguesias de Sameice e Santa Eulália",
    "",
    "no",
    "638",
    "14269500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091232",
    "União das freguesias de Santa Marinha e São Martinho",
    "",
    "no",
    "1629",
    "15081000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091233",
    "União das freguesias de Seia, São Romão e Lapa dos Dinheiros",
    "",
    "no",
    "9379",
    "53795600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091234",
    "União das freguesias de Torrozelo e Folhadosa",
    "",
    "no",
    "808",
    "10204300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091235",
    "União das freguesias de Tourais e Lajes",
    "",
    "no",
    "1713",
    "26177300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091236",
    "União das freguesias de Vide e Cabeça",
    "",
    "no",
    "761",
    "56474600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091301",
    "Aldeia Nova",
    "",
    "no",
    "332",
    "26811100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091303",
    "Castanheira",
    "",
    "no",
    "194",
    "9993400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091304",
    "Cogula",
    "",
    "no",
    "195",
    "4636900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091305",
    "Cótimos",
    "",
    "no",
    "220",
    "13475300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091307",
    "Fiães",
    "",
    "no",
    "273",
    "9624000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091309",
    "Granja",
    "",
    "no",
    "151",
    "9249900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091310",
    "Guilheiro",
    "",
    "no",
    "184",
    "13679300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091311",
    "Moimentinha",
    "",
    "no",
    "229",
    "6670400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091312",
    "Moreira de Rei",
    "",
    "no",
    "508",
    "32929200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091313",
    "Palhais",
    "",
    "no",
    "196",
    "4323900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091314",
    "Póvoa do Concelho",
    "",
    "no",
    "276",
    "10834200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091315",
    "Reboleiro",
    "",
    "no",
    "324",
    "4493500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091316",
    "Rio de Mel",
    "",
    "no",
    "323",
    "23359000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091321",
    "Tamanhos",
    "",
    "no",
    "250",
    "8320600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091325",
    "Valdujo",
    "",
    "no",
    "185",
    "15310700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091330",
    "União das freguesias de Freches e Torres",
    "",
    "no",
    "593",
    "23854000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091331",
    "União das freguesias de Torre do Terrenho, Sebadelhe da Serra e Terrenho",
    "",
    "no",
    "401",
    "29394800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091332",
    "União das freguesias de Trancoso (São Pedro e Santa Maria) e Souto Maior",
    "",
    "no",
    "3420",
    "58037700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091333",
    "União das freguesias de Vale do Seixo e Vila Garcia",
    "",
    "no",
    "245",
    "20349900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091334",
    "União das freguesias de Vila Franca das Naves e Feital",
    "",
    "no",
    "1030",
    "16037100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16J",
    "091335",
    "União das freguesias de Vilares e Carnicães",
    "",
    "no",
    "349",
    "20139800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091401",
    "Almendra",
    "",
    "no",
    "386",
    "54406500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091402",
    "Castelo Melhor",
    "",
    "no",
    "228",
    "36772300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091403",
    "Cedovim",
    "",
    "no",
    "338",
    "32104200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091404",
    "Chãs",
    "",
    "no",
    "278",
    "17601900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091405",
    "Custóias",
    "",
    "no",
    "202",
    "10870300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091407",
    "Horta",
    "",
    "no",
    "242",
    "10066600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091410",
    "Muxagata",
    "",
    "no",
    "309",
    "26534200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091411",
    "Numão",
    "",
    "no",
    "240",
    "23049800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091412",
    "Santa Comba",
    "",
    "no",
    "208",
    "30541800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091414",
    "Sebadelhe",
    "",
    "no",
    "265",
    "8078600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091415",
    "Seixas",
    "",
    "no",
    "335",
    "12211200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091416",
    "Touça",
    "",
    "no",
    "235",
    "9394100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091418",
    "Freixo de Numão",
    "",
    "no",
    "609",
    "36349400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "091419",
    "Vila Nova de Foz Côa",
    "",
    "no",
    "3437",
    "90170800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100102",
    "Alfeizerão",
    "",
    "no",
    "3854",
    "27986800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100104",
    "Bárrio",
    "",
    "no",
    "1523",
    "15012800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100105",
    "Benedita",
    "",
    "no",
    "8635",
    "29175500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100106",
    "Cela",
    "",
    "no",
    "3264",
    "25827100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100108",
    "Évora de Alcobaça",
    "",
    "no",
    "4485",
    "42423800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100109",
    "Maiorga",
    "",
    "no",
    "2050",
    "10038100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100112",
    "São Martinho do Porto",
    "",
    "no",
    "2868",
    "14637300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100114",
    "Turquel",
    "",
    "no",
    "4561",
    "40567300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100116",
    "Vimeiro",
    "",
    "no",
    "1948",
    "20165700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100120",
    "Aljubarrota",
    "",
    "no",
    "6639",
    "47942000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100121",
    "União das freguesias de Alcobaça e Vestiaria",
    "",
    "no",
    "7009",
    "9806100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100122",
    "União das freguesias de Coz, Alpedriz e Montes",
    "",
    "no",
    "3261",
    "37474400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100123",
    "União das freguesias de Pataias e Martingança",
    "",
    "no",
    "6591",
    "87083900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "100201",
    "Almoster",
    "",
    "no",
    "674",
    "25840400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100204",
    "Maçãs de Dona Maria",
    "",
    "no",
    "1835",
    "24542600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100205",
    "Pelmá",
    "",
    "no",
    "736",
    "30394900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100208",
    "Alvaiázere",
    "",
    "no",
    "2049",
    "38516900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100209",
    "Pussos São Pedro",
    "",
    "no",
    "1993",
    "41182800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100301",
    "Alvorge",
    "",
    "no",
    "1227",
    "39045200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100303",
    "Avelar",
    "",
    "no",
    "2169",
    "8495800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100304",
    "Chão de Couce",
    "",
    "no",
    "1992",
    "23794900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100306",
    "Pousaflores",
    "",
    "no",
    "950",
    "25274600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100307",
    "Santiago da Guarda",
    "",
    "no",
    "3111",
    "41233800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100309",
    "Ansião",
    "",
    "no",
    "3643",
    "38250000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100401",
    "Batalha",
    "",
    "no",
    "8548",
    "28416400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100402",
    "Reguengo do Fetal",
    "",
    "no",
    "2169",
    "28165500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100403",
    "São Mamede",
    "",
    "no",
    "3560",
    "41771600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100404",
    "Golpilheira",
    "",
    "no",
    "1528",
    "5062500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100502",
    "Carvalhal",
    "",
    "no",
    "2634",
    "32342400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100503",
    "Roliça",
    "",
    "no",
    "2808",
    "22633900",
    "3",
    "no",
    "no",
    "no"
  ],
  ["PT16B", "100505", "Pó", "", "no", "930", "6769200", "3", "no", "no", "no"],
  [
    "PT16B",
    "100506",
    "União das freguesias do Bombarral e Vale Covo",
    "",
    "no",
    "6821",
    "29540000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100601",
    "A dos Francos",
    "",
    "no",
    "1701",
    "18932100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100602",
    "Alvorninha",
    "",
    "no",
    "2987",
    "37601400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100604",
    "Carvalhal Benfeito",
    "",
    "no",
    "1279",
    "13949000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100606",
    "Foz do Arelho",
    "",
    "no",
    "1339",
    "9623900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100607",
    "Landal",
    "",
    "no",
    "1051",
    "10205000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100608",
    "Nadadouro",
    "",
    "no",
    "1904",
    "10600800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100609",
    "Salir de Matos",
    "",
    "no",
    "2583",
    "24593200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100611",
    "Santa Catarina",
    "",
    "no",
    "3029",
    "19978600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100615",
    "Vidais",
    "",
    "no",
    "1155",
    "21485000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100617",
    "União das freguesias de Caldas da Rainha - Nossa Senhora do Pópulo, Coto e São Gregório",
    "",
    "no",
    "18417",
    "31688700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "100618",
    "União das freguesias de Caldas da Rainha - Santo Onofre e Serra do Bouro",
    "",
    "no",
    "11926",
    "27509300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "100619",
    "União das freguesias de Tornada e Salir do Porto",
    "",
    "no",
    "4358",
    "29527500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "100703",
    "União das freguesias de Castanheira de Pêra e Coentral",
    "",
    "no",
    "3191",
    "66774500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100801",
    "Aguda",
    "",
    "no",
    "1106",
    "39667700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100802",
    "Arega",
    "",
    "no",
    "870",
    "28641000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100803",
    "Campelo",
    "",
    "no",
    "278",
    "51640500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100806",
    "União das freguesias de Figueiró dos Vinhos e Bairradas",
    "",
    "no",
    "3915",
    "53490700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100901",
    "Amor",
    "",
    "no",
    "4747",
    "23484100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100902",
    "Arrabal",
    "",
    "no",
    "2684",
    "20085000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100907",
    "Caranguejeira",
    "",
    "no",
    "4691",
    "30989300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100909",
    "Coimbrão",
    "",
    "no",
    "1735",
    "52193800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "100913",
    "Maceira",
    "",
    "no",
    "9901",
    "47027000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100915",
    "Milagres",
    "",
    "no",
    "3071",
    "17354500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100921",
    "Regueira de Pontes",
    "",
    "no",
    "2221",
    "11546500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100925",
    "Bajouca",
    "",
    "no",
    "2004",
    "12273400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100926",
    "Bidoeira de Cima",
    "",
    "no",
    "2250",
    "15614400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100932",
    "União das freguesias de Colmeias e Memória",
    "",
    "no",
    "4085",
    "46567400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100933",
    "União das freguesias de Leiria, Pousos, Barreira e Cortes",
    "",
    "no",
    "31775",
    "52264500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100934",
    "União das freguesias de Marrazes e Barosa",
    "",
    "no",
    "24684",
    "32802300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100935",
    "União das freguesias de Monte Real e Carvide",
    "",
    "no",
    "5756",
    "26031300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "100936",
    "União das freguesias de Monte Redondo e Carreira",
    "",
    "no",
    "5564",
    "50911200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "100937",
    "União das freguesias de Parceiros e Azoia",
    "",
    "no",
    "6940",
    "22986400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100938",
    "União das freguesias de Santa Catarina da Serra e Chainça",
    "",
    "no",
    "4870",
    "41196600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100939",
    "União das freguesias de Santa Eufémia e Boa Vista",
    "",
    "no",
    "4072",
    "19547800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "100940",
    "União das freguesias de Souto da Carpalhosa e Ortigosa",
    "",
    "no",
    "5834",
    "42213100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101001",
    "Marinha Grande",
    "",
    "no",
    "31434",
    "135834500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101002",
    "Vieira de Leiria",
    "",
    "no",
    "5845",
    "43009000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101003",
    "Moita",
    "",
    "no",
    "1420",
    "8408400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101101",
    "Famalicão",
    "",
    "no",
    "1740",
    "21715000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101102",
    "Nazaré",
    "",
    "no",
    "10309",
    "42204600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101103",
    "Valado dos Frades",
    "",
    "no",
    "3109",
    "18514700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101201",
    "A dos Negros",
    "",
    "no",
    "1489",
    "17493800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "101202",
    "Amoreira",
    "",
    "no",
    "989",
    "19906600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101203",
    "Olho Marinho",
    "",
    "no",
    "1279",
    "18118100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101207",
    "Vau",
    "",
    "no",
    "952",
    "31892000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101208",
    "Gaeiras",
    "",
    "no",
    "2331",
    "10312800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "101209",
    "Usseira",
    "",
    "no",
    "953",
    "7240400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "101210",
    "Santa Maria, São Pedro e Sobral da Lagoa",
    "",
    "no",
    "3779",
    "36590700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101301",
    "Graça",
    "",
    "no",
    "786",
    "31436800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101302",
    "Pedrógão Grande",
    "",
    "no",
    "2550",
    "80252700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101303",
    "Vila Facaia",
    "",
    "no",
    "579",
    "17058000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "101402",
    "Atouguia da Baleia",
    "",
    "no",
    "8954",
    "47024200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101405",
    "Serra d'El-Rei",
    "",
    "no",
    "1401",
    "8924600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101406",
    "Ferrel",
    "",
    "no",
    "2649",
    "13792600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "101407",
    "Peniche",
    "",
    "no",
    "14749",
    "7808500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101501",
    "Abiul",
    "",
    "no",
    "2765",
    "54144500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101503",
    "Almagreira",
    "",
    "no",
    "3076",
    "42611000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101504",
    "Carnide",
    "",
    "no",
    "1738",
    "22312600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101505",
    "Carriço",
    "",
    "no",
    "3620",
    "83051500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101506",
    "Louriçal",
    "",
    "no",
    "4645",
    "47661800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101508",
    "Pelariga",
    "",
    "no",
    "2186",
    "26345800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101509",
    "Pombal",
    "",
    "no",
    "17225",
    "93975900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101510",
    "Redinha",
    "",
    "no",
    "2117",
    "41385100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101513",
    "Vermoil",
    "",
    "no",
    "2617",
    "22802500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101514",
    "Vila Cã",
    "",
    "no",
    "1607",
    "31569200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101515",
    "Meirinhas",
    "",
    "no",
    "1742",
    "8887800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101518",
    "União das freguesias de Guia, Ilha e Mata Mourisca",
    "",
    "no",
    "6489",
    "80370500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16F",
    "101519",
    "União das freguesias de Santiago e São Simão de Litém e Albergaria dos Doze",
    "",
    "no",
    "5418",
    "70884600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101602",
    "Alqueidão da Serra",
    "",
    "no",
    "1755",
    "22103100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101605",
    "Calvaria de Cima",
    "",
    "no",
    "2462",
    "10715400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101606",
    "Juncal",
    "",
    "no",
    "3316",
    "26635600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101608",
    "Mira de Aire",
    "",
    "no",
    "3775",
    "15623000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101609",
    "Pedreiras",
    "",
    "no",
    "2705",
    "13223100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101610",
    "São Bento",
    "",
    "no",
    "835",
    "41300100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101613",
    "Serro Ventoso",
    "",
    "no",
    "1026",
    "32097700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101614",
    "Porto de Mós - São João Baptista e São Pedro",
    "",
    "no",
    "6023",
    "28189800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101615",
    "União das freguesias de Alvados e Alcaria",
    "",
    "no",
    "741",
    "33306100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16F",
    "101616",
    "União das freguesias de Arrimal e Mendiga",
    "",
    "no",
    "1704",
    "38640000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110106",
    "Carnota",
    "",
    "no",
    "1678",
    "18086000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110107",
    "Meca",
    "",
    "no",
    "1719",
    "14124900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110108",
    "Olhalvo",
    "",
    "no",
    "1907",
    "8295600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110109",
    "Ota",
    "",
    "no",
    "1289",
    "46318900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110113",
    "Ventosa",
    "",
    "no",
    "2173",
    "22206100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110114",
    "Vila Verde dos Francos",
    "",
    "no",
    "1162",
    "28133700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110117",
    "União das freguesias de Abrigada e Cabanas de Torres",
    "",
    "no",
    "4309",
    "46150300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110118",
    "União das freguesias de Aldeia Galega da Merceana e Aldeia Gavinha",
    "",
    "no",
    "3221",
    "27958200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110119",
    "União das freguesias de Alenquer (Santo Estêvão e Triana)",
    "",
    "no",
    "10821",
    "50081000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110120",
    "União das freguesias de Carregado e Cadafais",
    "",
    "no",
    "13441",
    "24519800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110121",
    "União das freguesias de Ribafria e Pereiro de Palhacana",
    "",
    "no",
    "1547",
    "18344700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110201",
    "Arranhó",
    "",
    "no",
    "2531",
    "21474800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110202",
    "Arruda dos Vinhos",
    "",
    "no",
    "8656",
    "34378700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110203",
    "Cardosas",
    "",
    "no",
    "836",
    "6012800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110204",
    "Santiago dos Velhos",
    "",
    "no",
    "1368",
    "16093100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110301",
    "Alcoentre",
    "",
    "no",
    "3448",
    "47053300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110302",
    "Aveiras de Baixo",
    "",
    "no",
    "1317",
    "18895900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110303",
    "Aveiras de Cima",
    "",
    "no",
    "4762",
    "26155700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110304",
    "Azambuja",
    "",
    "no",
    "8069",
    "81109700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110306",
    "Vale do Paraíso",
    "",
    "no",
    "1001",
    "6733200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110307",
    "Vila Nova da Rainha",
    "",
    "no",
    "926",
    "24896800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "110310",
    "União das freguesias de Manique do Intendente, Vila Nova de São Pedro e Maçussa",
    "",
    "no",
    "2291",
    "57811900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110401",
    "Alguber",
    "",
    "no",
    "957",
    "19261600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110407",
    "Peral",
    "",
    "no",
    "905",
    "16462100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110409",
    "Vermelha",
    "",
    "no",
    "1288",
    "11987000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110410",
    "Vilar",
    "",
    "no",
    "1684",
    "16926800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110411",
    "União das freguesias do Cadaval e Pêro Moniz",
    "",
    "no",
    "3752",
    "38426300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110412",
    "União das freguesias de Lamas e Cercal",
    "",
    "no",
    "3632",
    "57961100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110413",
    "União das freguesias de Painho e Figueiros",
    "",
    "no",
    "2010",
    "13868000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110501",
    "Alcabideche",
    "",
    "no",
    "42162",
    "39767400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110506",
    "São Domingos de Rana",
    "",
    "no",
    "57502",
    "20364300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110507",
    "União das freguesias de Carcavelos e Parede",
    "",
    "no",
    "45007",
    "8109900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110508",
    "União das freguesias de Cascais e Estoril",
    "",
    "no",
    "61808",
    "29160100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110601",
    "Ajuda",
    "",
    "no",
    "15617",
    "2876600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110602",
    "Alcântara",
    "",
    "no",
    "13943",
    "5074800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110607",
    "Beato",
    "",
    "no",
    "12737",
    "2483800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110608",
    "Benfica",
    "",
    "no",
    "36985",
    "8024900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110610",
    "Campolide",
    "",
    "no",
    "15460",
    "2774300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110611",
    "Carnide",
    "",
    "no",
    "19218",
    "3689100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110618",
    "Lumiar",
    "",
    "no",
    "45605",
    "6574900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110621",
    "Marvila",
    "",
    "no",
    "37793",
    "7122400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110633",
    "Olivais",
    "",
    "no",
    "33788",
    "8088000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110639",
    "São Domingos de Benfica",
    "",
    "no",
    "33043",
    "4294300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110654",
    "Alvalade",
    "",
    "no",
    "31813",
    "5341700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110655",
    "Areeiro",
    "",
    "no",
    "20131",
    "1718900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110656",
    "Arroios",
    "",
    "no",
    "31653",
    "2127800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110657",
    "Avenidas Novas",
    "",
    "no",
    "21625",
    "2994500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110658",
    "Belém",
    "",
    "no",
    "16528",
    "10427600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110659",
    "Campo de Ourique",
    "",
    "no",
    "22120",
    "1651400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110660",
    "Estrela",
    "",
    "no",
    "20128",
    "4604000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110661",
    "Misericórdia",
    "",
    "no",
    "13044",
    "2192200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110662",
    "Parque das Nações",
    "",
    "no",
    "21025",
    "5435000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110663",
    "Penha de França",
    "",
    "no",
    "27967",
    "2710700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110664",
    "Santa Clara",
    "",
    "no",
    "22480",
    "3355500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110665",
    "Santa Maria Maior",
    "",
    "no",
    "12822",
    "3011600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110666",
    "Santo António",
    "",
    "no",
    "11836",
    "1494300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110667",
    "São Vicente",
    "",
    "no",
    "15339",
    "1985800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110702",
    "Bucelas",
    "",
    "no",
    "4663",
    "33969000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110705",
    "Fanhões",
    "",
    "no",
    "2801",
    "11629100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110707",
    "Loures",
    "",
    "no",
    "26769",
    "32815000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110708",
    "Lousa",
    "",
    "no",
    "3169",
    "16522100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110726",
    "União das freguesias de Moscavide e Portela",
    "",
    "no",
    "21891",
    "1656300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110727",
    "União das freguesias de Sacavém e Prior Velho",
    "",
    "no",
    "24822",
    "3885500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110728",
    "União das freguesias de Santa Iria de Azoia, São João da Talha e Bobadela",
    "",
    "no",
    "44331",
    "17591900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110729",
    "União das freguesias de Santo Antão e São Julião do Tojal",
    "",
    "no",
    "8053",
    "28408000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110730",
    "União das freguesias de Santo António dos Cavaleiros e Frielas",
    "",
    "no",
    "28052",
    "9197100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110731",
    "União das freguesias de Camarate, Unhos e Apelação",
    "",
    "no",
    "34943",
    "11565900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110803",
    "Moita dos Ferreiros",
    "",
    "no",
    "1734",
    "24825800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110805",
    "Reguengo Grande",
    "",
    "no",
    "1626",
    "15591200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "110806",
    "Santa Bárbara",
    "",
    "no",
    "1943",
    "7521600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110808",
    "Vimeiro",
    "",
    "no",
    "1470",
    "7077800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110810",
    "Ribamar",
    "",
    "no",
    "2141",
    "6110100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110812",
    "União das freguesias de Lourinhã e Atalaia",
    "",
    "no",
    "11755",
    "46480400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110813",
    "União das freguesias de Miragaia e Marteleira",
    "",
    "no",
    "3583",
    "19469100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "110814",
    "União das freguesias de São Bartolomeu dos Galegos e Moledo",
    "",
    "no",
    "1483",
    "20096000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110902",
    "Carvoeira",
    "",
    "no",
    "2155",
    "8212900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110904",
    "Encarnação",
    "",
    "no",
    "4798",
    "28511300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110906",
    "Ericeira",
    "",
    "no",
    "10260",
    "12050100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110909",
    "Mafra",
    "",
    "no",
    "17986",
    "47952700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110911",
    "Milharado",
    "",
    "no",
    "7023",
    "24431400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110913",
    "Santo Isidoro",
    "",
    "no",
    "3814",
    "24831900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110918",
    "União das freguesias de Azueira e Sobral da Abelheira",
    "",
    "no",
    "4316",
    "30627600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110919",
    "União das freguesias de Enxara do Bispo, Gradil e Vila Franca do Rosário",
    "",
    "no",
    "3837",
    "31645700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110920",
    "União das freguesias de Igreja Nova e Cheleiros",
    "",
    "no",
    "4384",
    "37065800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "110921",
    "União das freguesias de Malveira e São Miguel de Alcainça",
    "",
    "no",
    "8257",
    "16845300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "110922",
    "União das freguesias de Venda do Pinheiro e Santo Estêvão das Galés",
    "",
    "no",
    "9855",
    "29480300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111002",
    "Barcarena",
    "",
    "no",
    "13861",
    "9013300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111009",
    "Porto Salvo",
    "",
    "no",
    "15157",
    "7342900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111012",
    "União das freguesias de Algés, Linda-a-Velha e Cruz Quebrada-Dafundo",
    "",
    "no",
    "48665",
    "7182800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111013",
    "União das freguesias de Carnaxide e Queijas",
    "",
    "no",
    "36288",
    "8812800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111014",
    "União das freguesias de Oeiras e São Julião da Barra, Paço de Arcos e Caxias",
    "",
    "no",
    "58149",
    "13531300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111102",
    "Algueirão-Mem Martins",
    "",
    "no",
    "66250",
    "15995500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111105",
    "Colares",
    "",
    "no",
    "7628",
    "33371700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111108",
    "Rio de Mouro",
    "",
    "no",
    "47311",
    "16493800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111115",
    "Casal de Cambra",
    "",
    "no",
    "12701",
    "2169500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111122",
    "União das freguesias de Agualva e Mira-Sintra",
    "",
    "no",
    "41104",
    "5980600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111123",
    "União das freguesias de Almargem do Bispo, Pêro Pinheiro e Montelavar",
    "",
    "no",
    "16788",
    "64067500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111124",
    "União das freguesias do Cacém e São Marcos",
    "",
    "no",
    "38701",
    "4443800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111125",
    "União das freguesias de Massamá e Monte Abraão",
    "",
    "no",
    "48921",
    "3085800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111126",
    "União das freguesias de Queluz e Belas",
    "",
    "no",
    "52335",
    "26469300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111127",
    "União das freguesias de São João das Lampas e Terrugem",
    "",
    "no",
    "16505",
    "83597100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111128",
    "União das freguesias de Sintra (Santa Maria e São Miguel, São Martinho e São Pedro de Penaferrim)",
    "",
    "no",
    "29591",
    "63552500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111201",
    "Santo Quintino",
    "",
    "no",
    "3706",
    "29001800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111202",
    "Sapataria",
    "",
    "no",
    "3044",
    "14404600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111203",
    "Sobral de Monte Agraço",
    "",
    "no",
    "3406",
    "8696800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111306",
    "Freiria",
    "",
    "no",
    "2461",
    "13432700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111310",
    "Ponte do Rol",
    "",
    "no",
    "2444",
    "9672800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111311",
    "Ramalhal",
    "",
    "no",
    "3472",
    "36835200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111314",
    "São Pedro da Cadeira",
    "",
    "no",
    "5077",
    "23851900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111316",
    "Silveira",
    "",
    "no",
    "8530",
    "24968200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111317",
    "Turcifal",
    "",
    "no",
    "3342",
    "24700200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111318",
    "Ventosa",
    "",
    "no",
    "5276",
    "25981200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111321",
    "União das freguesias de A dos Cunhados e Maceira",
    "",
    "no",
    "10391",
    "52722900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT16B",
    "111322",
    "União das freguesias de Campelos e Outeiro da Cabeça",
    "",
    "no",
    "3667",
    "29963200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111323",
    "União das freguesias de Carvoeira e Carmões",
    "",
    "no",
    "2414",
    "20967500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111324",
    "União das freguesias de Dois Portos e Runa",
    "",
    "no",
    "3128",
    "43225900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111325",
    "União das freguesias de Maxial e Monte Redondo",
    "",
    "no",
    "3546",
    "38386400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16B",
    "111326",
    "União das freguesias de Torres Vedras (São Pedro, Santiago, Santa Maria do Castelo e São Miguel) e Matacães",
    "",
    "no",
    "25717",
    "62440800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111408",
    "Vialonga",
    "",
    "no",
    "21033",
    "17929000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111409",
    "Vila Franca de Xira",
    "",
    "no",
    "18197",
    "212869600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111412",
    "União das freguesias de Alhandra, São João dos Montes e Calhandriz",
    "",
    "no",
    "12866",
    "27535400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111413",
    "União das freguesias de Alverca do Ribatejo e Sobralinho",
    "",
    "no",
    "36120",
    "23918000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111414",
    "União das freguesias de Castanheira do Ribatejo e Cachoeiras",
    "",
    "no",
    "8266",
    "26781100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "111415",
    "União das freguesias de Póvoa de Santa Iria e Forte da Casa",
    "",
    "no",
    "40404",
    "9161000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111512",
    "Alfragide",
    "",
    "no",
    "17044",
    "2511200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111513",
    "Águas Livres",
    "",
    "no",
    "37426",
    "2212800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111514",
    "Encosta do Sol",
    "",
    "no",
    "28261",
    "2802000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111515",
    "Falagueira-Venda Nova",
    "",
    "no",
    "23186",
    "2857400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111516",
    "Mina de Água",
    "",
    "no",
    "43927",
    "8092200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111517",
    "Venteira",
    "",
    "no",
    "25292",
    "5309200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111603",
    "Odivelas",
    "",
    "no",
    "59578",
    "5044500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111608",
    "União das freguesias de Pontinha e Famões",
    "",
    "no",
    "34111",
    "9210300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111609",
    "União das freguesias de Póvoa de Santo Adrião e Olival Basto",
    "",
    "no",
    "18872",
    "2629700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "111610",
    "União das freguesias de Ramada e Caneças",
    "",
    "no",
    "32581",
    "9659100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120101",
    "Alter do Chão",
    "",
    "no",
    "2373",
    "140851500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120102",
    "Chancelaria",
    "",
    "no",
    "448",
    "71700700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120103",
    "Seda",
    "",
    "no",
    "352",
    "112434500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120104",
    "Cunheira",
    "",
    "no",
    "389",
    "37079500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120201",
    "Assunção",
    "",
    "no",
    "1970",
    "204508700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120202",
    "Esperança",
    "",
    "no",
    "739",
    "57147900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120203",
    "Mosteiros",
    "",
    "no",
    "456",
    "52990600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120302",
    "Aldeia Velha",
    "",
    "no",
    "280",
    "126109400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120303",
    "Avis",
    "",
    "no",
    "1840",
    "92088600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120305",
    "Ervedal",
    "",
    "no",
    "560",
    "38074800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120306",
    "Figueira e Barros",
    "",
    "no",
    "309",
    "70264500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120309",
    "União das freguesias de Alcórrego e Maranhão",
    "",
    "no",
    "464",
    "128753900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120310",
    "União das freguesias de Benavila e Valongo",
    "",
    "no",
    "1118",
    "150673900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120401",
    "Nossa Senhora da Expectação",
    "",
    "no",
    "3974",
    "105064700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120402",
    "Nossa Senhora da Graça dos Degolados",
    "",
    "no",
    "587",
    "35751100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120403",
    "São João Baptista",
    "",
    "no",
    "3895",
    "106385800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120501",
    "Nossa Senhora da Graça de Póvoa e Meadas",
    "",
    "no",
    "606",
    "73545700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120502",
    "Santa Maria da Devesa",
    "",
    "no",
    "1578",
    "56334000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120503",
    "Santiago Maior",
    "",
    "no",
    "358",
    "58833800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120504",
    "São João Baptista",
    "",
    "no",
    "865",
    "76198900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120601",
    "Aldeia da Mata",
    "",
    "no",
    "374",
    "37284100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120604",
    "Gáfete",
    "",
    "no",
    "856",
    "46147700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120605",
    "Monte da Pedra",
    "",
    "no",
    "280",
    "60075700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120607",
    "União das freguesias de Crato e Mártires, Flor da Rosa e Vale do Peso",
    "",
    "no",
    "2198",
    "254561400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120706",
    "Santa Eulália",
    "",
    "no",
    "1198",
    "98517900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120707",
    "São Brás e São Lourenço",
    "",
    "no",
    "1684",
    "47634200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120708",
    "São Vicente e Ventosa",
    "",
    "no",
    "801",
    "101678300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120712",
    "Assunção, Ajuda, Salvador e Santo Ildefonso",
    "",
    "no",
    "9688",
    "98662200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120713",
    "Caia, São Pedro e Alcáçova",
    "",
    "no",
    "6253",
    "104042900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120714",
    "União das freguesias de Barbacena e Vila Fernando",
    "",
    "no",
    "979",
    "82530900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120715",
    "União das freguesias de Terrugem e Vila Boim",
    "",
    "no",
    "2475",
    "98222200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120801",
    "Cabeço de Vide",
    "",
    "no",
    "1063",
    "65808100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120802",
    "Fronteira",
    "",
    "no",
    "2069",
    "141393300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120803",
    "São Saturnino",
    "",
    "no",
    "278",
    "41394500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120902",
    "Belver",
    "",
    "no",
    "684",
    "69838900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120903",
    "Comenda",
    "",
    "no",
    "890",
    "90021600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120905",
    "Margem",
    "",
    "no",
    "811",
    "56852900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "120906",
    "União das freguesias de Gavião e Atalaia",
    "",
    "no",
    "1747",
    "77881100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121001",
    "Beirã",
    "",
    "no",
    "498",
    "44759800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121002",
    "Santa Maria de Marvão",
    "",
    "no",
    "486",
    "23352300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121003",
    "Santo António das Areias",
    "",
    "no",
    "1102",
    "35991300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121004",
    "São Salvador da Aramenha",
    "",
    "no",
    "1426",
    "50795600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121101",
    "Assumar",
    "",
    "no",
    "651",
    "63832200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121102",
    "Monforte",
    "",
    "no",
    "1384",
    "214736600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121103",
    "Santo Aleixo",
    "",
    "no",
    "638",
    "58505900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121104",
    "Vaiamonte",
    "",
    "no",
    "656",
    "83173500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121201",
    "Alpalhão",
    "",
    "no",
    "1238",
    "34233800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121205",
    "Montalvão",
    "",
    "no",
    "442",
    "124169000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121207",
    "Santana",
    "",
    "no",
    "404",
    "27193700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121208",
    "São Matias",
    "",
    "no",
    "289",
    "54663300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121210",
    "Tolosa",
    "",
    "no",
    "1011",
    "23528100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121211",
    "União das freguesias de Arez e Amieira do Tejo",
    "",
    "no",
    "497",
    "158227000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121212",
    "União das freguesias de Espírito Santo, Nossa Senhora da Graça e São Simão",
    "",
    "no",
    "3569",
    "153663500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121301",
    "Galveias",
    "",
    "no",
    "1061",
    "79829300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121302",
    "Montargil",
    "",
    "no",
    "2316",
    "296944400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121304",
    "Foros de Arrão",
    "",
    "no",
    "919",
    "84256000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121305",
    "Longomel",
    "",
    "no",
    "1228",
    "46970800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121308",
    "União das freguesias de Ponte de Sor, Tramaga e Vale de Açor",
    "",
    "no",
    "11198",
    "331711100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121401",
    "Alagoa",
    "",
    "no",
    "669",
    "18156300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121402",
    "Alegrete",
    "",
    "no",
    "1746",
    "86923800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121404",
    "Fortios",
    "",
    "no",
    "2018",
    "65853700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121410",
    "Urra",
    "",
    "no",
    "1934",
    "129982800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121411",
    "União das freguesias da Sé e São Lourenço",
    "",
    "no",
    "15642",
    "23608100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121412",
    "União das freguesias de Reguengo e São Julião",
    "",
    "no",
    "972",
    "72186500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121413",
    "União das freguesias de Ribeira de Nisa e Carreiras",
    "",
    "no",
    "1949",
    "50425300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121501",
    "Cano",
    "",
    "no",
    "1266",
    "49425400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121502",
    "Casa Branca",
    "",
    "no",
    "1232",
    "101004000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121503",
    "Santo Amaro",
    "",
    "no",
    "644",
    "39610100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT186",
    "121504",
    "Sousel",
    "",
    "no",
    "1932",
    "89282400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130103",
    "Ansiães",
    "",
    "no",
    "623",
    "27190100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130107",
    "Candemil",
    "",
    "no",
    "771",
    "12008800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130112",
    "Fregim",
    "",
    "no",
    "2836",
    "10369000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130115",
    "Fridão",
    "",
    "no",
    "863",
    "7869000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130117",
    "Gondar",
    "",
    "no",
    "1686",
    "9639400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130118",
    "Jazente",
    "",
    "no",
    "542",
    "3353900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130119",
    "Lomba",
    "",
    "no",
    "793",
    "3629300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130120",
    "Louredo",
    "",
    "no",
    "638",
    "3597700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130121",
    "Lufrei",
    "",
    "no",
    "1777",
    "6452800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130123",
    "Mancelos",
    "",
    "no",
    "3114",
    "12133300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130126",
    "Padronelo",
    "",
    "no",
    "884",
    "2484900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130128",
    "Rebordelo",
    "",
    "no",
    "365",
    "15657500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130129",
    "Salvador do Monte",
    "",
    "no",
    "1066",
    "7479400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130134",
    "Gouveia (São Simão)",
    "",
    "no",
    "633",
    "12492600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130135",
    "Telões",
    "",
    "no",
    "4226",
    "14472000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130136",
    "Travanca",
    "",
    "no",
    "2278",
    "8689700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130138",
    "Vila Caiz",
    "",
    "no",
    "3026",
    "8523200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130139",
    "Vila Chã do Marão",
    "",
    "no",
    "940",
    "6711500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130141",
    "União das freguesias de Aboadela, Sanche e Várzea",
    "",
    "no",
    "1675",
    "30448400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130142",
    "União das freguesias de Amarante (São Gonçalo), Madalena, Cepelos e Gatão",
    "",
    "no",
    "11840",
    "15212600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130143",
    "União das freguesias de Bustelo, Carneiro e Carvalho de Rei",
    "",
    "no",
    "1019",
    "23429100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130144",
    "União das freguesias de Figueiró (Santiago e Santa Cristina)",
    "",
    "no",
    "3828",
    "8114800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130145",
    "União das freguesias de Freixo de Cima e de Baixo",
    "",
    "no",
    "3643",
    "8815000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130146",
    "União das freguesias de Olo e Canadelo",
    "",
    "no",
    "492",
    "19514900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130147",
    "União das freguesias de Real, Ataíde e Oliveira",
    "",
    "no",
    "5006",
    "10962600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130148",
    "União das freguesias de Vila Garcia, Aboim e Chapa",
    "",
    "no",
    "1700",
    "12079800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130204",
    "Frende",
    "",
    "no",
    "656",
    "2900100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130205",
    "Gestaçô",
    "",
    "no",
    "1258",
    "14224500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130206",
    "Gove",
    "",
    "no",
    "2007",
    "11532300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130207",
    "Grilo",
    "",
    "no",
    "590",
    "5944100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130208",
    "Loivos do Monte",
    "",
    "no",
    "373",
    "8749400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130215",
    "Santa Marinha do Zêzere",
    "",
    "no",
    "2789",
    "10688900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130219",
    "Valadares",
    "",
    "no",
    "844",
    "9929900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130220",
    "Viariz",
    "",
    "no",
    "520",
    "6234800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130221",
    "União das freguesias de Ancede e Ribadouro",
    "",
    "no",
    "2777",
    "14360100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130222",
    "União das freguesias de Baião (Santa Leocádia) e Mesquinhata",
    "",
    "no",
    "881",
    "8566400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130223",
    "União das freguesias de Campelo e Ovil",
    "",
    "no",
    "3938",
    "31810800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130224",
    "União das freguesias de Loivos da Ribeira e Tresouras",
    "",
    "no",
    "853",
    "7174600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130225",
    "União das freguesias de Santa Cruz do Douro e São Tomé de Covelas",
    "",
    "no",
    "2085",
    "16113600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130226",
    "União das freguesias de Teixeira e Teixeiró",
    "",
    "no",
    "951",
    "26298700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130301",
    "Aião",
    "",
    "no",
    "856",
    "2778700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130302",
    "Airães",
    "",
    "no",
    "2486",
    "4010500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130305",
    "Friande",
    "",
    "no",
    "1838",
    "3287000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130306",
    "Idães",
    "",
    "no",
    "2496",
    "7111300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130307",
    "Jugueiros",
    "",
    "no",
    "1303",
    "7448600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130313",
    "Penacova",
    "",
    "no",
    "1130",
    "2999100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130314",
    "Pinheiro",
    "",
    "no",
    "1042",
    "3574400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130315",
    "Pombeiro de Ribavizela",
    "",
    "no",
    "2218",
    "4809000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130317",
    "Refontoura",
    "",
    "no",
    "2081",
    "3439300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130318",
    "Regilde",
    "",
    "no",
    "1284",
    "3081700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130319",
    "Revinhade",
    "",
    "no",
    "811",
    "3325600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130324",
    "Sendim",
    "",
    "no",
    "1627",
    "7029900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130334",
    "União das freguesias de Macieira da Lixa e Caramos",
    "",
    "no",
    "3815",
    "8634100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130335",
    "União das freguesias de Margaride (Santa Eulália), Várzea, Lagares, Varziela e Moure",
    "",
    "no",
    "17990",
    "17440500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130336",
    "União das freguesias de Pedreira, Rande e Sernande",
    "",
    "no",
    "3487",
    "6981800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130337",
    "União das freguesias de Torrados e Sousa",
    "",
    "no",
    "3465",
    "5206600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130338",
    "União das freguesias de Unhão e Lordelo",
    "",
    "no",
    "1157",
    "4955800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130339",
    "União das freguesias de Vila Cova da Lixa e Borba de Godim",
    "",
    "no",
    "6191",
    "13464800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130340",
    "União das freguesias de Vila Fria e Vizela (São Jorge)",
    "",
    "no",
    "1203",
    "3021800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130341",
    "União das freguesias de Vila Verde e Santão",
    "",
    "no",
    "1585",
    "3137100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130405",
    "Lomba",
    "",
    "no",
    "1505",
    "13696600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130408",
    "Rio Tinto",
    "",
    "no",
    "51515",
    "9438600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130412",
    "Baguim do Monte (Rio Tinto)",
    "",
    "no",
    "14102",
    "5456800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130413",
    "União das freguesias de Fânzeres e São Pedro da Cova",
    "",
    "no",
    "39586",
    "21961900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130414",
    "União das freguesias de Foz do Sousa e Covelo",
    "",
    "no",
    "7701",
    "30237700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130415",
    "União das freguesias de Gondomar (São Cosme), Valbom e Jovim",
    "",
    "no",
    "48600",
    "23318000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130416",
    "União das freguesias de Melres e Medas",
    "",
    "no",
    "5820",
    "27808000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130502",
    "Aveleda",
    "",
    "no",
    "2073",
    "3810800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130504",
    "Caíde de Rei",
    "",
    "no",
    "2529",
    "6733200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130510",
    "Lodares",
    "",
    "no",
    "2002",
    "3884000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130512",
    "Macieira",
    "",
    "no",
    "1344",
    "1547600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130513",
    "Meinedo",
    "",
    "no",
    "4052",
    "9310900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130515",
    "Nevogilde",
    "",
    "no",
    "2617",
    "3437700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130524",
    "Sousela",
    "",
    "no",
    "1797",
    "6724700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130525",
    "Torno",
    "",
    "no",
    "2542",
    "3754300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130526",
    "Vilar do Torno e Alentém",
    "",
    "no",
    "1342",
    "3774600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130527",
    "União das freguesias de Cernadelo e Lousada (São Miguel e Santa Margarida)",
    "",
    "no",
    "2166",
    "7336300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130528",
    "União das freguesias de Cristelos, Boim e Ordem",
    "",
    "no",
    "7411",
    "10362700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130529",
    "União das freguesias de Figueiras e Covas",
    "",
    "no",
    "2108",
    "4341800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130530",
    "União das freguesias de Lustosa e Barrosas (Santo Estêvão)",
    "",
    "no",
    "5775",
    "15903000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130531",
    "União das freguesias de Nespereira e Casais",
    "",
    "no",
    "3486",
    "4667700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130532",
    "União das freguesias de Silvares, Pias, Nogueira e Alvarenga",
    "",
    "no",
    "6143",
    "10490800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130601",
    "Águas Santas",
    "",
    "no",
    "27182",
    "8203300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130603",
    "Folgosa",
    "",
    "no",
    "3704",
    "10114500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130608",
    "Milheirós",
    "",
    "no",
    "4861",
    "3604200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130609",
    "Moreira",
    "",
    "no",
    "12890",
    "8672700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130613",
    "São Pedro Fins",
    "",
    "no",
    "1837",
    "4706800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130616",
    "Vila Nova da Telha",
    "",
    "no",
    "5886",
    "5943100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130617",
    "Pedrouços",
    "",
    "no",
    "11635",
    "2540900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130618",
    "Castêlo da Maia",
    "",
    "no",
    "18395",
    "19910400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130619",
    "Cidade da Maia",
    "",
    "no",
    "40134",
    "10416800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130620",
    "Nogueira e Silva Escura",
    "",
    "no",
    "7980",
    "8826600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130704",
    "Banho e Carvalhosa",
    "",
    "no",
    "1276",
    "4914000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130705",
    "Constance",
    "",
    "no",
    "1626",
    "4796700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130722",
    "Soalhães",
    "",
    "no",
    "3682",
    "24062500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130723",
    "Sobretâmega",
    "",
    "no",
    "1132",
    "2839200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130724",
    "Tabuado",
    "",
    "no",
    "1375",
    "6803900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130730",
    "Vila Boa do Bispo",
    "",
    "no",
    "3240",
    "12484800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130732",
    "Alpendorada, Várzea e Torrão",
    "",
    "no",
    "8485",
    "16819200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130733",
    "Avessadas e Rosém",
    "",
    "no",
    "1467",
    "11138100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130734",
    "Bem Viver",
    "",
    "no",
    "3877",
    "9585800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130735",
    "Santo Isidoro e Livração",
    "",
    "no",
    "2083",
    "4668900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130736",
    "Marco",
    "",
    "no",
    "11014",
    "17389300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130737",
    "Paredes de Viadores e Manhuncelos",
    "",
    "no",
    "1775",
    "13118300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130738",
    "Penhalonga e Paços de Gaiolo",
    "",
    "no",
    "2924",
    "18137200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130739",
    "Sande e São Lourenço do Douro",
    "",
    "no",
    "2869",
    "12617600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130740",
    "Várzea, Aliviada e Folhada",
    "",
    "no",
    "2771",
    "23185100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130741",
    "Vila Boa de Quires e Maureles",
    "",
    "no",
    "3854",
    "19329100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "130811",
    "União das freguesias de Custóias, Leça do Balio e Guifões",
    "",
    "no",
    "45716",
    "18835300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130812",
    "União das freguesias de Matosinhos e Leça da Palmeira",
    "",
    "no",
    "49486",
    "12155800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130813",
    "União das freguesias de Perafita, Lavra e Santa Cruz do Bispo",
    "",
    "no",
    "29407",
    "22649100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "130814",
    "União das freguesias de São Mamede de Infesta e Senhora da Hora",
    "",
    "no",
    "50869",
    "8779500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11C",
    "130902",
    "Carvalhosa",
    "",
    "no",
    "4583",
    "5988900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130904",
    "Eiriz",
    "",
    "no",
    "2303",
    "6024800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130905",
    "Ferreira",
    "",
    "no",
    "4341",
    "6745900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130906",
    "Figueiró",
    "",
    "no",
    "2496",
    "2851600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130908",
    "Freamunde",
    "",
    "no",
    "7789",
    "5151800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130910",
    "Meixomil",
    "",
    "no",
    "3676",
    "4377500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130913",
    "Penamaior",
    "",
    "no",
    "3819",
    "6718200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130914",
    "Raimonda",
    "",
    "no",
    "2576",
    "3366500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130916",
    "Seroa",
    "",
    "no",
    "3646",
    "6292700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130917",
    "Frazão Arreigada",
    "",
    "no",
    "6263",
    "7282900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130918",
    "Paços de Ferreira",
    "",
    "no",
    "9085",
    "6078000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "130919",
    "Sanfins Lamoso Codessos",
    "",
    "no",
    "5763",
    "10114000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131001",
    "Aguiar de Sousa",
    "",
    "no",
    "1631",
    "22377000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131002",
    "Astromil",
    "",
    "no",
    "1086",
    "1928300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131003",
    "Baltar",
    "",
    "no",
    "4818",
    "7414000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131004",
    "Beire",
    "",
    "no",
    "2040",
    "3308900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131008",
    "Cete",
    "",
    "no",
    "3113",
    "4675800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131009",
    "Cristelo",
    "",
    "no",
    "1891",
    "2023600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131010",
    "Duas Igrejas",
    "",
    "no",
    "3879",
    "3779700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131011",
    "Gandra",
    "",
    "no",
    "6974",
    "11755200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131013",
    "Lordelo",
    "",
    "no",
    "10025",
    "9758600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131014",
    "Louredo",
    "",
    "no",
    "1514",
    "2892800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131017",
    "Parada de Todeia",
    "",
    "no",
    "1848",
    "3493200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131018",
    "Rebordosa",
    "",
    "no",
    "9106",
    "10762300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131019",
    "Recarei",
    "",
    "no",
    "4631",
    "14603400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131020",
    "Sobreira",
    "",
    "no",
    "4300",
    "21959000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131021",
    "Sobrosa",
    "",
    "no",
    "2641",
    "4702300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131022",
    "Vandoma",
    "",
    "no",
    "2363",
    "5124600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131024",
    "Vilela",
    "",
    "no",
    "5160",
    "4683600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131025",
    "Paredes",
    "",
    "no",
    "19834",
    "21514600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131101",
    "Abragão",
    "",
    "no",
    "2341",
    "9532200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131102",
    "Boelhe",
    "",
    "no",
    "1642",
    "5086300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131103",
    "Bustelo",
    "",
    "no",
    "1697",
    "6857400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131104",
    "Cabeça Santa",
    "",
    "no",
    "2528",
    "6929500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131105",
    "Canelas",
    "",
    "no",
    "1649",
    "11818100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131106",
    "Capela",
    "",
    "no",
    "1044",
    "13248200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131107",
    "Castelões",
    "",
    "no",
    "1397",
    "4219800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131108",
    "Croca",
    "",
    "no",
    "1769",
    "6635800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131109",
    "Duas Igrejas",
    "",
    "no",
    "2466",
    "8102100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131110",
    "Eja",
    "",
    "no",
    "1037",
    "4929200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131112",
    "Fonte Arcada",
    "",
    "no",
    "1584",
    "4822300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131113",
    "Galegos",
    "",
    "no",
    "2669",
    "4567700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131115",
    "Irivo",
    "",
    "no",
    "2182",
    "3170200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131121",
    "Oldrões",
    "",
    "no",
    "2004",
    "4057300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131122",
    "Paço de Sousa",
    "",
    "no",
    "3891",
    "8604200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131125",
    "Perozelo",
    "",
    "no",
    "1346",
    "3991000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131128",
    "Rans",
    "",
    "no",
    "1914",
    "3053100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131129",
    "Rio de Moinhos",
    "",
    "no",
    "2886",
    "8211500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131132",
    "Recezinhos (São Mamede)",
    "",
    "no",
    "1439",
    "4251700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131133",
    "Recezinhos (São Martinho)",
    "",
    "no",
    "1791",
    "5236900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131134",
    "Sebolido",
    "",
    "no",
    "919",
    "5154600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131136",
    "Valpedre",
    "",
    "no",
    "1576",
    "6333500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131138",
    "Rio Mau",
    "",
    "no",
    "1407",
    "6133200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131139",
    "Penafiel",
    "",
    "no",
    "15552",
    "22522900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131140",
    "Luzim e Vila Cova",
    "",
    "no",
    "1640",
    "10603000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131141",
    "Guilhufe e Urrô",
    "",
    "no",
    "4001",
    "7321300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131142",
    "Lagares e Figueira",
    "",
    "no",
    "2866",
    "16641700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "131143",
    "Termas de São Vicente",
    "",
    "no",
    "5028",
    "10208100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131202",
    "Bonfim",
    "",
    "no",
    "24265",
    "3096300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131203",
    "Campanhã",
    "",
    "no",
    "32659",
    "8042600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131210",
    "Paranhos",
    "",
    "no",
    "44298",
    "7168100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131211",
    "Ramalde",
    "",
    "no",
    "38012",
    "5825000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131216",
    "União das freguesias de Aldoar, Foz do Douro e Nevogilde",
    "",
    "no",
    "28858",
    "6267900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131217",
    "União das freguesias de Cedofeita, Santo Ildefonso, Sé, Miragaia, São Nicolau e Vitória",
    "",
    "no",
    "40440",
    "5433300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131218",
    "União das freguesias de Lordelo do Ouro e Massarelos",
    "",
    "no",
    "29059",
    "5586900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131305",
    "Balazar",
    "",
    "no",
    "2543",
    "11607000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131307",
    "Estela",
    "",
    "no",
    "2307",
    "11536400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131308",
    "Laundos",
    "",
    "no",
    "2055",
    "8527200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131311",
    "Rates",
    "",
    "no",
    "2505",
    "13897600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131313",
    "União das freguesias de Aver-o-Mar, Amorim e Terroso",
    "",
    "no",
    "13987",
    "16642800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131314",
    "União das freguesias de Aguçadoura e Navais",
    "",
    "no",
    "5745",
    "7399800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131315",
    "União das freguesias da Póvoa de Varzim, Beiriz e Argivai",
    "",
    "no",
    "34266",
    "12595200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131401",
    "Agrela",
    "",
    "no",
    "1584",
    "6986800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131402",
    "Água Longa",
    "",
    "no",
    "2207",
    "12873400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131405",
    "Aves",
    "",
    "yes",
    "8455",
    "6114100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131413",
    "Monte Córdova",
    "",
    "no",
    "3958",
    "16798000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131416",
    "Rebordões",
    "",
    "no",
    "3368",
    "4210000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131418",
    "Reguenga",
    "",
    "no",
    "1596",
    "5004300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131419",
    "Roriz",
    "",
    "no",
    "3665",
    "6169700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131430",
    "Negrelos (São Tomé)",
    "",
    "no",
    "4032",
    "6116400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131432",
    "Vilarinho",
    "",
    "no",
    "3788",
    "5266500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131433",
    "União das freguesias de Areias, Sequeiró, Lama e Palmeira",
    "",
    "no",
    "6795",
    "10304100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131434",
    "União das freguesias de Campo (São Martinho), São Salvador do Campo e Negrelos (São Mamede)",
    "",
    "no",
    "6809",
    "9595900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131435",
    "União das freguesias de Carreira e Refojos de Riba de Ave",
    "",
    "no",
    "2072",
    "9490000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131436",
    "União das freguesias de Lamelas e Guimarei",
    "",
    "no",
    "1660",
    "12408500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131437",
    "União das freguesias de Santo Tirso, Couto (Santa Cristina e São Miguel) e Burgães",
    "",
    "no",
    "21538",
    "25217500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131501",
    "Alfena",
    "",
    "no",
    "15021",
    "15520300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131503",
    "Ermesinde",
    "",
    "no",
    "38963",
    "7878600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131505",
    "Valongo",
    "",
    "no",
    "24074",
    "20238600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131506",
    "União das freguesias de Campo e Sobrado",
    "",
    "no",
    "15800",
    "31486900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131602",
    "Árvore",
    "",
    "no",
    "5196",
    "6560400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131603",
    "Aveleda",
    "",
    "no",
    "1314",
    "3701700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131604",
    "Azurara",
    "",
    "no",
    "2305",
    "2164000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131607",
    "Fajozes",
    "",
    "no",
    "1425",
    "5961800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131610",
    "Gião",
    "",
    "no",
    "1756",
    "5657500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131611",
    "Guilhabreu",
    "",
    "no",
    "2357",
    "6458700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131612",
    "Junqueira",
    "",
    "no",
    "2019",
    "6827700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131613",
    "Labruge",
    "",
    "no",
    "2806",
    "5070700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131614",
    "Macieira da Maia",
    "",
    "no",
    "2321",
    "5926500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131616",
    "Mindelo",
    "",
    "no",
    "3491",
    "5738700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131617",
    "Modivas",
    "",
    "no",
    "1806",
    "4099300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131627",
    "Vila Chã",
    "",
    "no",
    "3094",
    "4813300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131628",
    "Vila do Conde",
    "",
    "no",
    "28636",
    "6778800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131630",
    "Vilar de Pinheiro",
    "",
    "no",
    "2537",
    "3783600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131631",
    "União das freguesias de Bagunte, Ferreiró, Outeiro Maior e Parada",
    "",
    "no",
    "2848",
    "21860000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131632",
    "União das freguesias de Fornelo e Vairão",
    "",
    "no",
    "2643",
    "10854000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131633",
    "União das freguesias de Malta e Canidelo",
    "",
    "no",
    "2291",
    "5471200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131634",
    "União das freguesias de Retorta e Tougues",
    "",
    "no",
    "2052",
    "6550600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131635",
    "União das freguesias de Rio Mau e Arcos",
    "",
    "no",
    "2681",
    "15696900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131636",
    "União das freguesias de Touguinha e Touguinhó",
    "",
    "no",
    "3386",
    "7723300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131637",
    "União das freguesias de Vilar e Mosteiró",
    "",
    "no",
    "2569",
    "7329100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131701",
    "Arcozelo",
    "",
    "no",
    "14352",
    "8495400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131702",
    "Avintes",
    "",
    "no",
    "11497",
    "8821400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131703",
    "Canelas",
    "",
    "no",
    "13459",
    "6901300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131704",
    "Canidelo",
    "",
    "no",
    "27769",
    "8930800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131709",
    "Madalena",
    "",
    "no",
    "10040",
    "4690100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131712",
    "Oliveira do Douro",
    "",
    "no",
    "22383",
    "7536200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131717",
    "São Félix da Marinha",
    "",
    "no",
    "12706",
    "7929000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131723",
    "Vilar de Andorinho",
    "",
    "no",
    "18155",
    "7065100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131725",
    "União das freguesias de Grijó e Sermonde",
    "",
    "no",
    "11938",
    "12989600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131726",
    "União das freguesias de Gulpilhares e Valadares",
    "",
    "no",
    "22019",
    "10612300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131727",
    "União das freguesias de Mafamude e Vilar do Paraíso",
    "",
    "no",
    "52422",
    "10575000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131728",
    "União das freguesias de Pedroso e Seixezelo",
    "",
    "no",
    "20426",
    "20878100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131729",
    "União das freguesias de Sandim, Olival, Lever e Crestuma",
    "",
    "no",
    "17168",
    "34156000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131730",
    "União das freguesias de Santa Marinha e São Pedro da Afurada",
    "",
    "no",
    "33714",
    "6914300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131731",
    "União das freguesias de Serzedo e Perosinho",
    "",
    "no",
    "14250",
    "11969700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT11A",
    "131806",
    "Covelas",
    "",
    "no",
    "1563",
    "15280400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131808",
    "Muro",
    "",
    "no",
    "1922",
    "4994100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131809",
    "União das freguesias de Alvarelhos e Guidões",
    "",
    "no",
    "4810",
    "12074400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131810",
    "União das freguesias de Bougado (São Martinho e Santiago)",
    "",
    "no",
    "21585",
    "28686900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11A",
    "131811",
    "União das freguesias de Coronado (São Romão e São Mamede)",
    "",
    "no",
    "9119",
    "10981700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140104",
    "Bemposta",
    "",
    "no",
    "1795",
    "187453500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140105",
    "Martinchel",
    "",
    "no",
    "604",
    "17068300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140106",
    "Mouriscas",
    "",
    "no",
    "1832",
    "35022700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140107",
    "Pego",
    "",
    "no",
    "2431",
    "36046900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140108",
    "Rio de Moinhos",
    "",
    "no",
    "1202",
    "20031000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140115",
    "Tramagal",
    "",
    "no",
    "3500",
    "24100600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140118",
    "Fontes",
    "",
    "no",
    "627",
    "28485200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140119",
    "Carvalhal",
    "",
    "no",
    "722",
    "17542100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140120",
    "União das freguesias de Abrantes (São Vicente e São João) e Alferrarede",
    "",
    "no",
    "17205",
    "64466500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140121",
    "União das freguesias de Aldeia do Mato e Souto",
    "",
    "no",
    "859",
    "44768000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140122",
    "União das freguesias de Alvega e Concavada",
    "",
    "no",
    "2152",
    "75849600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140123",
    "União das freguesias de São Facundo e Vale das Mós",
    "",
    "no",
    "1515",
    "104912400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140124",
    "União das freguesias de São Miguel do Rio Torto e Rossio ao Sul do Tejo",
    "",
    "no",
    "4881",
    "58944100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140202",
    "Bugalhos",
    "",
    "no",
    "1084",
    "16458200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140206",
    "Minde",
    "",
    "no",
    "3293",
    "21144500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140207",
    "Moitas Venda",
    "",
    "no",
    "866",
    "6751500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140208",
    "Monsanto",
    "",
    "no",
    "886",
    "18463400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140209",
    "Serra de Santo António",
    "",
    "no",
    "725",
    "14620800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140211",
    "União das freguesias de Alcanena e Vila Moreira",
    "",
    "no",
    "5105",
    "15431200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140212",
    "União das freguesias de Malhou, Louriceira e Espinheiro",
    "",
    "no",
    "1909",
    "34459200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140301",
    "Almeirim",
    "",
    "no",
    "12812",
    "69130200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140302",
    "Benfica do Ribatejo",
    "",
    "no",
    "3067",
    "29270200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140303",
    "Fazendas de Almeirim",
    "",
    "no",
    "6949",
    "58302800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140304",
    "Raposa",
    "",
    "no",
    "548",
    "65417300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140401",
    "Alpiarça",
    "",
    "no",
    "7702",
    "95363300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140501",
    "Benavente",
    "",
    "no",
    "9174",
    "130410100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140502",
    "Samora Correia",
    "",
    "no",
    "17123",
    "321387100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT185",
    "140503",
    "Santo Estêvão",
    "",
    "no",
    "1997",
    "62412100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140504",
    "Barrosa",
    "",
    "no",
    "725",
    "7174700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140604",
    "Pontével",
    "",
    "no",
    "4614",
    "27843800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140605",
    "Valada",
    "",
    "no",
    "821",
    "42166300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140607",
    "Vila Chã de Ourique",
    "",
    "no",
    "2771",
    "33219000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140608",
    "Vale da Pedra",
    "",
    "no",
    "1755",
    "14095100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140609",
    "União das freguesias do Cartaxo e Vale da Pinta",
    "",
    "no",
    "12665",
    "28231000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140610",
    "União das freguesias de Ereira e Lapa",
    "",
    "no",
    "1836",
    "12617600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140704",
    "Ulme",
    "",
    "no",
    "1277",
    "121797800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140705",
    "Vale de Cavalos",
    "",
    "no",
    "1032",
    "120050300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140707",
    "Carregueira",
    "",
    "no",
    "2020",
    "98644900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140708",
    "União das freguesias da Chamusca e Pinheiro Grande",
    "",
    "no",
    "4299",
    "67099900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140709",
    "União das freguesias de Parreira e Chouto",
    "",
    "no",
    "1492",
    "338412500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140801",
    "Constância",
    "",
    "no",
    "993",
    "8831500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140802",
    "Montalvo",
    "",
    "no",
    "1275",
    "12814400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "140803",
    "Santa Margarida da Coutada",
    "",
    "no",
    "1788",
    "58719900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140902",
    "Couço",
    "",
    "no",
    "2765",
    "346578200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140903",
    "São José da Lamarosa",
    "",
    "no",
    "1727",
    "110892400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140905",
    "Branca",
    "",
    "no",
    "1474",
    "117342200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140907",
    "Biscainho",
    "",
    "no",
    "1074",
    "81367200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140908",
    "Santana do Mato",
    "",
    "no",
    "1148",
    "103059600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "140909",
    "União das freguesias de Coruche, Fajarda e Erra",
    "",
    "no",
    "11756",
    "356480600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141001",
    "São João Baptista",
    "",
    "no",
    "7576",
    "4560500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141002",
    "Nossa Senhora de Fátima",
    "",
    "no",
    "12630",
    "9167600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141101",
    "Águas Belas",
    "",
    "no",
    "1181",
    "22130300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141103",
    "Beco",
    "",
    "no",
    "906",
    "16213400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141104",
    "Chãos",
    "",
    "no",
    "597",
    "23335500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141106",
    "Ferreira do Zêzere",
    "",
    "no",
    "2353",
    "37932400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141107",
    "Igreja Nova do Sobral",
    "",
    "no",
    "678",
    "14524000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141110",
    "Nossa Senhora do Pranto",
    "",
    "no",
    "1089",
    "30482500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141111",
    "União das freguesias de Areias e Pias",
    "",
    "no",
    "1815",
    "45762200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141201",
    "Azinhaga",
    "",
    "no",
    "1620",
    "38213800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141202",
    "Golegã",
    "",
    "no",
    "3845",
    "38403400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141203",
    "Pombalinho",
    "",
    "no",
    "448",
    "7699400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141302",
    "Amêndoa",
    "",
    "no",
    "515",
    "37609800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141303",
    "Cardigos",
    "",
    "no",
    "1086",
    "70927500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141304",
    "Carvoeiro",
    "",
    "no",
    "620",
    "48915200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141305",
    "Envendos",
    "",
    "no",
    "984",
    "92048400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141307",
    "Ortiga",
    "",
    "no",
    "590",
    "16368600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141309",
    "União das freguesias de Mação, Penhascoso e Aboboreira",
    "",
    "no",
    "3543",
    "134110400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141401",
    "Alcobertas",
    "",
    "no",
    "1923",
    "32030100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141402",
    "Arrouquelas",
    "",
    "no",
    "591",
    "27850900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141405",
    "Fráguas",
    "",
    "no",
    "905",
    "16121800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141408",
    "Rio Maior",
    "",
    "no",
    "12005",
    "91003100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141410",
    "Asseiceira",
    "",
    "no",
    "1017",
    "16707900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141411",
    "São Sebastião",
    "",
    "no",
    "523",
    "15404200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141415",
    "União das freguesias de Azambujeira e Malaqueijo",
    "",
    "no",
    "896",
    "14842400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141416",
    "União das freguesias de Marmeleira e Assentiz",
    "",
    "no",
    "865",
    "14154300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141417",
    "União das freguesias de Outeiro da Cortiçada e Arruda dos Pisões",
    "",
    "no",
    "1079",
    "24482900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141418",
    "União das freguesias de São João da Ribeira e Ribeira de São João",
    "",
    "no",
    "1388",
    "20166800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141502",
    "Marinhais",
    "",
    "no",
    "6336",
    "37879200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141503",
    "Muge",
    "",
    "no",
    "1270",
    "49605100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141507",
    "União das freguesias de Glória do Ribatejo e Granho",
    "",
    "no",
    "4107",
    "84651600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141508",
    "União das freguesias de Salvaterra de Magos e Foros de Salvaterra",
    "",
    "no",
    "10446",
    "71796100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141601",
    "Abitureiras",
    "",
    "no",
    "972",
    "23689000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141602",
    "Abrã",
    "",
    "no",
    "1122",
    "22438800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141604",
    "Alcanede",
    "",
    "no",
    "4547",
    "105829900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141605",
    "Alcanhões",
    "",
    "no",
    "1469",
    "11453800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141606",
    "Almoster",
    "",
    "no",
    "1818",
    "40820400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141607",
    "Amiais de Baixo",
    "",
    "no",
    "1851",
    "6302400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141608",
    "Arneiro das Milhariças",
    "",
    "no",
    "835",
    "12021700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141613",
    "Moçarria",
    "",
    "no",
    "1136",
    "12119800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141614",
    "Pernes",
    "",
    "no",
    "1446",
    "14059600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141616",
    "Póvoa da Isenta",
    "",
    "no",
    "1127",
    "13903600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141625",
    "Vale de Santarém",
    "",
    "no",
    "2920",
    "10195300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141628",
    "Gançaria",
    "",
    "no",
    "514",
    "5589100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141629",
    "União das freguesias de Achete, Azoia de Baixo e Póvoa de Santarém",
    "",
    "no",
    "2923",
    "44260500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141630",
    "União das freguesias de Azoia de Cima e Tremês",
    "",
    "no",
    "2477",
    "33290900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141631",
    "União das freguesias de Casével e Vaqueiros",
    "",
    "no",
    "1149",
    "36782000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141632",
    "União das freguesias de Romeira e Várzea",
    "",
    "no",
    "2600",
    "32445700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141633",
    "União das freguesias de Santarém (Marvila), Santa Iria da Ribeira de Santarém, Santarém (São Salvador) e Santarém (São Nicolau)",
    "",
    "no",
    "29929",
    "55511100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT185",
    "141634",
    "União das freguesias de São Vicente do Paul e Vale de Figueira",
    "",
    "no",
    "2917",
    "71822300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141701",
    "Alcaravela",
    "",
    "no",
    "904",
    "36774400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141702",
    "Santiago de Montalegre",
    "",
    "no",
    "229",
    "16996100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141703",
    "Sardoal",
    "",
    "no",
    "2404",
    "30008900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141704",
    "Valhascos",
    "",
    "no",
    "402",
    "8367900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141802",
    "Asseiceira",
    "",
    "no",
    "2945",
    "29071400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141804",
    "Carregueiros",
    "",
    "no",
    "1179",
    "12350800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141808",
    "Olalhas",
    "",
    "no",
    "1415",
    "34717900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141809",
    "Paialvo",
    "",
    "no",
    "2599",
    "22306200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141813",
    "São Pedro de Tomar",
    "",
    "no",
    "3027",
    "36656700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141814",
    "Sabacheira",
    "",
    "no",
    "955",
    "34255000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141817",
    "União das freguesias de Além da Ribeira e Pedreira",
    "",
    "no",
    "1313",
    "24502100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141818",
    "União das freguesias de Casais e Alviobeira",
    "",
    "no",
    "2965",
    "35959000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141819",
    "União das freguesias de Madalena e Beselga",
    "",
    "no",
    "3990",
    "44437900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141820",
    "União das freguesias de Serra e Junceira",
    "",
    "no",
    "2080",
    "46566600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141821",
    "União das freguesias de Tomar (São João Baptista) e Santa Maria dos Olivais",
    "",
    "no",
    "18209",
    "30380900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141902",
    "Assentiz",
    "",
    "no",
    "2921",
    "32822500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141904",
    "Chancelaria",
    "",
    "no",
    "1659",
    "35371000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141909",
    "Pedrógão",
    "",
    "no",
    "2037",
    "39335600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141910",
    "Riachos",
    "",
    "no",
    "5247",
    "14570800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141916",
    "Zibreira",
    "",
    "no",
    "1028",
    "10505200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141917",
    "Meia Via",
    "",
    "no",
    "1667",
    "4090300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141918",
    "União das freguesias de Brogueira, Parceiros de Igreja e Alcorochel",
    "",
    "no",
    "2829",
    "42074300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141919",
    "União das freguesias de Olaia e Paço",
    "",
    "no",
    "2409",
    "29583300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141920",
    "União das freguesias de Torres Novas (Santa Maria, Salvador e Santiago)",
    "",
    "no",
    "8246",
    "39651100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "141921",
    "União das freguesias de Torres Novas (São Pedro), Lapas e Ribeira Branca",
    "",
    "no",
    "8674",
    "21992700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142001",
    "Atalaia",
    "",
    "no",
    "1697",
    "14396000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142002",
    "Praia do Ribatejo",
    "",
    "no",
    "1702",
    "20257800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142003",
    "Tancos",
    "",
    "no",
    "243",
    "2043500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142006",
    "Vila Nova da Barquinha",
    "",
    "no",
    "3680",
    "12832400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142101",
    "Alburitel",
    "",
    "no",
    "1179",
    "11194200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142102",
    "Atouguia",
    "",
    "no",
    "2454",
    "19612800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142104",
    "Caxarias",
    "",
    "no",
    "2166",
    "18034300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142105",
    "Espite",
    "",
    "no",
    "1104",
    "19776500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142106",
    "Fátima",
    "",
    "no",
    "11596",
    "71838600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142111",
    "Nossa Senhora das Misericórdias",
    "",
    "no",
    "5077",
    "40673300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142113",
    "Seiça",
    "",
    "no",
    "2076",
    "24879400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142114",
    "Urqueira",
    "",
    "no",
    "1682",
    "31055700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142115",
    "Nossa Senhora da Piedade",
    "",
    "no",
    "7217",
    "20423200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142119",
    "União das freguesias de Freixianda, Ribeira do Fárrio e Formigais",
    "",
    "no",
    "3693",
    "64225700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142120",
    "União das freguesias de Gondemaria e Olival",
    "",
    "no",
    "3170",
    "30108800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142121",
    "União das freguesias de Matas e Cercal",
    "",
    "no",
    "1728",
    "20745300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16I",
    "142122",
    "União das freguesias de Rio de Couros e Casal dos Bernardos",
    "",
    "no",
    "2798",
    "44112500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150104",
    "Torrão",
    "",
    "no",
    "2295",
    "372388100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150105",
    "São Martinho",
    "",
    "no",
    "450",
    "88592900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150106",
    "Comporta",
    "",
    "no",
    "1268",
    "150539700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "150107",
    "União das freguesias de Alcácer do Sal (Santa Maria do Castelo e Santiago) e Santa Susana",
    "",
    "no",
    "9033",
    "888352200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "150201",
    "Alcochete",
    "",
    "no",
    "12239",
    "119441700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150202",
    "Samouco",
    "",
    "no",
    "3143",
    "4761400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150203",
    "São Francisco",
    "",
    "no",
    "2187",
    "4161700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150303",
    "Costa da Caparica",
    "",
    "no",
    "13418",
    "10178200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150312",
    "União das freguesias de Almada, Cova da Piedade, Pragal e Cacilhas",
    "",
    "no",
    "49661",
    "6154500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150313",
    "União das freguesias de Caparica e Trafaria",
    "",
    "no",
    "26150",
    "16745600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150314",
    "União das freguesias de Charneca de Caparica e Sobreda",
    "",
    "no",
    "43239",
    "29051300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150315",
    "União das freguesias de Laranjeiro e Feijó",
    "",
    "no",
    "39872",
    "7879300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150407",
    "Santo António da Charneca",
    "",
    "no",
    "11536",
    "7696700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150409",
    "União das freguesias de Alto do Seixalinho, Santo André e Verderena",
    "",
    "no",
    "41760",
    "7179100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150410",
    "União das freguesias de Barreiro e Lavradio",
    "",
    "no",
    "21877",
    "7735600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150411",
    "União das freguesias de Palhais e Coina",
    "",
    "no",
    "3591",
    "13779300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "150501",
    "Azinheira dos Barros e São Mamede do Sádão",
    "",
    "no",
    "704",
    "172520700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150503",
    "Melides",
    "",
    "no",
    "1658",
    "155162800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "150505",
    "Carvalhal",
    "",
    "no",
    "1630",
    "81998300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "150506",
    "União das freguesias de Grândola e Santa Margarida da Serra",
    "",
    "no",
    "10834",
    "416254900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "150601",
    "Alhos Vedros",
    "",
    "no",
    "15050",
    "17907300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150603",
    "Moita",
    "",
    "no",
    "17653",
    "17941500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150607",
    "União das freguesias de Baixa da Banheira e Vale da Amoreira",
    "",
    "no",
    "30949",
    "6420500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150608",
    "União das freguesias de Gaio-Rosário e Sarilhos Pequenos",
    "",
    "no",
    "2377",
    "12990500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150701",
    "Canha",
    "",
    "no",
    "1689",
    "211971200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "150704",
    "Sarilhos Grandes",
    "",
    "no",
    "3424",
    "11765800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150709",
    "União das freguesias de Atalaia e Alto Estanqueiro-Jardia",
    "",
    "no",
    "5085",
    "13649000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150710",
    "União das freguesias de Montijo e Afonsoeiro",
    "",
    "no",
    "37111",
    "31460000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150711",
    "União das freguesias de Pegões",
    "",
    "no",
    "3913",
    "79770300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "150802",
    "Palmela",
    "",
    "yes",
    "17446",
    "77434500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150803",
    "Pinhal Novo",
    "",
    "no",
    "25000",
    "54443000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "150804",
    "Quinta do Anjo",
    "",
    "no",
    "11865",
    "51117600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "150806",
    "União das freguesias de Poceirão e Marateca",
    "",
    "yes",
    "8520",
    "282125100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150901",
    "Abela",
    "",
    "no",
    "890",
    "137679100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150902",
    "Alvalade",
    "",
    "no",
    "2098",
    "161822100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150903",
    "Cercal",
    "",
    "no",
    "3362",
    "137485300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150904",
    "Ermidas-Sado",
    "",
    "no",
    "2020",
    "82400400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150907",
    "Santo André",
    "",
    "no",
    "10647",
    "75105100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "150910",
    "São Francisco da Serra",
    "",
    "no",
    "809",
    "51379400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150912",
    "União das freguesias de Santiago do Cacém, Santa Cruz e São Bartolomeu da Serra",
    "",
    "no",
    "8454",
    "207934900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT181",
    "150913",
    "União das freguesias de São Domingos e Vale de Água",
    "",
    "no",
    "1469",
    "205886600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "151002",
    "Amora",
    "",
    "no",
    "48629",
    "24333300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151005",
    "Corroios",
    "",
    "no",
    "49351",
    "17309700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151006",
    "Fernão Ferro",
    "",
    "no",
    "16410",
    "23905600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151007",
    "União das freguesias do Seixal, Arrentela e Aldeia de Paio Pires",
    "",
    "no",
    "44920",
    "29903100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151101",
    "Sesimbra (Castelo)",
    "",
    "no",
    "19053",
    "179325300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151102",
    "Sesimbra (Santiago)",
    "",
    "no",
    "4841",
    "2015900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151103",
    "Quinta do Conde",
    "",
    "no",
    "26255",
    "14376300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151205",
    "Setúbal (São Sebastião)",
    "",
    "no",
    "52368",
    "25518700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151207",
    "Gâmbia-Pontes-Alto da Guerra",
    "",
    "no",
    "6059",
    "33229900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT170",
    "151208",
    "Sado",
    "",
    "no",
    "5783",
    "65488700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151209",
    "União das freguesias de Azeitão (São Lourenço e São Simão)",
    "",
    "no",
    "18877",
    "69322500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT170",
    "151210",
    "União das freguesias de Setúbal (São Julião, Nossa Senhora da Anunciada e Santa Maria da Graça)",
    "",
    "no",
    "38098",
    "36765300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "151301",
    "Sines",
    "",
    "no",
    "13200",
    "152579800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT181",
    "151302",
    "Porto Covo",
    "",
    "no",
    "1038",
    "50721900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160101",
    "Aboim das Choças",
    "",
    "no",
    "333",
    "1828100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160102",
    "Aguiã",
    "",
    "no",
    "705",
    "3805200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160104",
    "Ázere",
    "",
    "no",
    "247",
    "3177600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160105",
    "Cabana Maior",
    "",
    "no",
    "239",
    "13403500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160106",
    "Cabreiro",
    "",
    "no",
    "428",
    "41720500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160108",
    "Cendufe",
    "",
    "no",
    "360",
    "3158000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160109",
    "Couto",
    "",
    "no",
    "615",
    "5787100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160113",
    "Gavieira",
    "",
    "no",
    "298",
    "57712300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160115",
    "Gondoriz",
    "",
    "no",
    "958",
    "33971800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160121",
    "Miranda",
    "",
    "no",
    "325",
    "10020100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160122",
    "Monte Redondo",
    "",
    "no",
    "227",
    "2383000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160123",
    "Oliveira",
    "",
    "no",
    "330",
    "3207200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160124",
    "Paçô",
    "",
    "no",
    "933",
    "4602700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160125",
    "Padroso",
    "",
    "no",
    "234",
    "7932400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160128",
    "Prozelo",
    "",
    "no",
    "943",
    "3955900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160130",
    "Rio Frio",
    "",
    "no",
    "684",
    "19283000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160131",
    "Rio de Moinhos",
    "",
    "no",
    "438",
    "3591300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160133",
    "Sabadim",
    "",
    "no",
    "468",
    "8330200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160142",
    "Jolda (São Paio)",
    "",
    "no",
    "360",
    "1699900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160144",
    "Senharei",
    "",
    "no",
    "259",
    "7529800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160145",
    "Sistelo",
    "",
    "no",
    "273",
    "26232800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160146",
    "Soajo",
    "",
    "no",
    "986",
    "59100900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160149",
    "Vale",
    "",
    "no",
    "776",
    "15115900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160152",
    "União das freguesias de Alvora e Loureda",
    "",
    "no",
    "456",
    "10240400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160153",
    "União das freguesias de Arcos de Valdevez (São Paio) e Giela",
    "",
    "no",
    "1661",
    "5520300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160154",
    "União das freguesias de Arcos de Valdevez (Salvador), Vila Fonche e Parada",
    "",
    "no",
    "2580",
    "5272200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160155",
    "União das freguesias de Eiras e Mei",
    "",
    "no",
    "387",
    "6003000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160156",
    "União das freguesias de Grade e Carralcova",
    "",
    "no",
    "517",
    "13953900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160157",
    "União das freguesias de Guilhadeses e Santar",
    "",
    "no",
    "1283",
    "3909500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160158",
    "União das freguesias de Jolda (Madalena) e Rio Cabrão",
    "",
    "no",
    "485",
    "4232500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160159",
    "União das freguesias de Padreiro (Salvador e Santa Cristina)",
    "",
    "no",
    "377",
    "4425100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160160",
    "União das freguesias de Portela e Extremo",
    "",
    "no",
    "420",
    "11609300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160161",
    "União das freguesias de São Jorge e Ermelo",
    "",
    "no",
    "806",
    "24184400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160162",
    "União das freguesias de Souto e Tabaçô",
    "",
    "no",
    "977",
    "5005100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160163",
    "União das freguesias de Távora (Santa Maria e São Vicente)",
    "",
    "no",
    "955",
    "6737200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160164",
    "União das freguesias de Vilela, São Cosme e São Damião e Sá",
    "",
    "no",
    "524",
    "8954100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160201",
    "Âncora",
    "",
    "no",
    "1182",
    "5417300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160205",
    "Argela",
    "",
    "no",
    "393",
    "10796300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160209",
    "Dem",
    "",
    "no",
    "363",
    "6431600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160211",
    "Lanhelas",
    "",
    "no",
    "991",
    "5037000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160214",
    "Riba de Âncora",
    "",
    "no",
    "723",
    "8542000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160215",
    "Seixas",
    "",
    "no",
    "1502",
    "8333100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160217",
    "Vila Praia de Âncora",
    "",
    "no",
    "4820",
    "8372800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160218",
    "Vilar de Mouros",
    "",
    "no",
    "753",
    "10377200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160220",
    "Vile",
    "",
    "no",
    "302",
    "2799300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160221",
    "União das freguesias de Arga (Baixo, Cima e São João)",
    "",
    "no",
    "208",
    "30878700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160222",
    "União das freguesias de Caminha (Matriz) e Vilarelho",
    "",
    "no",
    "2471",
    "6737300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160223",
    "União das freguesias de Gondar e Orbacém",
    "",
    "no",
    "435",
    "11064200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160224",
    "União das freguesias de Moledo e Cristelo",
    "",
    "no",
    "1566",
    "10357300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160225",
    "União das freguesias de Venade e Azevedo",
    "",
    "no",
    "975",
    "11377300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160301",
    "Alvaredo",
    "",
    "no",
    "528",
    "4364100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160304",
    "Cousso",
    "",
    "no",
    "294",
    "7234800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160305",
    "Cristoval",
    "",
    "no",
    "528",
    "5556900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160307",
    "Fiães",
    "",
    "no",
    "239",
    "11212700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160308",
    "Gave",
    "",
    "no",
    "237",
    "18639300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160311",
    "Paderne",
    "",
    "no",
    "1160",
    "12850200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160313",
    "Penso",
    "",
    "no",
    "523",
    "8854000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160317",
    "São Paio",
    "",
    "no",
    "602",
    "9951700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160319",
    "União das freguesias de Castro Laboreiro e Lamas de Mouro",
    "",
    "no",
    "657",
    "106088500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160320",
    "União das freguesias de Chaviães e Paços",
    "",
    "no",
    "702",
    "8479000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160321",
    "União das freguesias de Parada do Monte e Cubalhão",
    "",
    "no",
    "526",
    "29838500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160322",
    "União das freguesias de Prado e Remoães",
    "",
    "no",
    "550",
    "3667500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160323",
    "União das freguesias de Vila e Roussas",
    "",
    "no",
    "2667",
    "11508700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160401",
    "Abedim",
    "",
    "no",
    "205",
    "7721000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160404",
    "Barbeita",
    "",
    "no",
    "1016",
    "6883300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160405",
    "Barroças e Taias",
    "",
    "no",
    "319",
    "2719400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160406",
    "Bela",
    "",
    "no",
    "698",
    "3792200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160407",
    "Cambeses",
    "",
    "no",
    "496",
    "4016900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160410",
    "Lara",
    "",
    "no",
    "266",
    "4929800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160411",
    "Longos Vales",
    "",
    "no",
    "989",
    "13996400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160415",
    "Merufe",
    "",
    "no",
    "1097",
    "28510200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160418",
    "Moreira",
    "",
    "no",
    "615",
    "3727700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160420",
    "Pias",
    "",
    "no",
    "854",
    "11121100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160421",
    "Pinheiros",
    "",
    "no",
    "345",
    "2132600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160422",
    "Podame",
    "",
    "no",
    "278",
    "3649000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160423",
    "Portela",
    "",
    "no",
    "242",
    "8117600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160424",
    "Riba de Mouro",
    "",
    "no",
    "964",
    "14045600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160427",
    "Segude",
    "",
    "no",
    "356",
    "2368500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160428",
    "Tangil",
    "",
    "no",
    "768",
    "22881500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160431",
    "Trute",
    "",
    "no",
    "277",
    "6018000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160434",
    "União das freguesias de Anhões e Luzio",
    "",
    "no",
    "260",
    "14377400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160435",
    "União das freguesias de Ceivães e Badim",
    "",
    "no",
    "670",
    "8947800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160436",
    "União das freguesias de Mazedo e Cortes",
    "",
    "no",
    "3377",
    "12131200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160437",
    "União das freguesias de Messegães, Valadares e Sá",
    "",
    "no",
    "658",
    "8248800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160438",
    "União das freguesias de Monção e Troviscoso",
    "",
    "no",
    "3535",
    "8676100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160439",
    "União das freguesias de Sago, Lordelo e Parada",
    "",
    "no",
    "448",
    "8333700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160440",
    "União das freguesias de Troporiz e Lapela",
    "",
    "no",
    "497",
    "3962900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160501",
    "Agualonga",
    "",
    "no",
    "295",
    "5322900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160503",
    "Castanheira",
    "",
    "no",
    "631",
    "7764500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160505",
    "Coura",
    "",
    "no",
    "374",
    "6587500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160507",
    "Cunha",
    "",
    "no",
    "529",
    "9976100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160510",
    "Infesta",
    "",
    "no",
    "450",
    "5889600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160513",
    "Mozelos",
    "",
    "no",
    "347",
    "3360300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160514",
    "Padornelo",
    "",
    "no",
    "437",
    "6660600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160515",
    "Parada",
    "",
    "no",
    "298",
    "5900700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160519",
    "Romarigães",
    "",
    "no",
    "246",
    "7132500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160520",
    "Rubiães",
    "",
    "no",
    "512",
    "9081700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160521",
    "Vascões",
    "",
    "no",
    "223",
    "6218100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160522",
    "União das freguesias de Bico e Cristelo",
    "",
    "no",
    "783",
    "11680400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160523",
    "União das freguesias de Cossourado e Linhares",
    "",
    "no",
    "517",
    "9638200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160524",
    "União das freguesias de Formariz e Ferreira",
    "",
    "no",
    "998",
    "19539400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160525",
    "União das freguesias de Insalde e Porreiras",
    "",
    "no",
    "459",
    "17592900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160526",
    "União das freguesias de Paredes de Coura e Resende",
    "",
    "no",
    "2099",
    "5840600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160601",
    "Azias",
    "",
    "no",
    "377",
    "8441400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160602",
    "Boivães",
    "",
    "no",
    "289",
    "3530700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160603",
    "Bravães",
    "",
    "no",
    "629",
    "4171600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160604",
    "Britelo",
    "",
    "no",
    "485",
    "12899800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160606",
    "Cuide de Vila Verde",
    "",
    "no",
    "344",
    "3819800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160611",
    "Lavradas",
    "",
    "no",
    "875",
    "6755600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160612",
    "Lindoso",
    "",
    "no",
    "427",
    "46032600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160613",
    "Nogueira",
    "",
    "no",
    "410",
    "1993500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160614",
    "Oleiros",
    "",
    "no",
    "466",
    "3410200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160619",
    "Sampriz",
    "",
    "no",
    "342",
    "6557900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160623",
    "Vade (São Pedro)",
    "",
    "no",
    "264",
    "2654100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160624",
    "Vade (São Tomé)",
    "",
    "no",
    "287",
    "1572100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160626",
    "União das freguesias de Crasto, Ruivos e Grovelas",
    "",
    "no",
    "882",
    "9917500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160627",
    "União das freguesias de Entre Ambos-os-Rios, Ermida e Germil",
    "",
    "no",
    "612",
    "38671600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160628",
    "União das freguesias de Ponte da Barca, Vila Nova de Muía e Paço Vedro de Magalhães",
    "",
    "no",
    "4372",
    "8835500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160629",
    "União das freguesias de Touvedo (São Lourenço e Salvador)",
    "",
    "no",
    "377",
    "6090600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160630",
    "União das freguesias de Vila Chã (São João Baptista e Santiago)",
    "",
    "no",
    "623",
    "16759300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160701",
    "Anais",
    "",
    "no",
    "1073",
    "8063000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160703",
    "São Pedro d'Arcos",
    "",
    "no",
    "640",
    "15053200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160704",
    "Arcozelo",
    "",
    "no",
    "3734",
    "12075700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160707",
    "Beiral do Lima",
    "",
    "no",
    "558",
    "7315200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160708",
    "Bertiandos",
    "",
    "no",
    "414",
    "2266800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160709",
    "Boalhosa",
    "",
    "no",
    "163",
    "2187000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160710",
    "Brandara",
    "",
    "no",
    "442",
    "2576900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160713",
    "Calheiros",
    "",
    "no",
    "991",
    "8499300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160714",
    "Calvelo",
    "",
    "no",
    "685",
    "5264200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160716",
    "Correlhã",
    "",
    "no",
    "2936",
    "8655400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160717",
    "Estorãos",
    "",
    "no",
    "464",
    "16209400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160718",
    "Facha",
    "",
    "no",
    "1529",
    "15307700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160719",
    "Feitosa",
    "",
    "no",
    "1363",
    "2693800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160721",
    "Fontão",
    "",
    "no",
    "1101",
    "4825400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160724",
    "Friastelas",
    "",
    "no",
    "450",
    "3919900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160726",
    "Gandra",
    "",
    "no",
    "1108",
    "3485400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160727",
    "Gemieira",
    "",
    "no",
    "598",
    "4248600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160728",
    "Gondufe",
    "",
    "no",
    "450",
    "5574000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160729",
    "Labruja",
    "",
    "no",
    "439",
    "14564600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160734",
    "Poiares",
    "",
    "no",
    "775",
    "7440100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160737",
    "Refóios do Lima",
    "",
    "no",
    "2169",
    "16447300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160739",
    "Ribeira",
    "",
    "no",
    "1902",
    "8771700",
    "3",
    "no",
    "no",
    "no"
  ],
  ["PT111", "160740", "Sá", "", "no", "420", "2798200", "3", "no", "no", "no"],
  [
    "PT111",
    "160742",
    "Santa Comba",
    "",
    "no",
    "661",
    "1499100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160743",
    "Santa Cruz do Lima",
    "",
    "no",
    "480",
    "2233400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160744",
    "Rebordões (Santa Maria)",
    "",
    "no",
    "1056",
    "7073000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160745",
    "Seara",
    "",
    "no",
    "714",
    "3634700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160746",
    "Serdedelo",
    "",
    "no",
    "464",
    "6512400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160747",
    "Rebordões (Souto)",
    "",
    "no",
    "1127",
    "7409400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160750",
    "Vitorino das Donas",
    "",
    "no",
    "1051",
    "4465300",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160752",
    "Arca e Ponte de Lima",
    "",
    "no",
    "3756",
    "4006000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160753",
    "Ardegão, Freixo e Mato",
    "",
    "no",
    "1754",
    "10717500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160754",
    "Associação de freguesias do Vale do Neiva",
    "",
    "no",
    "1075",
    "10273200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160755",
    "Bárrio e Cepões",
    "",
    "no",
    "921",
    "9712300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160756",
    "Cabaços e Fojo Lobal",
    "",
    "no",
    "951",
    "9265500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160757",
    "Cabração e Moreira do Lima",
    "",
    "no",
    "987",
    "27340200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160758",
    "Fornelos e Queijada",
    "",
    "no",
    "1912",
    "13011400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160759",
    "Labrujó, Rendufe e Vilar do Monte",
    "",
    "no",
    "417",
    "11255500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160760",
    "Navió e Vitorino dos Piães",
    "",
    "no",
    "1768",
    "13603100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160802",
    "Boivão",
    "",
    "no",
    "239",
    "7965800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160803",
    "Cerdal",
    "",
    "no",
    "1693",
    "18777000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160805",
    "Fontoura",
    "",
    "no",
    "751",
    "9168100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160806",
    "Friestas",
    "",
    "no",
    "562",
    "4147700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160808",
    "Ganfei",
    "",
    "no",
    "1296",
    "9472200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160812",
    "São Pedro da Torre",
    "",
    "no",
    "1267",
    "7790900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160816",
    "Verdoejo",
    "",
    "no",
    "608",
    "4233800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160817",
    "União das freguesias de Gandra e Taião",
    "",
    "no",
    "1471",
    "20187200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160818",
    "União das freguesias de Gondomil e Sanfins",
    "",
    "no",
    "464",
    "17716500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160819",
    "União das freguesias de São Julião e Silva",
    "",
    "no",
    "623",
    "8181800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160820",
    "União das freguesias de Valença, Cristelo Covo e Arão",
    "",
    "no",
    "5153",
    "9487700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160901",
    "Afife",
    "",
    "no",
    "1632",
    "13028400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160902",
    "Alvarães",
    "",
    "no",
    "2623",
    "9106900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160903",
    "Amonde",
    "",
    "no",
    "293",
    "6245400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160904",
    "Anha",
    "",
    "no",
    "2415",
    "9400500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160905",
    "Areosa",
    "",
    "no",
    "4853",
    "14111800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160908",
    "Carreço",
    "",
    "no",
    "1759",
    "14204600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160910",
    "Castelo do Neiva",
    "",
    "no",
    "2930",
    "6944900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160911",
    "Darque",
    "",
    "no",
    "7817",
    "9014900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160914",
    "Freixieiro de Soutelo",
    "",
    "no",
    "511",
    "11775700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160915",
    "Lanheses",
    "",
    "no",
    "1645",
    "9595700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160920",
    "Montaria",
    "",
    "no",
    "549",
    "22431400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160922",
    "Mujães",
    "",
    "no",
    "1550",
    "4898600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160923",
    "São Romão de Neiva",
    "",
    "no",
    "1225",
    "7023300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160925",
    "Outeiro",
    "",
    "no",
    "1234",
    "18825700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160926",
    "Perre",
    "",
    "no",
    "2956",
    "13088200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160928",
    "Santa Marta de Portuzelo",
    "",
    "no",
    "3805",
    "7412200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160935",
    "Vila Franca",
    "",
    "no",
    "1757",
    "7146000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160938",
    "Vila de Punhe",
    "",
    "no",
    "2273",
    "6026700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160940",
    "Chafé",
    "",
    "no",
    "2841",
    "7850900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160941",
    "União das freguesias de Barroselas e Carvoeiro",
    "",
    "no",
    "5031",
    "18675400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160942",
    "União das freguesias de Cardielos e Serreleis",
    "",
    "no",
    "2312",
    "7681000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160943",
    "União das freguesias de Geraz do Lima (Santa Maria, Santa Leocádia e Moreira) e Deão",
    "",
    "no",
    "3339",
    "19060600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160944",
    "União das freguesias de Mazarefes e Vila Fria",
    "",
    "no",
    "2670",
    "10281000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "160945",
    "União das freguesias de Nogueira, Meixedo e Vilar de Murteda",
    "",
    "no",
    "1597",
    "27409400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160946",
    "União das freguesias de Subportela, Deocriste e Portela Susã",
    "",
    "no",
    "2552",
    "17101500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160947",
    "União das freguesias de Torre e Vila Mou",
    "",
    "no",
    "1181",
    "6354500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "160948",
    "União das freguesias de Viana do Castelo (Santa Maria Maior e Monserrate) e Meadela",
    "",
    "no",
    "25375",
    "14324900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT111",
    "161003",
    "Cornes",
    "",
    "no",
    "478",
    "6156500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161004",
    "Covas",
    "",
    "no",
    "675",
    "28604100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161006",
    "Gondarém",
    "",
    "no",
    "1010",
    "6862200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161007",
    "Loivo",
    "",
    "no",
    "885",
    "5146400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161009",
    "Mentrestido",
    "",
    "no",
    "264",
    "4704000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161012",
    "Sapardos",
    "",
    "no",
    "366",
    "6715600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161013",
    "Sopo",
    "",
    "no",
    "557",
    "14820400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161016",
    "União das freguesias de Campos e Vila Meã",
    "",
    "no",
    "1713",
    "8758000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161017",
    "União das freguesias de Candemil e Gondar",
    "",
    "no",
    "359",
    "10816600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161018",
    "União das freguesias de Reboreda e Nogueira",
    "",
    "no",
    "1071",
    "8981800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT111",
    "161019",
    "União das freguesias de Vila Nova de Cerveira e Lovelhe",
    "",
    "no",
    "1875",
    "6901000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170101",
    "Alijó",
    "",
    "no",
    "2635",
    "29361400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170107",
    "Favaios",
    "",
    "no",
    "1064",
    "21445300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170108",
    "Pegarinhos",
    "",
    "no",
    "465",
    "18781000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170109",
    "Pinhão",
    "",
    "no",
    "648",
    "2995200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170112",
    "Sanfins do Douro",
    "",
    "no",
    "1495",
    "17091000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170113",
    "Santa Eugénia",
    "",
    "no",
    "333",
    "9143000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170114",
    "São Mamede de Ribatua",
    "",
    "no",
    "728",
    "20108800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170116",
    "Vila Chã",
    "",
    "no",
    "533",
    "20226700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170117",
    "Vila Verde",
    "",
    "no",
    "622",
    "42086900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170118",
    "Vilar de Maçada",
    "",
    "no",
    "915",
    "20194800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170120",
    "União das freguesias de Carlão e Amieiro",
    "",
    "no",
    "800",
    "33007300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170121",
    "União das freguesias de Castedo e Cotas",
    "",
    "no",
    "618",
    "28910900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170122",
    "União das freguesias de Pópulo e Ribalonga",
    "",
    "no",
    "508",
    "21303000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170123",
    "União das freguesias de Vale de Mendiz, Casal de Loivos e Vilarinho de Cotas",
    "",
    "no",
    "578",
    "12943500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170203",
    "Beça",
    "",
    "no",
    "843",
    "29858800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170208",
    "Covas do Barroso",
    "",
    "no",
    "262",
    "29577600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170210",
    "Dornelas",
    "",
    "no",
    "338",
    "36576800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170213",
    "Pinho",
    "",
    "no",
    "401",
    "22369500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170215",
    "Sapiãos",
    "",
    "no",
    "488",
    "21100000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170217",
    "Alturas do Barroso e Cerdedo",
    "",
    "no",
    "544",
    "56639800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170218",
    "Ardãos e Bobadela",
    "",
    "no",
    "579",
    "37122500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170219",
    "Boticas e Granja",
    "",
    "no",
    "1510",
    "22665000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170220",
    "Codessoso, Curros e Fiães do Tâmega",
    "",
    "no",
    "298",
    "35167000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170221",
    "Vilar e Viveiro",
    "",
    "no",
    "487",
    "30879600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170301",
    "Águas Frias",
    "",
    "no",
    "746",
    "28775800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170302",
    "Anelhe",
    "",
    "no",
    "476",
    "12485100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170305",
    "Bustelo",
    "",
    "no",
    "519",
    "9351400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170309",
    "Cimo de Vila da Castanheira",
    "",
    "no",
    "479",
    "16416600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170310",
    "Curalha",
    "",
    "no",
    "469",
    "7821600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170312",
    "Ervededo",
    "",
    "no",
    "646",
    "20207900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170313",
    "Faiões",
    "",
    "no",
    "873",
    "8086900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170314",
    "Lama de Arcos",
    "",
    "no",
    "316",
    "13693300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170316",
    "Mairos",
    "",
    "no",
    "344",
    "11667800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170317",
    "Moreiras",
    "",
    "no",
    "273",
    "9231600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170318",
    "Nogueira da Montanha",
    "",
    "no",
    "529",
    "16665700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170320",
    "Oura",
    "",
    "no",
    "602",
    "14507300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170321",
    "Outeiro Seco",
    "",
    "no",
    "938",
    "15206700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170322",
    "Paradela",
    "",
    "no",
    "262",
    "8215400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170324",
    "Redondelo",
    "",
    "no",
    "527",
    "18705600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170327",
    "Sanfins",
    "",
    "no",
    "236",
    "17691300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170329",
    "Santa Leocádia",
    "",
    "no",
    "324",
    "13104300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170330",
    "Santo António de Monforte",
    "",
    "no",
    "454",
    "11776400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170331",
    "Santo Estêvão",
    "",
    "no",
    "607",
    "8673500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170333",
    "São Pedro de Agostém",
    "",
    "no",
    "1419",
    "26704300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170334",
    "São Vicente",
    "",
    "no",
    "227",
    "31257900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170340",
    "Tronco",
    "",
    "no",
    "218",
    "8542400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170341",
    "Vale de Anta",
    "",
    "no",
    "1543",
    "10177400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170343",
    "Vila Verde da Raia",
    "",
    "no",
    "993",
    "9773100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170344",
    "Vilar de Nantes",
    "",
    "no",
    "2084",
    "7275200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170345",
    "Vilarelho da Raia",
    "",
    "no",
    "558",
    "18032200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170347",
    "Vilas Boas",
    "",
    "no",
    "195",
    "6856500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170348",
    "Vilela Seca",
    "",
    "no",
    "276",
    "14014900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170349",
    "Vilela do Tâmega",
    "",
    "no",
    "409",
    "9607300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170350",
    "Santa Maria Maior",
    "",
    "no",
    "12019",
    "5631600",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170353",
    "Planalto de Monforte (União das freguesias de Oucidres e Bobadela)",
    "",
    "no",
    "299",
    "18979300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170354",
    "União das freguesias da Madalena e Samaiões",
    "",
    "no",
    "2669",
    "13990800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170355",
    "União das freguesias das Eiras, São Julião de Montenegro e Cela",
    "",
    "no",
    "970",
    "22785000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170356",
    "União das freguesias de Calvão e Soutelinho da Raia",
    "",
    "no",
    "503",
    "28364900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170357",
    "União das freguesias de Loivos e Póvoa de Agrações",
    "",
    "no",
    "739",
    "19013500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170358",
    "União das freguesias de Santa Cruz/Trindade e Sanjurge",
    "",
    "no",
    "3430",
    "13384800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170359",
    "União das freguesias de Soutelo e Seara Velha",
    "",
    "no",
    "515",
    "18119700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170360",
    "União das freguesias de Travancas e Roriz",
    "",
    "no",
    "566",
    "21864800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170361",
    "Vidago (União das freguesias de Vidago, Arcossó, Selhariz e Vilarinho das Paranheiras)",
    "",
    "no",
    "1991",
    "24569800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170401",
    "Barqueiros",
    "",
    "no",
    "701",
    "4655000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170402",
    "Cidadelhe",
    "",
    "no",
    "171",
    "2589100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170403",
    "Oliveira",
    "",
    "no",
    "391",
    "3438500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170407",
    "Vila Marim",
    "",
    "no",
    "1243",
    "8554400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170408",
    "Mesão Frio (Santo André)",
    "",
    "no",
    "1927",
    "7411700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170501",
    "Atei",
    "",
    "no",
    "1352",
    "24676000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170502",
    "Bilhó",
    "",
    "no",
    "546",
    "26568300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170505",
    "Mondim de Basto",
    "",
    "no",
    "3273",
    "15970300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170508",
    "Vilar de Ferreiros",
    "",
    "no",
    "1136",
    "27890200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170509",
    "União das freguesias de Campanhó e Paradança",
    "",
    "no",
    "721",
    "30033000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT119",
    "170510",
    "União das freguesias de Ermelo e Pardelhas",
    "",
    "no",
    "465",
    "46937400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170601",
    "Cabril",
    "",
    "no",
    "553",
    "76563800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170603",
    "Cervos",
    "",
    "no",
    "271",
    "32945700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170604",
    "Chã",
    "",
    "no",
    "748",
    "50975300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170607",
    "Covelo do Gerês",
    "",
    "no",
    "194",
    "10756800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170609",
    "Ferral",
    "",
    "no",
    "397",
    "15280500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170612",
    "Gralhas",
    "",
    "no",
    "208",
    "21594700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170616",
    "Morgade",
    "",
    "no",
    "228",
    "21149000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170618",
    "Negrões",
    "",
    "no",
    "177",
    "20609200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170619",
    "Outeiro",
    "",
    "no",
    "156",
    "52315400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170623",
    "Pitões das Junias",
    "",
    "no",
    "161",
    "33493900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170625",
    "Reigoso",
    "",
    "no",
    "167",
    "17233300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170626",
    "Salto",
    "",
    "no",
    "1429",
    "78548900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170627",
    "Santo André",
    "",
    "no",
    "218",
    "18964400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170629",
    "Sarraquinhos",
    "",
    "no",
    "294",
    "33494600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170631",
    "Solveira",
    "",
    "no",
    "154",
    "12336000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170632",
    "Tourém",
    "",
    "no",
    "151",
    "17033900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170635",
    "Vila da Ponte",
    "",
    "no",
    "178",
    "10669900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170636",
    "União das freguesias de Cambeses do Rio, Donões e Mourilhe",
    "",
    "no",
    "309",
    "45302200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170637",
    "União das freguesias de Meixedo e Padornelos",
    "",
    "no",
    "333",
    "35757800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170638",
    "União das freguesias de Montalegre e Padroso",
    "",
    "no",
    "1923",
    "32145000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170639",
    "União das freguesias de Paradela, Contim e Fiães",
    "",
    "no",
    "308",
    "30858600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170640",
    "União das freguesias de Sezelhe e Covelães",
    "",
    "no",
    "277",
    "32941400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170641",
    "União das freguesias de Venda Nova e Pondras",
    "",
    "no",
    "393",
    "19133300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170642",
    "União das freguesias de Viade de Baixo e Fervidelas",
    "",
    "no",
    "762",
    "48309200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170643",
    "União das freguesias de Vilar de Perdizes e Meixide",
    "",
    "no",
    "548",
    "37044500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170701",
    "Candedo",
    "",
    "no",
    "1002",
    "28784200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170703",
    "Fiolhoso",
    "",
    "no",
    "452",
    "16199100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170704",
    "Jou",
    "",
    "no",
    "654",
    "37291400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170705",
    "Murça",
    "",
    "no",
    "2136",
    "13959200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170708",
    "Valongo de Milhais",
    "",
    "no",
    "329",
    "22115500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170710",
    "União das freguesias de Carva e Vilares",
    "",
    "no",
    "472",
    "29301000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170711",
    "União das freguesias de Noura e Palheiros",
    "",
    "no",
    "907",
    "41720600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170802",
    "Fontelas",
    "",
    "no",
    "781",
    "3234800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170805",
    "Loureiro",
    "",
    "no",
    "1154",
    "4858600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170809",
    "Sedielos",
    "",
    "no",
    "911",
    "12633900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170810",
    "Vilarinho dos Freires",
    "",
    "no",
    "950",
    "7895800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170813",
    "União das freguesias de Galafura e Covelinhas",
    "",
    "no",
    "886",
    "15853700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170814",
    "União das freguesias de Moura Morta e Vinhós",
    "",
    "no",
    "1024",
    "12798400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170815",
    "União das freguesias de Peso da Régua e Godim",
    "",
    "no",
    "9959",
    "10126800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "170816",
    "União das freguesias de Poiares e Canelas",
    "",
    "no",
    "1466",
    "27458100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170901",
    "Alvadia",
    "",
    "no",
    "196",
    "33738500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170902",
    "Canedo",
    "",
    "no",
    "390",
    "36156200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170906",
    "Santa Marinha",
    "",
    "no",
    "558",
    "34679500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170908",
    "União das freguesias de Cerva e Limões",
    "",
    "no",
    "2615",
    "60037600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "170909",
    "União das freguesias de Ribeira de Pena (Salvador) e Santo Aleixo de Além-Tâmega",
    "",
    "no",
    "2785",
    "52848000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171001",
    "Celeirós",
    "",
    "no",
    "222",
    "5250400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171002",
    "Covas do Douro",
    "",
    "no",
    "444",
    "19678800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171004",
    "Gouvinhas",
    "",
    "no",
    "267",
    "14663400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171005",
    "Parada de Pinhão",
    "",
    "no",
    "309",
    "5721700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171007",
    "Paços",
    "",
    "no",
    "762",
    "17088100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171009",
    "Sabrosa",
    "",
    "no",
    "1202",
    "8684000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171011",
    "São Lourenço de Ribapinhão",
    "",
    "no",
    "407",
    "12025700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171013",
    "Souto Maior",
    "",
    "no",
    "487",
    "9183100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171014",
    "Torre do Pinhão",
    "",
    "no",
    "342",
    "14610300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171015",
    "Vilarinho de São Romão",
    "",
    "no",
    "294",
    "6201800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171016",
    "União das freguesias de Provesende, Gouvães do Douro e São Cristóvão do Douro",
    "",
    "no",
    "612",
    "18367000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171017",
    "União das freguesias de São Martinho de Antas e Paradela de Guiães",
    "",
    "no",
    "1013",
    "25450200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171101",
    "Alvações do Corgo",
    "",
    "no",
    "477",
    "4343600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171102",
    "Cumieira",
    "",
    "no",
    "1146",
    "11069400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171103",
    "Fontes",
    "",
    "no",
    "835",
    "15671100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171106",
    "Medrões",
    "",
    "no",
    "505",
    "5145500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171110",
    "Sever",
    "",
    "no",
    "714",
    "6168300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171111",
    "União das freguesias de Lobrigos (São Miguel e São João Baptista) e Sanhoane",
    "",
    "no",
    "3010",
    "14714200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171112",
    "União das freguesias de Louredo e Fornelos",
    "",
    "no",
    "669",
    "12169300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171201",
    "Água Revés e Crasto",
    "",
    "no",
    "342",
    "18987200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171203",
    "Algeriz",
    "",
    "no",
    "570",
    "20906600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171205",
    "Bouçoães",
    "",
    "no",
    "419",
    "25985400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171206",
    "Canaveses",
    "",
    "no",
    "237",
    "12872100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171209",
    "Ervões",
    "",
    "no",
    "636",
    "21847800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171211",
    "Fornos do Pinhal",
    "",
    "no",
    "320",
    "10398600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171212",
    "Friões",
    "",
    "no",
    "619",
    "28163000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171215",
    "Padrela e Tazem",
    "",
    "no",
    "359",
    "23119400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171216",
    "Possacos",
    "",
    "no",
    "446",
    "13087800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171217",
    "Rio Torto",
    "",
    "no",
    "362",
    "30688300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171219",
    "Santa Maria de Emeres",
    "",
    "no",
    "406",
    "16571700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171220",
    "Santa Valha",
    "",
    "no",
    "415",
    "27244900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171221",
    "Santiago da Ribeira de Alhariz",
    "",
    "no",
    "603",
    "21612000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171222",
    "São João da Corveira",
    "",
    "no",
    "537",
    "15836900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171223",
    "São Pedro de Veiga de Lila",
    "",
    "no",
    "304",
    "19382700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171224",
    "Serapicos",
    "",
    "no",
    "246",
    "7169100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171227",
    "Vales",
    "",
    "no",
    "257",
    "22505000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171229",
    "Vassal",
    "",
    "no",
    "460",
    "13143100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171230",
    "Veiga de Lila",
    "",
    "no",
    "261",
    "14358200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171231",
    "Vilarandelo",
    "",
    "no",
    "984",
    "20160900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171232",
    "Carrazedo de Montenegro e Curros",
    "",
    "no",
    "1780",
    "49825800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171233",
    "Lebução, Fiães e Nozelos",
    "",
    "no",
    "784",
    "29707200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171234",
    "Sonim e Barreiros",
    "",
    "no",
    "450",
    "17787000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171235",
    "Tinhela e Alvarelhos",
    "",
    "no",
    "333",
    "28224300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171236",
    "Valpaços e Sanfins",
    "",
    "no",
    "4752",
    "39154200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171302",
    "Alfarela de Jales",
    "",
    "no",
    "401",
    "13751500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171303",
    "Bornes de Aguiar",
    "",
    "no",
    "2057",
    "45430400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171304",
    "Bragado",
    "",
    "no",
    "544",
    "26126000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171305",
    "Capeludos",
    "",
    "no",
    "440",
    "21416600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171310",
    "Soutelo de Aguiar",
    "",
    "no",
    "638",
    "17366400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171311",
    "Telões",
    "",
    "no",
    "1485",
    "45217800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171312",
    "Tresminas",
    "",
    "no",
    "415",
    "55923100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171313",
    "Valoura",
    "",
    "no",
    "376",
    "14913800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171314",
    "Vila Pouca de Aguiar",
    "",
    "no",
    "3303",
    "22906200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171315",
    "Vreia de Bornes",
    "",
    "no",
    "652",
    "17731200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171316",
    "Vreia de Jales",
    "",
    "no",
    "967",
    "47278300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171317",
    "Sabroso de Aguiar",
    "",
    "no",
    "684",
    "8769900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171319",
    "Alvão",
    "",
    "no",
    "875",
    "53066300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11B",
    "171320",
    "União das freguesias de Pensalvos e Parada de Monteiros",
    "",
    "no",
    "350",
    "47168500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171401",
    "Abaças",
    "",
    "no",
    "965",
    "18871100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171403",
    "Andrães",
    "",
    "no",
    "1389",
    "20474900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171404",
    "Arroios",
    "",
    "no",
    "1117",
    "2891500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171406",
    "Campeã",
    "",
    "no",
    "1375",
    "24047900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171409",
    "Folhadela",
    "",
    "no",
    "2261",
    "16056600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171410",
    "Guiães",
    "",
    "no",
    "478",
    "8571300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171414",
    "Lordelo",
    "",
    "no",
    "3169",
    "5163100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171415",
    "Mateus",
    "",
    "no",
    "3400",
    "4139000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171416",
    "Mondrões",
    "",
    "no",
    "1065",
    "11037600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171420",
    "Parada de Cunhos",
    "",
    "no",
    "1939",
    "7040500",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171426",
    "Torgueda",
    "",
    "no",
    "1382",
    "14433700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171429",
    "Vila Marim",
    "",
    "no",
    "1742",
    "23213000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171431",
    "União das freguesias de Adoufe e Vilarinho de Samardã",
    "",
    "no",
    "2895",
    "37758700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171432",
    "União das freguesias de Borbela e Lamas de Olo",
    "",
    "no",
    "2761",
    "41276000",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171433",
    "União das freguesias de Constantim e Vale de Nogueiras",
    "",
    "no",
    "1856",
    "26007500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171434",
    "União das freguesias de Mouçós e Lamares",
    "",
    "no",
    "3402",
    "32236000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171435",
    "União das freguesias de Nogueira e Ermida",
    "",
    "no",
    "964",
    "11957200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171436",
    "União das freguesias de Pena, Quintã e Vila Cova",
    "",
    "no",
    "819",
    "24981300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171437",
    "União das freguesias de São Tomé do Castelo e Justes",
    "",
    "no",
    "1283",
    "41555200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "171438",
    "União das freguesias de Vila Real (Nossa Senhora da Conceição, São Pedro e São Dinis)",
    "",
    "no",
    "17588",
    "7090700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180101",
    "Aldeias",
    "",
    "no",
    "337",
    "5191300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180104",
    "Cimbres",
    "",
    "no",
    "308",
    "6073300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180106",
    "Folgosa",
    "",
    "no",
    "428",
    "4803200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180107",
    "Fontelo",
    "",
    "no",
    "641",
    "7519700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180109",
    "Queimada",
    "",
    "no",
    "285",
    "4259200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180110",
    "Queimadela",
    "",
    "no",
    "248",
    "2482000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180111",
    "Santa Cruz",
    "",
    "no",
    "206",
    "7882000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180114",
    "São Cosmado",
    "",
    "no",
    "598",
    "13953600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180115",
    "São Martinho das Chãs",
    "",
    "no",
    "549",
    "9667800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180118",
    "Vacalar",
    "",
    "no",
    "205",
    "6038400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180120",
    "Armamar",
    "",
    "no",
    "1464",
    "16754600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180121",
    "União das freguesias de Aricera e Goujoim",
    "",
    "no",
    "215",
    "10649400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180122",
    "União das freguesias de São Romão e Santiago",
    "",
    "no",
    "306",
    "6933200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180123",
    "União das freguesias de Vila Seca e Santo Adrião",
    "",
    "no",
    "507",
    "15029500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180201",
    "Beijós",
    "",
    "no",
    "975",
    "12525000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180202",
    "Cabanas de Viriato",
    "",
    "no",
    "1533",
    "21469400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180204",
    "Oliveira do Conde",
    "",
    "no",
    "3122",
    "35241400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180206",
    "Parada",
    "",
    "no",
    "806",
    "11664900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180208",
    "União das freguesias de Currelos, Papízios e Sobral",
    "",
    "no",
    "3399",
    "35991500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180301",
    "Almofala",
    "",
    "no",
    "228",
    "18595900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180303",
    "Cabril",
    "",
    "no",
    "414",
    "22016900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180304",
    "Castro Daire",
    "",
    "no",
    "4674",
    "32528200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180305",
    "Cujó",
    "",
    "no",
    "299",
    "8459700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180309",
    "Gosende",
    "",
    "no",
    "426",
    "20458100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180312",
    "Mões",
    "",
    "no",
    "1837",
    "44148200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180313",
    "Moledo",
    "",
    "no",
    "1222",
    "46993500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180314",
    "Monteiras",
    "",
    "no",
    "481",
    "21133300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180317",
    "Pepim",
    "",
    "no",
    "334",
    "11934600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180319",
    "Pinheiro",
    "",
    "no",
    "730",
    "19595700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180322",
    "São Joaninho",
    "",
    "no",
    "360",
    "8057000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180323",
    "União das freguesias de Mamouros, Alva e Ribolhos",
    "",
    "no",
    "1424",
    "23651700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180324",
    "União das freguesias de Mezio e Moura Morta",
    "",
    "no",
    "618",
    "22651500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180325",
    "União das freguesias de Parada de Ester e Ester",
    "",
    "no",
    "874",
    "40247500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180326",
    "União das freguesias de Picão e Ermida",
    "",
    "no",
    "535",
    "15950100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180327",
    "União das freguesias de Reriz e Gafanhão",
    "",
    "no",
    "883",
    "22619400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180403",
    "Cinfães",
    "",
    "no",
    "3395",
    "25424600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180404",
    "Espadanedo",
    "",
    "no",
    "1318",
    "5304000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180405",
    "Ferreiros de Tendais",
    "",
    "no",
    "695",
    "15995700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180406",
    "Fornelos",
    "",
    "no",
    "703",
    "10080600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180408",
    "Moimenta",
    "",
    "no",
    "408",
    "6535800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180409",
    "Nespereira",
    "",
    "no",
    "1977",
    "35992200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180410",
    "Oliveira do Douro",
    "",
    "no",
    "1529",
    "14127900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180412",
    "Santiago de Piães",
    "",
    "no",
    "1797",
    "17591500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180413",
    "São Cristóvão de Nogueira",
    "",
    "no",
    "1930",
    "18153800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180414",
    "Souselo",
    "",
    "no",
    "3202",
    "9173200",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180415",
    "Tarouquela",
    "",
    "no",
    "1242",
    "6644900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180416",
    "Tendais",
    "",
    "no",
    "807",
    "31771700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180417",
    "Travanca",
    "",
    "no",
    "829",
    "4974700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "180418",
    "União das freguesias de Alhões, Bustelo, Gralheira e Ramires",
    "",
    "no",
    "595",
    "37517000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180502",
    "Avões",
    "",
    "no",
    "619",
    "4870900",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180504",
    "Britiande",
    "",
    "no",
    "934",
    "4796400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180505",
    "Cambres",
    "",
    "no",
    "2066",
    "11279800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180507",
    "Ferreirim",
    "",
    "no",
    "904",
    "5528700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180508",
    "Ferreiros de Avões",
    "",
    "no",
    "509",
    "2648600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180509",
    "Figueira",
    "",
    "no",
    "342",
    "4552200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180510",
    "Lalim",
    "",
    "no",
    "729",
    "7217600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180511",
    "Lazarim",
    "",
    "no",
    "521",
    "16538400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180516",
    "Penajóia",
    "",
    "no",
    "1023",
    "10127500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180517",
    "Penude",
    "",
    "no",
    "1666",
    "12817000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180519",
    "Samodães",
    "",
    "no",
    "203",
    "3086700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180520",
    "Sande",
    "",
    "no",
    "916",
    "3128700",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180523",
    "Várzea de Abrunhais",
    "",
    "no",
    "405",
    "5848800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180524",
    "Vila Nova de Souto d'El-Rei",
    "",
    "no",
    "824",
    "8788600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180525",
    "Lamego (Almacave e Sé)",
    "",
    "no",
    "12214",
    "20197800",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180526",
    "União das freguesias de Bigorne, Magueija e Pretarouca",
    "",
    "no",
    "706",
    "20142800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180527",
    "União das freguesias de Cepões, Meijinhos e Melcões",
    "",
    "no",
    "1071",
    "10959100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180528",
    "União das freguesias de Parada do Bispo e Valdigem",
    "",
    "no",
    "1039",
    "12891400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180601",
    "Abrunhosa-a-Velha",
    "",
    "no",
    "563",
    "17299400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180602",
    "Alcafache",
    "",
    "no",
    "921",
    "12878100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180605",
    "Cunha Baixa",
    "",
    "no",
    "884",
    "15517000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180606",
    "Espinho",
    "",
    "no",
    "984",
    "14552500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180607",
    "Fornos de Maceira Dão",
    "",
    "no",
    "1459",
    "16245800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180608",
    "Freixiosa",
    "",
    "no",
    "257",
    "7319000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180614",
    "Quintela de Azurara",
    "",
    "no",
    "542",
    "9593300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180616",
    "São João da Fresta",
    "",
    "no",
    "208",
    "7409100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180619",
    "União das freguesias de Mangualde, Mesquitela e Cunha Alta",
    "",
    "no",
    "10407",
    "46249400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180620",
    "União das freguesias de Moimenta de Maceira Dão e Lobelhe do Mato",
    "",
    "no",
    "773",
    "7147200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180621",
    "União das freguesias de Santiago de Cassurrães e Póvoa de Cervães",
    "",
    "no",
    "1414",
    "30028100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180622",
    "União das freguesias de Tavares (Chãs, Várzea e Travanca)",
    "",
    "no",
    "1468",
    "35016700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180702",
    "Alvite",
    "",
    "no",
    "1095",
    "19286600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180703",
    "Arcozelos",
    "",
    "no",
    "674",
    "9500000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180705",
    "Baldos",
    "",
    "no",
    "201",
    "4441800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180706",
    "Cabaços",
    "",
    "no",
    "280",
    "11212200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180707",
    "Caria",
    "",
    "no",
    "507",
    "16710600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180708",
    "Castelo",
    "",
    "no",
    "245",
    "9277400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180709",
    "Leomil",
    "",
    "no",
    "1115",
    "36772400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180710",
    "Moimenta da Beira",
    "",
    "no",
    "2888",
    "9265700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180713",
    "Passô",
    "",
    "no",
    "343",
    "4352300",
    "3",
    "no",
    "no",
    "no"
  ],
  ["PT11D", "180716", "Rua", "", "no", "601", "9666900", "3", "no", "no", "no"],
  [
    "PT11D",
    "180717",
    "Sarzedo",
    "",
    "no",
    "162",
    "4992800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180719",
    "Sever",
    "",
    "no",
    "536",
    "10033800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180720",
    "Vilar",
    "",
    "no",
    "382",
    "8544300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180721",
    "União das freguesias de Paradinha e Nagosa",
    "",
    "no",
    "236",
    "12094200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180722",
    "União das freguesias de Pêra Velha, Aldeia de Nacomba e Ariz",
    "",
    "no",
    "428",
    "29174100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "180723",
    "União das freguesias de Peva e Segões",
    "",
    "no",
    "519",
    "24644000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180802",
    "Cercosa",
    "",
    "no",
    "303",
    "8715200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180804",
    "Espinho",
    "",
    "no",
    "1105",
    "41341000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180805",
    "Marmeleira",
    "",
    "no",
    "503",
    "18508000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180807",
    "Pala",
    "",
    "no",
    "1016",
    "48857400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180808",
    "Sobral",
    "",
    "no",
    "2311",
    "64154600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180809",
    "Trezói",
    "",
    "no",
    "377",
    "17505800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16E",
    "180811",
    "União das freguesias de Mortágua, Vale de Remígio, Cortegaça e Almaça",
    "",
    "no",
    "3992",
    "52096100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180901",
    "Canas de Senhorim",
    "",
    "no",
    "3509",
    "25452600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180903",
    "Nelas",
    "",
    "no",
    "4702",
    "21627500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180905",
    "Senhorim",
    "",
    "no",
    "1156",
    "31337200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180906",
    "Vilar Seco",
    "",
    "no",
    "745",
    "10150900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180908",
    "Lapa do Lobo",
    "",
    "no",
    "756",
    "7321500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180910",
    "União das freguesias de Carvalhal Redondo e Aguieira",
    "",
    "no",
    "1532",
    "13520600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "180911",
    "União das freguesias de Santar e Moreira",
    "",
    "no",
    "1637",
    "16304500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181002",
    "Arcozelo das Maias",
    "",
    "no",
    "1364",
    "21808100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181005",
    "Pinheiro",
    "",
    "no",
    "1277",
    "21618600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181007",
    "Ribeiradio",
    "",
    "no",
    "1011",
    "15671400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181008",
    "São João da Serra",
    "",
    "no",
    "524",
    "12406800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181009",
    "São Vicente de Lafões",
    "",
    "no",
    "756",
    "8199200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181013",
    "União das freguesias de Arca e Varzielas",
    "",
    "no",
    "718",
    "20369600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181014",
    "União das freguesias de Destriz e Reigoso",
    "",
    "no",
    "688",
    "22758000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181015",
    "União das freguesias de Oliveira de Frades, Souto de Lafões e Sejães",
    "",
    "no",
    "3923",
    "22514500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181102",
    "Castelo de Penalva",
    "",
    "no",
    "914",
    "27161700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181103",
    "Esmolfe",
    "",
    "no",
    "417",
    "10870600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181104",
    "Germil",
    "",
    "no",
    "427",
    "5459200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181105",
    "Ínsua",
    "",
    "no",
    "2045",
    "9437500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181106",
    "Lusinde",
    "",
    "no",
    "189",
    "2807000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181109",
    "Pindo",
    "",
    "no",
    "1916",
    "16764300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181110",
    "Real",
    "",
    "no",
    "263",
    "4690800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181111",
    "Sezures",
    "",
    "no",
    "726",
    "21042700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181112",
    "Trancozelos",
    "",
    "no",
    "269",
    "5124300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181114",
    "União das freguesias de Antas e Matela",
    "",
    "no",
    "473",
    "18268400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181115",
    "União das freguesias de Vila Cova do Covelo/Mareco",
    "",
    "no",
    "317",
    "12712500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181202",
    "Beselga",
    "",
    "no",
    "321",
    "14765700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181203",
    "Castainço",
    "",
    "no",
    "161",
    "13370200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181207",
    "Penela da Beira",
    "",
    "no",
    "353",
    "18384700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181208",
    "Póvoa de Penela",
    "",
    "no",
    "325",
    "9774800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181209",
    "Souto",
    "",
    "no",
    "317",
    "14584100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181210",
    "União das freguesias de Antas e Ourozinho",
    "",
    "no",
    "320",
    "30061300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181211",
    "União das freguesias de Penedono e Granja",
    "",
    "no",
    "1155",
    "32766700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181302",
    "Barrô",
    "",
    "no",
    "744",
    "10036500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181303",
    "Cárquere",
    "",
    "no",
    "854",
    "7504900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181310",
    "Paus",
    "",
    "no",
    "528",
    "13396800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181311",
    "Resende",
    "",
    "no",
    "3166",
    "11878300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181312",
    "São Cipriano",
    "",
    "no",
    "771",
    "6703800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181313",
    "São João de Fontoura",
    "",
    "no",
    "700",
    "5055700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181314",
    "São Martinho de Mouros",
    "",
    "no",
    "1495",
    "14408500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181316",
    "União das freguesias de Anreade e São Romão de Aregos",
    "",
    "no",
    "1471",
    "9831300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181317",
    "União das freguesias de Felgueiras e Feirão",
    "",
    "no",
    "436",
    "13282800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181318",
    "União das freguesias de Freigil e Miomães",
    "",
    "no",
    "790",
    "7429300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11C",
    "181319",
    "União das freguesias de Ovadas e Panchorra",
    "",
    "no",
    "409",
    "23821200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181403",
    "Pinheiro de Ázere",
    "",
    "no",
    "937",
    "11887800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181405",
    "São Joaninho",
    "",
    "no",
    "1075",
    "9723000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181406",
    "São João de Areias",
    "",
    "no",
    "1939",
    "21510000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181410",
    "União das freguesias de Ovoa e Vimieiro",
    "",
    "no",
    "1640",
    "22467100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181411",
    "União das freguesias de Santa Comba Dão e Couto do Mosteiro",
    "",
    "no",
    "4572",
    "26737500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181412",
    "União das freguesias de Treixedo e Nagozela",
    "",
    "no",
    "1434",
    "19622200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181501",
    "Castanheiro do Sul",
    "",
    "no",
    "439",
    "20395200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181502",
    "Ervedosa do Douro",
    "",
    "no",
    "1294",
    "40238300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181504",
    "Nagozelo do Douro",
    "",
    "no",
    "414",
    "7887000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181505",
    "Paredes da Beira",
    "",
    "no",
    "629",
    "20555600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181507",
    "Riodades",
    "",
    "no",
    "462",
    "20066300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181509",
    "Soutelo do Douro",
    "",
    "no",
    "459",
    "17799700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181511",
    "Vale de Figueira",
    "",
    "no",
    "462",
    "16466700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181512",
    "Valongo dos Azeites",
    "",
    "no",
    "227",
    "4556800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181515",
    "União das freguesias de São João da Pesqueira e Várzea de Trevões",
    "",
    "no",
    "2380",
    "53272900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181516",
    "União das freguesias de Trevões e Espinhosa",
    "",
    "no",
    "696",
    "30126300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181517",
    "União das freguesias de Vilarouco e Pereiros",
    "",
    "no",
    "412",
    "34743600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181602",
    "Bordonhos",
    "",
    "no",
    "547",
    "5950500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181606",
    "Figueiredo de Alva",
    "",
    "no",
    "816",
    "14685700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181607",
    "Manhouce",
    "",
    "no",
    "647",
    "40405700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181608",
    "Pindelo dos Milagres",
    "",
    "no",
    "659",
    "23897100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181609",
    "Pinho",
    "",
    "no",
    "777",
    "13637700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181612",
    "São Félix",
    "",
    "no",
    "390",
    "3193700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181615",
    "Serrazes",
    "",
    "no",
    "1001",
    "13232200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181616",
    "Sul",
    "",
    "no",
    "1090",
    "52411900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181617",
    "Valadares",
    "",
    "no",
    "805",
    "20760100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181619",
    "Vila Maior",
    "",
    "no",
    "962",
    "11874900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181620",
    "União das freguesias de Carvalhais e Candal",
    "",
    "no",
    "1554",
    "43731700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181621",
    "União das freguesias de Santa Cruz da Trapa e São Cristóvão de Lafões",
    "",
    "no",
    "1504",
    "28937700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181622",
    "União das freguesias de São Martinho das Moitas e Covas do Rio",
    "",
    "no",
    "371",
    "53681100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181623",
    "União das freguesias de São Pedro do Sul, Várzea e Baiões",
    "",
    "no",
    "5728",
    "22550900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181702",
    "Avelal",
    "",
    "no",
    "529",
    "8152400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181704",
    "Ferreira de Aves",
    "",
    "no",
    "2464",
    "66131600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181706",
    "Mioma",
    "",
    "no",
    "1217",
    "15340400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181707",
    "Rio de Moinhos",
    "",
    "no",
    "942",
    "11038800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181709",
    "São Miguel de Vila Boa",
    "",
    "no",
    "1334",
    "12889800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181710",
    "Sátão",
    "",
    "no",
    "4007",
    "18571600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181711",
    "Silvã de Cima",
    "",
    "no",
    "455",
    "6884400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181713",
    "União das freguesias de Águas Boas e Forles",
    "",
    "no",
    "237",
    "15859900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "181714",
    "União das freguesias de Romãs, Decermilo e Vila Longa",
    "",
    "no",
    "1259",
    "47072100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181801",
    "Arnas",
    "",
    "no",
    "220",
    "21253600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181802",
    "Carregal",
    "",
    "no",
    "393",
    "20767100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181803",
    "Chosendo",
    "",
    "no",
    "254",
    "11301300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181804",
    "Cunha",
    "",
    "no",
    "310",
    "17024500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181806",
    "Faia",
    "",
    "no",
    "207",
    "3625900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181810",
    "Granjal",
    "",
    "no",
    "272",
    "13728300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181811",
    "Lamosa",
    "",
    "no",
    "179",
    "13221000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181814",
    "Quintela",
    "",
    "no",
    "294",
    "13772400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181817",
    "Vila da Ponte",
    "",
    "no",
    "470",
    "12767300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181818",
    "União das freguesias de Ferreirim e Macieira",
    "",
    "no",
    "581",
    "22368900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181819",
    "União das freguesias de Fonte Arcada e Escurquela",
    "",
    "no",
    "408",
    "19869600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181820",
    "União das freguesias de Penso e Freixinho",
    "",
    "no",
    "370",
    "14135000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181821",
    "União das freguesias de Sernancelhe e Sarzeda",
    "",
    "no",
    "1713",
    "44777400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181901",
    "Adorigo",
    "",
    "no",
    "397",
    "9225300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181902",
    "Arcos",
    "",
    "no",
    "233",
    "7943500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181904",
    "Chavães",
    "",
    "no",
    "385",
    "9447300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181905",
    "Desejosa",
    "",
    "no",
    "175",
    "7488400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181906",
    "Granja do Tedo",
    "",
    "no",
    "214",
    "3771500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181908",
    "Longa",
    "",
    "no",
    "370",
    "6828500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181913",
    "Sendim",
    "",
    "no",
    "705",
    "21263400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181914",
    "Tabuaço",
    "",
    "no",
    "1782",
    "10744800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181917",
    "Valença do Douro",
    "",
    "no",
    "363",
    "9282400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181918",
    "União das freguesias de Barcos e Santa Leocádia",
    "",
    "no",
    "710",
    "15208800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181919",
    "União das freguesias de Paradela e Granjinha",
    "",
    "no",
    "180",
    "9051500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181920",
    "União das freguesias de Pinheiros e Vale de Figueira",
    "",
    "no",
    "324",
    "11662100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "181921",
    "União das freguesias de Távora e Pereiro",
    "",
    "no",
    "512",
    "11939300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182004",
    "Mondim da Beira",
    "",
    "no",
    "786",
    "7079900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182005",
    "Salzedas",
    "",
    "no",
    "767",
    "8835700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182006",
    "São João de Tarouca",
    "",
    "no",
    "606",
    "18585000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182009",
    "Várzea da Serra",
    "",
    "no",
    "261",
    "21190100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182011",
    "União das freguesias de Gouviães e Ucanha",
    "",
    "no",
    "817",
    "8940800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182012",
    "União das freguesias de Granja Nova e Vila Chã da Beira",
    "",
    "no",
    "566",
    "13536800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT11D",
    "182013",
    "União das freguesias de Tarouca e Dálvares",
    "",
    "no",
    "4245",
    "21916600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182102",
    "Campo de Besteiros",
    "",
    "no",
    "1474",
    "7925300",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182103",
    "Canas de Santa Maria",
    "",
    "no",
    "1806",
    "13846100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182105",
    "Castelões",
    "",
    "no",
    "1542",
    "17118500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182106",
    "Dardavaz",
    "",
    "no",
    "782",
    "13694500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182107",
    "Ferreirós do Dão",
    "",
    "no",
    "441",
    "8286400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182108",
    "Guardão",
    "",
    "no",
    "1490",
    "18951500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182109",
    "Lajeosa do Dão",
    "",
    "no",
    "1940",
    "24590800",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182110",
    "Lobão da Beira",
    "",
    "no",
    "1124",
    "14090700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182111",
    "Molelos",
    "",
    "no",
    "2346",
    "15496100",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182116",
    "Parada de Gonta",
    "",
    "no",
    "754",
    "6727900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182118",
    "Santiago de Besteiros",
    "",
    "no",
    "1331",
    "15754600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182122",
    "Tonda",
    "",
    "no",
    "984",
    "7503600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182127",
    "União das freguesias de Barreiro de Besteiros e Tourigo",
    "",
    "no",
    "1487",
    "45725500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182128",
    "União das freguesias de Caparrosa e Silvares",
    "",
    "no",
    "941",
    "24573600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182129",
    "União das freguesias de Mouraz e Vila Nova da Rainha",
    "",
    "no",
    "1354",
    "15526200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182130",
    "União das freguesias de São João do Monte e Mosteirinho",
    "",
    "no",
    "1079",
    "65134600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182131",
    "União das freguesias de São Miguel do Outeiro e Sabugosa",
    "",
    "no",
    "1458",
    "18538200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182132",
    "União das freguesias de Tondela e Nandufe",
    "",
    "no",
    "5130",
    "15753400",
    "2",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182133",
    "União das freguesias de Vilar de Besteiros e Mosteiro de Fráguas",
    "",
    "no",
    "1483",
    "21979500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182203",
    "Pendilhe",
    "",
    "no",
    "546",
    "24189700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182204",
    "Queiriga",
    "",
    "no",
    "575",
    "31937400",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182205",
    "Touro",
    "",
    "no",
    "918",
    "50166600",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182206",
    "Vila Cova à Coelheira",
    "",
    "no",
    "1109",
    "32030000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182208",
    "União das freguesias de Vila Nova de Paiva, Alhais e Fráguas",
    "",
    "no",
    "2028",
    "37209200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182301",
    "Abraveses",
    "",
    "no",
    "8539",
    "12227200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182304",
    "Bodiosa",
    "",
    "no",
    "3047",
    "25395000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182305",
    "Calde",
    "",
    "no",
    "1469",
    "35056800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182306",
    "Campo",
    "",
    "no",
    "5025",
    "16240400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182307",
    "Cavernães",
    "",
    "no",
    "1348",
    "13143900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182310",
    "Cota",
    "",
    "no",
    "974",
    "41547500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182315",
    "Fragosela",
    "",
    "no",
    "2662",
    "11038300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182316",
    "Lordosa",
    "",
    "no",
    "1791",
    "22310300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182317",
    "Silgueiros",
    "",
    "no",
    "3250",
    "36173300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182318",
    "Mundão",
    "",
    "no",
    "2385",
    "14446000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182319",
    "Orgens",
    "",
    "no",
    "3489",
    "8901600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182320",
    "Povolide",
    "",
    "no",
    "1747",
    "20800500",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182321",
    "Ranhados",
    "",
    "no",
    "4949",
    "6234000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182322",
    "Ribafeita",
    "",
    "no",
    "1227",
    "18117200",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182323",
    "Rio de Loba",
    "",
    "no",
    "9348",
    "17750600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182325",
    "Santos Evos",
    "",
    "no",
    "1569",
    "11857000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182327",
    "São João de Lourosa",
    "",
    "no",
    "4702",
    "26004100",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182329",
    "São Pedro de France",
    "",
    "no",
    "1370",
    "18751800",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182335",
    "União das freguesias de Barreiros e Cepões",
    "",
    "no",
    "1584",
    "35188000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182336",
    "União das freguesias de Boa Aldeia, Farminhão e Torredeita",
    "",
    "no",
    "2823",
    "35133700",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182337",
    "União das freguesias de Couto de Baixo e Couto de Cima",
    "",
    "no",
    "1607",
    "24408400",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182338",
    "União das freguesias de Faíl e Vila Chã de Sá",
    "",
    "no",
    "2673",
    "15697600",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182339",
    "União das freguesias de Repeses e São Salvador",
    "",
    "no",
    "6316",
    "10007000",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182340",
    "União das freguesias de São Cipriano e Vil de Souto",
    "",
    "no",
    "1950",
    "20711300",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182341",
    "União das freguesias de Viseu",
    "",
    "no",
    "23430",
    "9959900",
    "1",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182401",
    "Alcofra",
    "",
    "no",
    "1025",
    "28962700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182403",
    "Campia",
    "",
    "no",
    "1542",
    "39267200",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182407",
    "Fornelo do Monte",
    "",
    "no",
    "288",
    "15081000",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182409",
    "Queirã",
    "",
    "no",
    "1432",
    "23834700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182410",
    "São Miguel do Mato",
    "",
    "no",
    "924",
    "9002900",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182411",
    "Ventosa",
    "",
    "no",
    "794",
    "18330500",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182413",
    "União das freguesias de Cambra e Carvalhal de Vermilhas",
    "",
    "no",
    "1459",
    "32612100",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182414",
    "União das freguesias de Fataunços e Figueiredo das Donas",
    "",
    "no",
    "1103",
    "12659700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT16G",
    "182415",
    "União das freguesias de Vouzela e Paços de Vilharigues",
    "",
    "no",
    "1997",
    "13943700",
    "3",
    "no",
    "no",
    "no"
  ],
  [
    "PT300",
    "310101",
    "Arco da Calheta",
    "",
    "no",
    "3168",
    "14703100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310102",
    "Calheta",
    "",
    "no",
    "3163",
    "23439000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310103",
    "Estreito da Calheta",
    "",
    "no",
    "1607",
    "14321700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310104",
    "Fajã da Ovelha",
    "",
    "no",
    "895",
    "22163100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310105",
    "Jardim do Mar",
    "",
    "no",
    "204",
    "739500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310106",
    "Paul do Mar",
    "",
    "no",
    "871",
    "1400600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310107",
    "Ponta do Pargo",
    "",
    "no",
    "909",
    "24711900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310108",
    "Prazeres",
    "",
    "no",
    "704",
    "10025500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310201",
    "Câmara de Lobos",
    "",
    "no",
    "17986",
    "7766800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310202",
    "Curral das Freiras",
    "",
    "no",
    "2005",
    "25017100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310203",
    "Estreito de Câmara de Lobos",
    "",
    "no",
    "10265",
    "7872100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310204",
    "Quinta Grande",
    "",
    "no",
    "2099",
    "4148200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310205",
    "Jardim da Serra",
    "",
    "no",
    "3311",
    "7362600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310301",
    "Imaculado Coração de Maria",
    "",
    "no",
    "6207",
    "1359200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310302",
    "Monte",
    "",
    "no",
    "6701",
    "18583900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310303",
    "Funchal (Santa Luzia)",
    "",
    "no",
    "5866",
    "1337400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310304",
    "Funchal (Santa Maria Maior)",
    "",
    "no",
    "13352",
    "4872500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310305",
    "Santo António",
    "",
    "no",
    "27383",
    "22159400",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310306",
    "São Gonçalo",
    "",
    "no",
    "6587",
    "7081900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310307",
    "São Martinho",
    "",
    "no",
    "26482",
    "7983100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310308",
    "Funchal (São Pedro)",
    "",
    "no",
    "7273",
    "1488900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310309",
    "São Roque",
    "",
    "no",
    "9385",
    "7499100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310310",
    "Funchal (Sé)",
    "",
    "no",
    "2656",
    "3796800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310401",
    "Água de Pena",
    "",
    "no",
    "2434",
    "5147900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310402",
    "Caniçal",
    "",
    "no",
    "3924",
    "11831000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310403",
    "Machico",
    "",
    "no",
    "11256",
    "17458500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310404",
    "Porto da Cruz",
    "",
    "no",
    "2597",
    "25193700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310405",
    "Santo António da Serra",
    "",
    "no",
    "1617",
    "8619800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310501",
    "Canhas",
    "",
    "no",
    "3769",
    "16672000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310502",
    "Madalena do Mar",
    "",
    "no",
    "516",
    "2073900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310503",
    "Ponta do Sol",
    "",
    "no",
    "4577",
    "27474400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310601",
    "Achadas da Cruz",
    "",
    "no",
    "159",
    "7883400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310602",
    "Porto Moniz",
    "",
    "no",
    "1668",
    "20204100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310603",
    "Ribeira da Janela",
    "",
    "no",
    "228",
    "18456400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310604",
    "Seixal",
    "",
    "no",
    "656",
    "36389900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310701",
    "Campanário",
    "",
    "no",
    "4579",
    "11760400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310702",
    "Ribeira Brava",
    "",
    "no",
    "6591",
    "18472300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310703",
    "Serra de Água",
    "",
    "no",
    "1049",
    "24095500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310704",
    "Tábua",
    "",
    "no",
    "1156",
    "11120700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310802",
    "Camacha",
    "",
    "no",
    "7445",
    "19753500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310803",
    "Caniço",
    "",
    "no",
    "23372",
    "12008200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310804",
    "Gaula",
    "",
    "no",
    "4038",
    "6942200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310805",
    "Santa Cruz",
    "",
    "no",
    "7214",
    "28047700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310806",
    "Santo António da Serra",
    "",
    "no",
    "936",
    "14751300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310901",
    "Arco de São Jorge",
    "",
    "no",
    "413",
    "3367400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310902",
    "Faial",
    "",
    "no",
    "1567",
    "24008100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310903",
    "Santana",
    "",
    "no",
    "3275",
    "18996100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310904",
    "São Jorge",
    "",
    "no",
    "1473",
    "19316400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310905",
    "São Roque do Faial",
    "",
    "no",
    "736",
    "15605300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "310906",
    "Ilha",
    "",
    "no",
    "255",
    "14179800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "311001",
    "Boa Ventura",
    "",
    "no",
    "1221",
    "25314700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "311002",
    "Ponta Delgada",
    "",
    "no",
    "1363",
    "9390800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "311003",
    "São Vicente",
    "",
    "no",
    "3139",
    "44131500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT300",
    "320101",
    "Porto Santo",
    "",
    "no",
    "5483",
    "43007000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "410101",
    "Almagreira",
    "",
    "no",
    "599",
    "11219800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "410102",
    "Santa Bárbara",
    "",
    "no",
    "405",
    "15271700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "410103",
    "Santo Espírito",
    "",
    "no",
    "588",
    "26676600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "410104",
    "São Pedro",
    "",
    "no",
    "841",
    "18170700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "410105",
    "Vila do Porto",
    "",
    "no",
    "3119",
    "25548700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420101",
    "Água de Pau",
    "",
    "no",
    "3058",
    "17455300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420102",
    "Cabouco",
    "",
    "no",
    "1921",
    "4846800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420103",
    "Lagoa (Nossa Senhora do Rosário)",
    "",
    "no",
    "5396",
    "6521200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420104",
    "Lagoa (Santa Cruz)",
    "",
    "no",
    "3671",
    "14272700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420105",
    "Ribeira Chã",
    "",
    "no",
    "396",
    "2497300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420201",
    "Achada",
    "",
    "no",
    "436",
    "11886400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420202",
    "Achadinha",
    "",
    "no",
    "535",
    "12412700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420203",
    "Lomba da Fazenda",
    "",
    "no",
    "844",
    "14770300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420204",
    "Nordeste",
    "",
    "no",
    "1341",
    "23134100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420206",
    "Salga",
    "",
    "no",
    "488",
    "7709900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420207",
    "Santana",
    "",
    "no",
    "475",
    "6119800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420208",
    "Algarvia",
    "",
    "no",
    "290",
    "5403800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420209",
    "Santo António de Nordestinho",
    "",
    "no",
    "267",
    "9376300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420210",
    "São Pedro de Nordestinho",
    "",
    "no",
    "261",
    "10654600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420301",
    "Arrifes",
    "",
    "no",
    "7086",
    "25365200",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420303",
    "Candelária",
    "",
    "no",
    "1079",
    "8633700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420304",
    "Capelas",
    "",
    "no",
    "4080",
    "16854800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420305",
    "Covoada",
    "",
    "no",
    "1341",
    "9033500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420306",
    "Fajã de Baixo",
    "",
    "no",
    "5050",
    "4062900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420307",
    "Fajã de Cima",
    "",
    "no",
    "3438",
    "11893100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420308",
    "Fenais da Luz",
    "",
    "no",
    "2009",
    "7685800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420309",
    "Feteiras",
    "",
    "no",
    "1571",
    "23529300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420310",
    "Ginetes",
    "",
    "no",
    "1378",
    "12137800",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420311",
    "Mosteiros",
    "",
    "no",
    "1123",
    "8952100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420312",
    "Ponta Delgada (São Sebastião)",
    "",
    "no",
    "3953",
    "3335500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420313",
    "Ponta Delgada (São José)",
    "",
    "no",
    "5934",
    "1658100",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420314",
    "Ponta Delgada (São Pedro)",
    "",
    "no",
    "7742",
    "2894900",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420315",
    "Relva",
    "",
    "no",
    "3006",
    "12065600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420316",
    "Remédios",
    "",
    "no",
    "931",
    "5594600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420317",
    "Rosto do Cão (Livramento)",
    "",
    "no",
    "4062",
    "5588300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420318",
    "Rosto do Cão (São Roque)",
    "",
    "no",
    "4932",
    "7211000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420319",
    "Santa Bárbara",
    "",
    "no",
    "855",
    "8719600",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420320",
    "Santo António",
    "",
    "no",
    "1829",
    "11746000",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420321",
    "São Vicente Ferreira",
    "",
    "no",
    "2361",
    "11423300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420322",
    "Sete Cidades",
    "",
    "no",
    "793",
    "19194700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420323",
    "Ajuda da Bretanha",
    "",
    "no",
    "661",
    "7092500",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420324",
    "Pilar da Bretanha",
    "",
    "no",
    "624",
    "6072300",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420325",
    "Santa Clara",
    "",
    "no",
    "2971",
    "2241700",
    "1",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420401",
    "Água Retorta",
    "",
    "no",
    "489",
    "12551600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420402",
    "Faial da Terra",
    "",
    "no",
    "359",
    "11383300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420403",
    "Furnas",
    "",
    "no",
    "1439",
    "34429100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420404",
    "Nossa Senhora dos Remédios",
    "",
    "no",
    "1112",
    "12775400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420405",
    "Povoação",
    "",
    "no",
    "2161",
    "26230700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420406",
    "Ribeira Quente",
    "",
    "no",
    "767",
    "9037500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420501",
    "Calhetas",
    "",
    "no",
    "988",
    "4697900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420502",
    "Fenais da Ajuda",
    "",
    "no",
    "1131",
    "13361200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420503",
    "Lomba da Maia",
    "",
    "no",
    "1152",
    "20468500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420504",
    "Lomba de São Pedro",
    "",
    "no",
    "284",
    "8250900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420505",
    "Maia",
    "",
    "no",
    "1900",
    "21974700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420506",
    "Pico da Pedra",
    "",
    "no",
    "2909",
    "6575300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420507",
    "Porto Formoso",
    "",
    "no",
    "1265",
    "12794900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420508",
    "Rabo de Peixe",
    "",
    "no",
    "8866",
    "16960500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420509",
    "Ribeira Grande (Conceição)",
    "",
    "no",
    "2425",
    "12729900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420510",
    "Ribeira Grande (Matriz)",
    "",
    "no",
    "3968",
    "10843900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420511",
    "Ribeira Seca",
    "",
    "no",
    "2950",
    "12592700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420512",
    "Ribeirinha",
    "",
    "no",
    "2349",
    "17982400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420513",
    "Santa Bárbara",
    "",
    "no",
    "1275",
    "12835700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420514",
    "São Brás",
    "",
    "no",
    "650",
    "8082900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420601",
    "Água de Alto",
    "",
    "no",
    "1788",
    "18414000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420602",
    "Ponta Garça",
    "",
    "no",
    "3547",
    "29354300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420603",
    "Ribeira das Tainhas",
    "",
    "no",
    "703",
    "9591900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420604",
    "Vila Franca do Campo (São Miguel)",
    "",
    "no",
    "2659",
    "12596800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420605",
    "Vila Franca do Campo (São Pedro)",
    "",
    "no",
    "1426",
    "2484900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "420606",
    "Ribeira Seca",
    "",
    "no",
    "1106",
    "5526300",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430101",
    "Altares",
    "",
    "no",
    "901",
    "28220200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430102",
    "Angra (Nossa Senhora da Conceição)",
    "",
    "no",
    "3717",
    "2440700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430103",
    "Angra (Santa Luzia)",
    "",
    "no",
    "2755",
    "1259700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430104",
    "Angra (São Pedro)",
    "",
    "no",
    "3460",
    "3656900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430105",
    "Angra (Sé)",
    "",
    "no",
    "955",
    "1650100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430106",
    "Cinco Ribeiras",
    "",
    "no",
    "704",
    "10797800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430107",
    "Doze Ribeiras",
    "",
    "no",
    "513",
    "10412100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430108",
    "Feteira",
    "",
    "no",
    "1239",
    "5248100",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430109",
    "Porto Judeu",
    "",
    "no",
    "2501",
    "30266200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430110",
    "Posto Santo",
    "",
    "no",
    "1048",
    "20373600",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430111",
    "Raminho",
    "",
    "no",
    "565",
    "11066100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430112",
    "Ribeirinha",
    "",
    "no",
    "2684",
    "7529400",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430113",
    "Santa Bárbara",
    "",
    "no",
    "1274",
    "16399500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430114",
    "São Bartolomeu de Regatos",
    "",
    "no",
    "1983",
    "24995500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430115",
    "São Bento",
    "",
    "no",
    "2000",
    "10339000",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430116",
    "São Mateus da Calheta",
    "",
    "no",
    "3757",
    "5980700",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430117",
    "Serreta",
    "",
    "no",
    "335",
    "14356100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430118",
    "Terra Chã",
    "",
    "no",
    "2915",
    "10070800",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430119",
    "Vila de São Sebastião",
    "",
    "no",
    "2096",
    "23934100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430201",
    "Agualva",
    "",
    "no",
    "1432",
    "38754300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430202",
    "Biscoitos",
    "",
    "no",
    "1424",
    "27053700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430203",
    "Cabo da Praia",
    "",
    "no",
    "712",
    "3182100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430204",
    "Fonte do Bastardo",
    "",
    "no",
    "1278",
    "8854300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430205",
    "Fontinhas",
    "",
    "no",
    "1594",
    "12144200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430206",
    "Lajes",
    "",
    "no",
    "3744",
    "12113700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430207",
    "Praia da Vitória (Santa Cruz)",
    "",
    "no",
    "6690",
    "30089200",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430208",
    "Quatro Ribeiras",
    "",
    "no",
    "394",
    "12832300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430209",
    "São Brás",
    "",
    "no",
    "1088",
    "4678000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430210",
    "Vila Nova",
    "",
    "no",
    "1678",
    "8136700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "430211",
    "Porto Martins",
    "",
    "no",
    "1001",
    "3432100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "440101",
    "Guadalupe",
    "",
    "no",
    "1096",
    "20615100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "440102",
    "Luz",
    "",
    "no",
    "683",
    "11702800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "440103",
    "São Mateus",
    "",
    "no",
    "836",
    "12823500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "440104",
    "Santa Cruz da Graciosa",
    "",
    "no",
    "1776",
    "15516400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450101",
    "Calheta",
    "",
    "no",
    "1275",
    "18811400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450102",
    "Norte Pequeno",
    "",
    "no",
    "220",
    "12105900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450103",
    "Ribeira Seca",
    "",
    "no",
    "1025",
    "53769000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450104",
    "Santo Antão",
    "",
    "no",
    "745",
    "32340600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450105",
    "Topo (Nossa Senhora do Rosário)",
    "",
    "no",
    "508",
    "9237000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450201",
    "Manadas (Santa Bárbara)",
    "",
    "no",
    "374",
    "11202300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450202",
    "Norte Grande (Neves)",
    "",
    "no",
    "532",
    "31849200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450203",
    "Rosais",
    "",
    "no",
    "743",
    "24226200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450204",
    "Santo Amaro",
    "",
    "no",
    "862",
    "22526400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450205",
    "Urzelina (São Mateus)",
    "",
    "no",
    "902",
    "13688400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "450206",
    "Velas (São Jorge)",
    "",
    "no",
    "1985",
    "13891200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460101",
    "Calheta de Nesquim",
    "",
    "no",
    "343",
    "13809800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460102",
    "Lajes do Pico",
    "",
    "no",
    "1802",
    "53091000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460103",
    "Piedade",
    "",
    "no",
    "844",
    "12813900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460104",
    "Ribeiras",
    "",
    "no",
    "925",
    "34167000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460105",
    "Ribeirinha",
    "",
    "no",
    "374",
    "8493100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460106",
    "São João",
    "",
    "no",
    "423",
    "32936000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460201",
    "Bandeiras",
    "",
    "no",
    "626",
    "22210200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460202",
    "Candelária",
    "",
    "no",
    "822",
    "29704600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460203",
    "Criação Velha",
    "",
    "no",
    "768",
    "18361300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460204",
    "Madalena",
    "",
    "no",
    "2581",
    "35590500",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460205",
    "São Caetano",
    "",
    "no",
    "480",
    "23883800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460206",
    "São Mateus",
    "",
    "no",
    "772",
    "17373000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460301",
    "Prainha",
    "",
    "no",
    "547",
    "26104400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460302",
    "Santa Luzia",
    "",
    "no",
    "422",
    "30125100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460303",
    "Santo Amaro",
    "",
    "no",
    "288",
    "11864600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460304",
    "Santo António",
    "",
    "no",
    "815",
    "32035000",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "460305",
    "São Roque do Pico",
    "",
    "no",
    "1316",
    "42231900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470101",
    "Capelo",
    "",
    "no",
    "486",
    "26642400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470102",
    "Castelo Branco",
    "",
    "no",
    "1309",
    "23914700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470103",
    "Cedros",
    "",
    "no",
    "907",
    "24537900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470104",
    "Feteira",
    "",
    "no",
    "1899",
    "14456300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470105",
    "Flamengos",
    "",
    "no",
    "1604",
    "14620900",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470106",
    "Horta (Angústias)",
    "",
    "no",
    "2418",
    "3788500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470107",
    "Horta (Conceição)",
    "",
    "no",
    "1138",
    "3084500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470108",
    "Horta (Matriz)",
    "",
    "no",
    "2562",
    "1808500",
    "2",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470109",
    "Pedro Miguel",
    "",
    "no",
    "759",
    "14479300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470110",
    "Praia do Almoxarife",
    "",
    "no",
    "834",
    "9203600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470111",
    "Praia do Norte",
    "",
    "no",
    "250",
    "13853900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470112",
    "Ribeirinha",
    "",
    "no",
    "427",
    "12260100",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "470113",
    "Salão",
    "",
    "no",
    "401",
    "10404700",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480101",
    "Fajã Grande",
    "",
    "no",
    "202",
    "12968400",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480102",
    "Fajãzinha",
    "",
    "no",
    "76",
    "6155600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480103",
    "Fazenda",
    "",
    "no",
    "257",
    "9473600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480104",
    "Lajedo",
    "",
    "no",
    "93",
    "6790800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480105",
    "Lajes das Flores",
    "",
    "no",
    "627",
    "18791300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480106",
    "Lomba",
    "",
    "no",
    "206",
    "9874300",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480107",
    "Mosteiro",
    "",
    "no",
    "43",
    "5993900",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480201",
    "Caveira",
    "",
    "no",
    "77",
    "3284800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480202",
    "Cedros",
    "",
    "no",
    "128",
    "10298200",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480203",
    "Ponta Delgada",
    "",
    "no",
    "359",
    "17651800",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "480204",
    "Santa Cruz das Flores",
    "",
    "no",
    "1725",
    "39679600",
    "3",
    "no",
    "yes",
    "no"
  ],
  [
    "PT200",
    "490101",
    "Corvo",
    "",
    "no",
    "430",
    "17114500",
    "3",
    "no",
    "yes",
    "no"
  ]
];
